import { ModalystStaffPick } from '../types/products';

export const DUMMY_STAFF_PICKS: ModalystStaffPick[] = [
  {
    "id": "000cf07f-f9f8-4f05-a83a-b828e958a5ff",
    "name": "Makeup Brush Set Soft Fluffy Professiona Cosmetic Foundation Powder Eyeshadow Kabuki Blending Make Up Brush Beauty Tool Makeup",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/89/f5/89f557a76e9a27a1abe03eea04f2e3c8.jpg",
    "cost_min": "2.11",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "6ce8dd08-b29b-440b-9056-da02a2ad2dca",
    "name": "19 Colors Matte Velvet Lip Gloss Waterproof Liquid Lipstick Nude Black Lips Tint Makeup Lip Glaze Cosmetics Red Lip Stain Beauty",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b1/c1/b1c18d1cd81994657de007362078ae83.jpg",
    "cost_min": "1.73",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "19d04d81-5f1c-4304-91d7-92d2e7b5668d",
    "name": "Titanium Steel Temperature Couple Ring Mood Emotion Feeling Intelligent Sensitive Rings for Women Men Waterproof Jewelry Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7f/ef/7fefd1377a889846c3af33cff572849b.jpg",
    "cost_min": "1.57",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "03e35462-f6f3-4424-9774-ec87b38efe1f",
    "name": "Pablo Picasso Dove of Peace 1949 Artwork T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/74/59/745922ff63a538cf96cbbc33afae1897.png",
    "cost_min": "13.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "fc13d8bc-d758-4609-b200-b73a7bbe251d",
    "name": "Coconut Slippers Cloud Thick-Soled Sandals Summer Fashion Soft Bottom Beach Men Slippers Women's Sandals  EVA Slides",
    "staff_picks": [
      "category_pick",
      "bestseller"
    ],
    "image": "https://media.modalyst.co/cache/81/36/8136a2a53d502d2c1eaa74f44f87ff1e.jpg",
    "cost_min": "4.31",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "c5a6be18-2f69-4d6a-a461-94ec049ec561",
    "name": "6/12pcs 3D Hexagon Mirror Wall Sticker Rose Gold DIY TV Background Living Room Stickers Wall Decor Bedroom Bathroom Home Decor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/a9/36a9dc6fcf1205a339646887721278c6.jpg",
    "cost_min": "1.62",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "3aac8bfa-3753-41a2-9e3c-7bfd20514360",
    "name": "MOIRA Complete Wear Foundation",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f6/36/f63608625c8d6b1c8be4cdbf1cbba48f.jpg",
    "cost_min": "13.20",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "983b9144-b9ed-4d4f-b7af-8cb02fc9e64d",
    "name": "Teeth Grinding Catnip Toys Funny Interactive Plush Cat Toy Pet Kitten Chewing Vocal Toy Claws Thumb Bite Cat Mint for Cats",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c2/4f/c24f2ae645ccbaaa42698c3dc21c8973.jpg",
    "cost_min": "1.09",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "0a9a5598-ea0e-40d2-bab5-cc15d2b1186b",
    "name": "Cat Dog Toys for Aggressive Chewers Cats Dogs,Chew Squeak Toy Cats Dogs Interactive Plush Doll Pet Products",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b7/b3/b7b3e11d67510c561941d87971572a5e.jpg",
    "cost_min": "2.97",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "19f649e0-febc-450c-81a9-e425a39b1331",
    "name": "Hairdressing Wooden Handle Boar Bristle Cleaning Brush Soft Beard Cleaning Brush Men Barber Beard Shaving Styling Tools",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/86/f4/86f40d20e9320ff719b14b6debb6e6a2.jpg",
    "cost_min": "2.82",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "b97bdd73-7b2d-4470-8e77-f97c2ecb59d9",
    "name": "Extra-Strength Deodorant (2-Pack) Full Size",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6b/b6/6bb644783bab227de24831a4083663ee.png",
    "cost_min": "13.49",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "3d9743e5-ae59-4af2-9c1c-d640003fce99",
    "name": "Evshine Soft Sole Slippers for Women Winter Fashion Women Fur Slippers Fuzzy Plush Men Slippers Warm Furry Women Cotton Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/43/12/4312f0856e6d5738f4f9369a3694486b.jpg",
    "cost_min": "7.08",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "e7f59821-341d-416e-9cb9-0ef9c5882020",
    "name": "Cheek Flush (Talc-Free)",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7e/a7/7ea737f372a54f8fa91509e1f14b9c54.jpg",
    "cost_min": "7.16",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "58e0a5b7-71f2-4908-9e4e-cc5bcd964396",
    "name": "Oatmeal & Goat Milk Handmade Soap",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/97/ab/97abcd23bace639130284051036df8d0.png",
    "cost_min": "2.70",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "986eaa89-f78a-4253-bffb-534e033ec37b",
    "name": "Revitaleyes® Patches",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e4/1a/e41af05b5c4c94533478431038c06424.jpg",
    "cost_min": "37.14",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "095e10ae-656d-4f0d-be1f-efd0de239835",
    "name": "Retro Sunglasses Men Women Fashion Sports Driver's Vintage Sun Glasses for Man Female Brand Design Shades Oculos De Sol UV400",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/41/da/41dafcaac86e0bb47c3062f953c8ac39.jpg",
    "cost_min": "2.72",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "c619d2ff-f6ce-4a46-8a99-9198baed16cd",
    "name": "Bornladies Summer 100% Cotton Women's T-Shirt Bottoming Basic Fashionable Solid Lady Short Sleeve Loose Tops Shirts 230g/㎡ Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/70/fa/70fa73ee5bc0822d902d206771dfe04b.jpg",
    "cost_min": "9.68",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f20c9c64-d8d2-4b66-a644-2f21061b9947",
    "name": "Blushing Rosé Gemstone Diffuser",
    "staff_picks": [
      "bestseller",
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/82/a7/82a7b6c1d47141739e547778c30d10c8.jpg",
    "cost_min": "39.60",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "58c6af94-23a3-4435-889c-cbfc6f05a25b",
    "name": "Lip Luster Lip Gloss",
    "staff_picks": [
      "category_pick",
      "bestseller"
    ],
    "image": "https://media.modalyst.co/cache/1f/9f/1f9fdf2e26767460ac04138e2537546e.jpg",
    "cost_min": "4.20",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "f817ce9e-bb2d-4b42-a1cd-646bfb7ed744",
    "name": "200/400pcs Black Star Acne Patch Fashion Ultrathin Breathable Acne Covering Hydrocolloid Patch Beauty  Face Acne Patch",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fd/9c/fd9c4cfc123035e3e76077b7ff62bb6d.jpg",
    "cost_min": "2.02",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "55c6526d-8fc4-4125-a816-7caac222d398",
    "name": "#303 Botanical Facial Steam",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c0/d7/c0d71322bf305de30985a36098329d5d.jpg",
    "cost_min": "16.32",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "629f3aa5-3233-48a6-8bae-52caf17d0eb0",
    "name": "KZ EDX PRO X IEM Earphones Dynamic Drive HiFi Deep Bass Sound Earbud Sport Music Noise Cancelling Headset With Detachable Cable",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/25/ea/25eab938f6b58b41ff334e177aae8cc9.jpg",
    "cost_min": "6.95",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "61122b8b-a0af-4a5b-aeb1-854effc54f7d",
    "name": "Amity Island Surf Shop, Jaws T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/76/cb/76cb0f1f7fdaaaa8a68d9b7c8d982bd0.png",
    "cost_min": "13.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "882e36f7-fba7-40ee-8d84-ee77dea101b4",
    "name": "Mineral (Baking Soda-Free) Deodorant",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ce/c5/cec5c4585a25700aa1548839c6b08e61.png",
    "cost_min": "5.99",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "a2d66e04-7c9d-4199-be51-1f4a56cbfb2d",
    "name": "Hot Winter Gloves for Men Women Touchscreen Warm Outdoor Cycling Driving Motorcycle Cold Gloves Windproof Non-Slip Womens Gloves",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2d/19/2d1979679a3a761df620d51f5c674abb.jpg",
    "cost_min": "4.73",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "9950588e-2c3a-4c92-89f4-76b7c7cc964d",
    "name": "Dish Soap Cube",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4e/83/4e8375816f8fad9e75f7108a70022df7.jpg",
    "cost_min": "8.39",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "d8d09981-35c5-452e-a028-b21a04d3314e",
    "name": "Strong Dog Leash Pet Leashes Reflective Leash for Big Small Medium Dog Leash Drag Pull Tow Golden Retriever",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8a/6c/8a6c90f941f92f871a5869e3e3f790c5.jpg",
    "cost_min": "2.39",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "4ceee95b-809c-4d3d-8e68-0405f1c544fd",
    "name": "Water-Resistant Cap With Reflective \"N\"",
    "staff_picks": [
      "bestseller",
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e0/3b/e03b44de4645d1d30ca45c3901d1ce2a.jpg",
    "cost_min": "13.02",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "9827b97f-b139-44bb-b054-71c38bbd656a",
    "name": "New Casual Orthopedics Wide Feet Swollen Shoes Thumb Eversion Adjusting Soft Comfortable Diabetic Shoe Walking Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/ef/4aef982aad70193df2d93d37dbf16624.jpg",
    "cost_min": "13.02",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "47c563f1-1649-43e4-8209-388a4e878f4b",
    "name": "Turmeric & Honey Handmade Soap",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ab/d5/abd5707f9c875229b3dd2a2028347b1e.png",
    "cost_min": "2.70",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "114bef22-b3cf-4ed4-8311-c87f18293470",
    "name": "Elegant Solid Basic Knitted Tops Women Turtlneck Sweater Long Sleeve Casual Slim Pullover Korean Fashion Simple Chic Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/70/37/70377d0b3ec88a71d1ee94a2adf9dfbf.jpg",
    "cost_min": "6.81",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "580cf76c-d73f-4cc9-a9d8-b87c6852acae",
    "name": "NCLAGEN Impact Leggings Women Seamless Sports Yoga Pants Low Ribbed Band Gym Clothes Fitness Workout Wear Scrunch Bum Tights",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e9/ba/e9ba9acf5206c1ca00e836b9a76571d7.jpg",
    "cost_min": "11.96",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "368fc17e-4f52-4a47-ba30-0b56594f01fa",
    "name": "Running Shorts Summer Gym Sportswear Men Jogging Outdoor Sports Shorts Fitness Man Quick Dry Breathable Pants Male Clothing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/39/81/3981ad5722274b24801dafbbb92d9aeb.jpg",
    "cost_min": "4.54",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "5efe76c3-3ac5-4d31-b56a-85e6e6a48c17",
    "name": "13 PCS Makeup Brushes Set Eye Shadow Foundation Women Cosmetic Brush Eyeshadow Blush Beauty Soft Make Up Tools Bag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3f/cc/3fcc19ee3bc3da7a06f9c59c2f20ad52.jpg",
    "cost_min": "2.77",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "c8f6cb1a-062a-4088-8fc5-73887459b307",
    "name": "Underestimate Me Black Cat T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ff/76/ff762ef301bbcaadf600c8b77be41d8f.png",
    "cost_min": "17.39",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "88326796-f021-4993-91a1-797f40d2e06d",
    "name": "Men's Mini Electric Shaver Rechargeable Razor Epilator Women's Shaving Machine for Men Car Mini Shaver Electric Shaving Tools",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e7/54/e754b5e18ae0279487a501640ab918f2.jpg",
    "cost_min": "3.17",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "ba242d6a-e252-4b85-829d-4b98d1e9aea3",
    "name": "Camo Running Shorts Men Gym Sports Shorts 2 in 1 Quick Dry Workout Training Gym Fitness Jogging Short Pants Summer Men Shorts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0c/74/0c7445c9044b5fb13ec5fc66a9c5c390.jpg",
    "cost_min": "7.43",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "b1a516d2-5ca9-4f08-b861-89470e74ca99",
    "name": "Men's \"Apex\" Waterproof Jacket",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/31/a4/31a4b701276a3a77696764b4ab9a11a3.jpg",
    "cost_min": "127.16",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "446269a8-a01c-44ef-816f-87a9628fc6e4",
    "name": "Makeup Brushes Foundation Loose Powder Concealer Blending Blush Brush Professional Cosmetic Beauty Makeup Tool",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8d/7e/8d7e7037150a32ee1f890df72c266ca4.jpg",
    "cost_min": "1.93",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "a60a4500-41f7-416a-a65e-4102867f1b85",
    "name": "3m 5m Dog Leash for Small Dogs Cat Automatic Retractable Durable Nylon Lead Puppy Outdoor Travel Walking Hiking Traction Rope",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c4/bf/c4bf212c0e9d7b7cec7d76f8171d31e7.jpg",
    "cost_min": "3.74",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "7ab19757-877b-4e57-9b56-dd922a8fd1c7",
    "name": "MAANGE Single Flat Round Tube Flat Head Foundation Brush With Box Powder Blush Concealer Makeup Brush Skin-Friendly Makeup Tool",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1d/e7/1de7db77c1accd9f8d548dfd3ff70f18.jpg",
    "cost_min": "2.40",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "5389fe67-5813-477e-bc31-b1940ff1ae2f",
    "name": "The Aromatherapy Ritual Kit | Ayurvedic Spritzers for Mood & Dosha Balance",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/70/40/70400d12e42eedb7e95dc81f0fc6be12.jpg",
    "cost_min": "40.50",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "e9521abb-d739-4429-bb96-8954a5c1ea98",
    "name": "Pure Creatine",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/65/47/654765303e583c352ff24d30d5e4974c.png",
    "cost_min": "33.00",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "8c05ce80-522a-4c70-a243-979ce94e7115",
    "name": "Ashton Sports Bra - Navy Blue",
    "staff_picks": [
      "category_pick",
      "bestseller"
    ],
    "image": "https://media.modalyst.co/cache/a4/0d/a40d722d9c090250e9071fbac216e939.jpg",
    "cost_min": "4.98",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "3c3079ea-ac2e-46c6-8fb7-ecb171744e18",
    "name": "45g Dog Nose and Paw Balm Dog Paw Cream Cats Dogs Paw Protector Cream Pet Feet Moisturizer Pet Crack Feet Repair Pet Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f4/d1/f4d12f46c11f1588a803b293e76eb0e7.jpg",
    "cost_min": "2.75",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "924d9bae-c122-4a58-a05f-4d0c4974a74b",
    "name": "Moonlight (White Gold Peppermint) Lip Whip",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5e/9a/5e9a69dea048d83cf88b73db421d2264.png",
    "cost_min": "9.60",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "70208306-2602-440f-9974-310bb7a3996c",
    "name": "100g Turmeric Hand Made Soap, Lemon Kojic Acid Soap, Shower and Facial Soap  Deep Cleaning for Face Body Skin Care",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cb/cc/cbcc2c0321be228e75fb079d51d5f2a2.jpg",
    "cost_min": "3.36",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "4ba0f773-437e-4bbd-95d5-5c99604156d2",
    "name": "360Pcs Colorful Invisible Pimple Removal Anti-Acne Hydrocolloid Patches Spots Marks Concealer Beauty Makeup Tool Repair Sticker",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/56/42/56426a349d4cd249e769cef6c34b8671.jpg",
    "cost_min": "2.34",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "c97673f4-e180-4929-9ffe-62c4a6305151",
    "name": "6pcs/Set Acne Removal Needle and Clip Stainless Steel Tool Blackhead Removal Blemishes Facial Skin Care Beauty Facial Pore Clean",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6b/77/6b77161848c8d50359bc58379764f28f.jpg",
    "cost_min": "2.99",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "0c8f04e2-5922-4350-baf2-a5912d980fbe",
    "name": "New Men Women T Shirt Pullover Oversize Korean Version Cartoon Cat Group Printed T-Shirt Casual Short Sleeve Couples T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5e/15/5e155b005913ebd06076b9334aeea1c1.jpg",
    "cost_min": "4.18",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "912681b4-8d20-44a5-8a79-f0c2d52b7cb9",
    "name": "Mr Roboto Heather Navy",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9a/db/9adb6dbbd4b89e0115aeb881cb241741.jpg",
    "cost_min": "6.00",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "61c0e8b1-4948-4834-8804-7d914c44cf34",
    "name": "New Bluetooth Earphones Handfree LED Dispay Headphones Bluetooth Music Wireless Earbuds Waterproof Headset for Smartphones",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/45/d7/45d71e63ab2556857f7324594375d3e4.jpg",
    "cost_min": "3.66",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "5058d650-4d47-44b8-a0d7-90586b1bb05b",
    "name": "Tea Tree Essential Oil Shampoo Soap for Deep Cleaning and Hair Care Silicone Free and Residue Free Handmade Essential Oil Soap",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/41/cb/41cb6b4265fe682bee8679d1a0c0bd45.jpg",
    "cost_min": "3.59",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "7308f0ca-fb9d-46a3-8493-83e2266df369",
    "name": "3 Pcs Seamless Ladies Ribbed Cotton Thong Simple Women's Low Waist Bikini Briefs Sports Girls Underwear Plus Size",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/48/a4/48a4b27569d08effbb2917e4929a9dec.jpg",
    "cost_min": "4.16",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "4b0e72ab-22e3-4aed-9db5-32f6842b5686",
    "name": "Banksy Anarchist Punk and His Mother Artwork T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2d/78/2d78f602d3bf42cf432bbf6f0365fdb5.png",
    "cost_min": "13.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "8c856ae0-ccd2-429b-adaf-538af3f9fe6a",
    "name": "Laundry Detergent Strips",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cb/e4/cbe4a9764d8e20f98ff02e4627099404.jpg",
    "cost_min": "12.16",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "77dc18b3-eac8-406d-8964-39225e9ed08c",
    "name": "4pcs Waterproof Winter Pet Dog Shoes Anti-Slip Snow Pet Boots Paw Protector Warm Reflective for Medium Large Dogs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/91/31/913189cd8a51f174a4de8e9611fedfde.jpg",
    "cost_min": "8.90",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "33be9449-d92e-403d-a88a-a639927b69b6",
    "name": "Dog Clothes Hoodies the Dog Face Wind Coat Warm for Small Large Dogs Jacket Sweatshirt French Bulldog Jacket Clothing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/98/bc/98bc058df3f4819b7660672a63c08fcb.jpg",
    "cost_min": "3.00",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "089abb05-e8a2-4842-ad93-23c87907e309",
    "name": "Women's Sheepskin Gloves Winter Warm Plus Velvet Short Thin Touch Screen Driving Color Women's Leather Gloves Good Quality -2226",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/05/fd/05fd2d703a9520c19bf0071df36a1531.jpg",
    "cost_min": "23.09",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "e8ad800c-e129-4c6f-bc4d-3cf4aac6044b",
    "name": "PLADIO Straight I Tip Hair Extensions Human Natural Hair Extensions Keratin Capsule Original Human Hair 12-26 Inch 50pcs 100pcs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/97/ef/97efa23dfe35cb2b1ca1c006301f5857.jpg",
    "cost_min": "13.30",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "a5b1ef6d-6261-442e-bcf6-f2a7996218d2",
    "name": "2024 Summer Camo Sport Pants Mens 2 in 1 Workout Running Training Pants Gym Fitness Jogging Shorts Quick-Dry Elastic Men Legging",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/67/59/6759fc43dbccd62e23e577b8b2854e5b.jpg",
    "cost_min": "11.26",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "d940e180-6c5e-434a-9934-98a61502af7a",
    "name": "3PCS Trendy Stainless Steel Flower Drop Earring Set for Women Crystal Zirconia Dangle Earring Hypoallerg Piercing Jewelry Aretes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/02/7d/027d867bd5c33b412443e6845aa6a8cb.jpg",
    "cost_min": "2.92",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "2d310aa6-24c4-4c71-9482-48de4d42f579",
    "name": "Men's Summer T-Shirt 230G Heavy Cotton Vintage Washed T-Shirts Oversized Short Sleeve Loose Streetwear Short Sleeve Tops Tee",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3f/b8/3fb85ce43d346fff6157bc89d10ebb4a.jpg",
    "cost_min": "9.71",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "fd675e95-2374-4e85-b56b-761bbaf2fabc",
    "name": "2026 Sanrio Hello Kitty Tshirt Cartoon Sportswear Women Men V-Neck Loose Casual Lightweight Breathable Streetwear Beach Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/81/68/816889998f4eb6caab9585219f6b9202.jpg",
    "cost_min": "6.08",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "1894e343-d747-4bbb-9137-0097029a9db7",
    "name": "Grapefruit Splash- Grapefruit Scented Handmade Soap",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/16/c6/16c6671ece77a0d46a1ed5fc55bb213e.png",
    "cost_min": "2.70",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "84985507-6862-43fd-8697-2c8e3d8f32df",
    "name": "2024 Summer Flat Women's Shoes Hemp Rope Set Foot Beach Sandals Outdoor All-Match Casual Slippers Large Size Women Sandals",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/85/4c/854c614814d4d5ecff9f27a4713e806c.jpg",
    "cost_min": "11.64",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "dcc37698-e1bb-49e2-bcbc-4c8e55d06a05",
    "name": "Eucalyptus Radiata  Pure Essential OIl-15ml",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a1/f7/a1f74232576c950f04165ef8ef7cff14.jpg",
    "cost_min": "8.40",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "a4894d21-3467-4483-9a50-26825f1c9653",
    "name": "Kanye West Albums Minimal",
    "staff_picks": [
      "category_pick",
      "bestseller"
    ],
    "image": "https://media.modalyst.co/cache/e3/60/e360313194ba7fda5c17dbdee6e8c9a6.jpg",
    "cost_min": "10.20",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "349ce749-cafd-4f3e-b86d-34378b10cde1",
    "name": "Seamless Cashmere Double-Layer Two-Color Hat 100% Cashmere Dot Yarn Knitted Toe Cap Men's and Women's Ear Protection Warm Hat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6d/60/6d60c8281c070feda65808b317a31897.jpg",
    "cost_min": "30.88",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "04fe0ff2-f78e-4c08-9391-31e9b139597b",
    "name": "Brand Women's Flannel Plaid Shirts 2025 New Ladies Tops Exquisite Designer Style Loose Blouses Casual Cotton Long Sleeve Blouse",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/be/0f/be0f9e1a3eeeb223bd06f45d2b659fbc.jpg",
    "cost_min": "11.68",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7a56800e-192c-43c3-82aa-e21e580e3a3f",
    "name": "Funny Simulated Animal No Stuffing Dog Toy With Squeakers Durable Stuffingless Plush Squeaky Dog Chew Toy Crinkle Pet Squeak Toy",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d8/ed/d8ed26d30b518869f33127d0d7bfb874.jpg",
    "cost_min": "2.61",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "a8be8959-ba32-411f-97e6-9ab0b6ec3e09",
    "name": "3 in 1 Ionic Hair Curler Straightener Professional Curling Iron Heated Hair Styling Brush Anti-Scald Thermal Brush Curl Wand",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b4/ff/b4ff56f7d11a45bd8b3ed1ef41ae7523.jpg",
    "cost_min": "25.04",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "1fcc100e-f188-43a2-a32b-32a908c31185",
    "name": "Women's Sneakers Barefoot Casual Wide Last Fashionable Canvas Flat Board Shoe 2025 New Wide Toe Breathable Mesh Running Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b3/6f/b36f3abfc65dfe1f102a1057c64d41db.jpg",
    "cost_min": "26.05",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "786f88c2-90bb-4adf-884e-3619cb8f6650",
    "name": "Bambini Fleece Robe With Hoodie",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/d2/4ad22daecc2fe15954b8860a4395b7ad.jpg",
    "cost_min": "5.99",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "184b5876-f7db-4412-863e-6d7e7ea3a627",
    "name": "Silicone Adjustable 20-90lb Hand Grip Arm Strength Exercise Gripping Ring Fitness Gym Finger Forearm Trainer Carpal Expander",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a5/0d/a50d0a085e89829c220fbe9aaf7db7b4.jpg",
    "cost_min": "6.01",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "21498d9f-cada-4463-baed-fcecc6c7af3d",
    "name": "Automatic Drinking Love Pet Bowl Moisture-Proof Cat Bowl Dog Basin Dual-Use Multi-Functional Drinking and Feeding",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4c/18/4c18e4ea2cd1011f1dc8733d5f44562a.jpg",
    "cost_min": "4.27",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "cb02b507-7285-488f-9ff2-12df613758ff",
    "name": "100% Pure Batana Hair Care Oil Hair Growth Oil for Natural Treatment Nourish Reduce Hair Loss Anti-Breakage Hair Thickn Products",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0c/a7/0ca72df6577cd54c6f2468959c92f7af.jpg",
    "cost_min": "4.02",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "94eb4d57-a709-4548-8e9c-b9751b52f94a",
    "name": "\"Quick-Flip\" Tactical Belt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/77/e3/77e313ab7efcba2e6ce6af3f49af9dcc.jpg",
    "cost_min": "16.06",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "1c20d3ab-465a-44d5-9057-bbb4e1f8961b",
    "name": "1pc Artificial Plants Large Tropical Palm Tree Fake Banana Plants Leaves Real Touch Plastic Monstera for Home Garden Party Decor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/46/e0/46e09b3b0c3dacbb85f66f28e9fce259.jpg",
    "cost_min": "3.81",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "245ca7c3-94b4-46d1-99e1-38ceb669308f",
    "name": "New Men's Business Casual Short Sleeved Bone Flower Solid Color POLO Shirt Fashion Breathable Comfortable Summer Versatile Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b0/44/b044d221c968c06c1fe7c6346dd2e016.jpg",
    "cost_min": "7.82",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "39cdfcbf-75bc-4068-9dd7-e8381d667482",
    "name": "Training Sport Gloves for Men Women Workout Gloves Fitness Body Building Weightlifting Gym Hand Wrist Palm Protector Gloves",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9a/1a/9a1adf9e14d8dffedb40972bd779939d.jpg",
    "cost_min": "3.60",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "9ca4b757-bc3a-425b-b467-59684ed026c5",
    "name": "Pet Dog Cat Car Seat Dog Car Seat Belt Safety Protector Travel Pets Accessories Dog Leash Collar Breakaway Solid Car Harness",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4b/85/4b85274ab8005a958cb9b1d4caf3ead3.jpg",
    "cost_min": "1.98",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "7b187df2-9d64-49ec-a869-c76678e9ad76",
    "name": "0-24months Baby Hooded Romper Long Sleeve Front Pocket Solid Color Bodysuit for Newborn Boys and Girls Spring Autumn Playsuit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1e/3a/1e3a68a37b45c9751dc74c0144a4f919.jpg",
    "cost_min": "7.10",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "8ab194fd-045c-40c4-bba1-5971e00e281f",
    "name": "2M Green Leaf String Lights Artificial Ivy Vine Fairy Light Wedding Party Decoration Christmas Home Room Decor Wall Plant Wreath",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/05/32/05321108f9aaa5c48a1d5ba3bd40aaff.jpg",
    "cost_min": "2.21",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "e51eb92c-ea8c-46a4-ac70-24348f6948ca",
    "name": "Multifunctional Cargo Shirt [B229]",
    "staff_picks": [
      "category_pick",
      "bestseller"
    ],
    "image": "https://media.modalyst.co/cache/21/12/2112cd9fed03faf3d5200a4b322051f2.png",
    "cost_min": "24.81",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "a008d154-3480-4c02-a5c8-d0830b8d17c1",
    "name": "Fashion Vintage Square Polarized Sunglasses Men Women Driving Fishing Luxury Brand Designer Sun Glasses Driver's Eyewear UV400",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/94/3a/943a3e76439d850800311bb94c48dfbc.jpg",
    "cost_min": "2.30",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "5ed39c8f-82e2-45bc-a096-825d61648d3d",
    "name": "Portable Eyelash Curler With 15 Silicone Pads and Stainless Steel Eyelash Curler, Used for Eyelash Extension and Curling Tools",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/06/27/0627a5b364eaccea5d6060b87e53b970.jpg",
    "cost_min": "2.40",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "e952c509-c185-4b03-bf48-abb990e86b96",
    "name": "1Pair Gym Gloves Fingerless Gloves Anti-Slip Shock-Absorbing Gloves Sports Gloves for Training Lifting Weight Cycling",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a9/d2/a9d26edb6f2ae74f0872858440691d54.jpg",
    "cost_min": "2.69",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "3924b0bb-fe0a-4344-9978-d18ee2fd5ca6",
    "name": "NEW Women's Men's Casual Thick Soft Bottom Home Slippers Household Plush Slippers Anti-Slip Thermal Slippers Indoor Winter Flats",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/40/20/4020258cec69fb945d7ab107a1635fbe.jpg",
    "cost_min": "5.10",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "52b5b938-8030-4772-abe2-42adad2f7477",
    "name": "Winter Self-Heating Pet Pad Blanket for Dogs Cats, No Electricity Thermal Mat With Anti-Slip BottomWarm Cushion for Puppy Kitten",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2c/77/2c7701b0b0f85b28533cad2f51eacefc.jpg",
    "cost_min": "3.96",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "138fe9a8-b98c-4f54-8daf-cc2038daab78",
    "name": "LAPCOS Variety 7+1 Daily Skin Mask",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a4/20/a42036f7f2c2beecaecaff56026d5f83.jpg",
    "cost_min": "13.20",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "bf75fd65-9c8f-4c6d-a4cf-6b03e59e0517",
    "name": "Fashion Skew Collar Off-Shoulder Long-Sleeved T-Shirts Women Spring 2025 New Solid Slim Fit Crop Top Sexy Hollow Out Tees Shirts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5e/b3/5eb3c2ea65b9bc7f8bc0d809ccafed79.jpg",
    "cost_min": "4.52",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "d122420c-faef-4f2c-913a-0051e88a5452",
    "name": "Push-Up Board Set Portable Multifunctional Push-Up Bar Foldable Fitness Equipment for Chest Abdomen Arms/Back Training",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fc/fb/fcfb1ce08c639348f178d2b578a4cf71.jpg",
    "cost_min": "11.40",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "0c9e90b8-11fb-4987-a2f4-fae7d20a4d7d",
    "name": "1PC Outdoor USB Rechargeable LED Lamp Bulbs 60W Emergency Light Hook Up Camping Fishing Portable Lantern Night Lights LT014",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/75/6c/756cabcb3a92a7b4bafb9d5afd0198f6.jpg",
    "cost_min": "2.53",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "914bbcb6-0a2d-43b0-b50b-7fc62eca7550",
    "name": "The Whiskey Decanter Gift Set",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/25/d3/25d3e9e9f0070dc4df9af3ac3dca9664.png",
    "cost_min": "69.99",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "4333dd6f-ca12-4fc2-ab33-872d17eb1d27",
    "name": "Summer Beach Maxi Dress Women Floral Print Boho Long Chiffon Dress Ruffles Wrap Casual V-Neck Split Sexy Party Dress Robe Femme",
    "staff_picks": [
      "category_pick",
      "bestseller"
    ],
    "image": "https://media.modalyst.co/cache/01/92/019293c582f742e31267e914b2fa70de.jpg",
    "cost_min": "11.83",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "1f461980-c886-492c-bd52-5cab6a276c97",
    "name": "Blue Bloods 2oz Beard Balm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f2/0a/f20a30dbfebba8205507f4fcdf15a00c.jpg",
    "cost_min": "13.19",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "bc4e82c1-51d9-4cfa-bcca-3138ae91ccf5",
    "name": "The Mission Skirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2a/3e/2a3e0bb0858d64face189fd0fda09a16.jpg",
    "cost_min": "28.80",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "522fb210-347b-4af0-8921-06818aeeb4fc",
    "name": "Thermal Underwear Tops Men Winter Clothes Thermal Shirt Autumn Men's Winter Tights High Neck Thin Slim Fit Long Sleeve T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/76/63/7663c52890d2ce2053542fef04c0db6b.jpg",
    "cost_min": "3.90",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "615d828d-9883-40d6-a662-b97208428eb8",
    "name": "Trimui Smart Pro Handheld Game Console 4.96''IPS Screen Linux System Joystick RGB Lighting Smartpro Retro Video Game Player Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fc/ec/fcecdbf46d784c2833710f66119c7898.png",
    "cost_min": "109.77",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "0e0fc674-811b-400b-bfb8-0b9b5d32eb12",
    "name": "Santdee Irregular Tank - Gray",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/dc/e4/dce4264e53dd953b4e99d1c71c4d68f1.webp",
    "cost_min": "31.50",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "3f5ce5b8-3970-4084-a2c7-db4b3d867844",
    "name": "Turkish Cotton Blend Fringed Hobo Scarf Blue Degraded",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a6/24/a6249822c4404f41c0b29e15cbebb2ee.jpg",
    "cost_min": "5.99",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7bab8b32-49db-4b11-9f0a-9ed25058ab2c",
    "name": "SEVICH Hair Building Fiber Set Cover Sparse Hair or Bald Spots Hair Loss Regrowth Treatment Keratin Hair Fiber Powder Applicator",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cc/da/ccda5d77418bc01c4f418cd1a27927f8.jpg",
    "cost_min": "6.41",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "16028158-3ee6-4329-93a4-c02158ee2bdd",
    "name": "Fashion Women Baggy Joggers Pants Casual Communte Female Chic Straight Cargo Pant Elastic High Waist Elegant Oversized Trousers",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c6/fb/c6fb08dc3eddf4b67c6447dd16c4019d.jpg",
    "cost_min": "6.94",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "a4a09dc7-3185-40a3-8355-e74310716f40",
    "name": "BSport – Bluetooth Sport Headphones With Dual-Microphone and NFC",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d4/f5/d4f57b382de4b1cef32c5b030a498753.jpg",
    "cost_min": "11.99",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "652275e2-086f-4123-b361-77344da466f0",
    "name": "Pure Plant Protein Chocolate",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1b/84/1b841d142a9c138ebd0a7560a72d6f2a.png",
    "cost_min": "33.00",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "9304a74f-bd04-405e-b880-fdf86ad37a08",
    "name": "1 Set of 4, Resin Succulent Cactus Mini Green Plant Car Office Home Living Room Crafts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/99/8b/998bc26486a2d4544aed529307b0beb3.jpg",
    "cost_min": "2.44",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "17aa604b-ab05-4e6b-b304-450f0fc32288",
    "name": "New Vintage Square Sunglasses Women Men Luxury Brand Small Round Sun Glasses Female Small Eyewear Sunglasses for Male Female",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/40/b3/40b308e454cb4236b7525f220a234bb1.jpg",
    "cost_min": "1.82",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f854485a-bfad-478f-91b5-b7ebb36e2ccd",
    "name": "New Deep Sleep Comfort in Winter Cat Bed Iittle Mat Basket Small Dog House Products Pets Tent Cozy Cave Nest Indoor Cama Gato",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1c/07/1c073734966368e4de4e38716e6e5f8c.jpg",
    "cost_min": "9.23",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "d3559309-102b-4f4a-96e7-72937888aef8",
    "name": "7/8pcs Makeup Brush Kit Soft Synthetic Hair Make Up Brushes Foundation Blush Eyeshadow Cosmetic Makeup Tools",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ba/62/ba62ea1ee866143f1e73ac1d10d535ca.jpg",
    "cost_min": "4.76",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "36151939-0f2b-41a0-9a86-260d1474e9be",
    "name": "Tuya Smart ZigBee Soil Moisture Sensor Temperature and Humidity Meter Thermo Hygrometer Garden Automation Irrigation Detector",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ea/5f/ea5fd0e08baf127fdb111fd0c8e79d93.jpg",
    "cost_min": "6.48",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "cc55809b-38aa-4cda-8cf2-09258a34156f",
    "name": "Double Strand Necklace - Gold",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7f/55/7f556102a9fe9a83ba0d5f8f150389eb.jpg",
    "cost_min": "26.40",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "b2ea2ea5-42bf-4f14-8050-7ff58fdc2eea",
    "name": "Tiger Eye Black Leather Bracelet Men Natural Gemstone Crystal Stone Jewelry Handmade Courage Stress Relief Protection Bracelet",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fd/f6/fdf6aa3a2d80c22fc918deeb3aebf6d1.jpg",
    "cost_min": "4.51",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "6de5e757-0f38-47aa-85fc-03d83595ac09",
    "name": "Hiking Backpack 40L Lightweight Travel Mountaineering Backpack Waterproof Sport Bags Climbing Rucksack Backpack Men Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e6/37/e63718fc2a6c12d2d08dcb3b88bc0439.jpg",
    "cost_min": "8.47",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "8dcd9d57-e42e-4cb3-8804-56bc235f13bd",
    "name": "Waterproof Eva Furry Mules Slippers Women 2025 Winter Metal Buckle Warm Plush Slippers Soft Thick Bottom Non Slip Indoor Slides",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0a/3f/0a3fcd2ad7fa9d93a5d8840919570f53.jpg",
    "cost_min": "5.02",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "e5363f45-088f-4415-a707-4e9eda0bd9a1",
    "name": "100% Pure Organic Hair Mask Batana Oil Hair Growth Oil Natural Treatment Nourish Reduce Hair Loss Anti-Breakage Hair Products",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ed/9e/ed9ec11baf04efa4ba011e448837c3d6.jpg",
    "cost_min": "2.41",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "d4395557-7639-4c37-833a-ecda215bd93f",
    "name": "1Pc Cat Toy Sisal Scratching Ball Training Interactive Toy for Kitten Pet Cat Supplies Feather Toy  Cat Toys Interactive",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/5e/365e9084c6ce08ac4d30e6c42e672527.jpg",
    "cost_min": "1.97",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "48948527-6309-4d18-bdba-38804c713aa9",
    "name": "Lavender Pure Essential Oil - 15ml",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d8/b8/d8b8e01194251a1a04900b6e147fa1b6.jpg",
    "cost_min": "12.60",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "a0b00253-7d44-4b47-868e-d0f46fd9f5d5",
    "name": "Organic 100% Natural High Quality Catnip Cattle Grass Mint Taste Funny Cat Toy New Cat Toy Interactive Cat Toys Pet Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/21/b5/21b5d07a4d483ef5548542a0569741a3.jpg",
    "cost_min": "5.30",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "b120007c-e3f9-42c8-a2a3-86d4217ca134",
    "name": "Foot Massager Massage Roller Yoga Massage Ball Plantar Fascia Roller Muscle Relaxation Care Plastic Manual Foot Massager",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/87/85/8785d93489b96514a474a5f5e79bccb1.jpg",
    "cost_min": "7.52",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "1b7a0e59-657e-4329-b5a8-ffe643229ffc",
    "name": "Pink Rose Shampoo Soap, Essential Oil, Handmade Soap, Nourishing, Oil Controlling, Stain Removing, Floral Fragrance Overflowing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ff/b6/ffb657d2edbf5f3562b31410830165b7.png",
    "cost_min": "3.27",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "38cd39dd-606e-49e4-bc8b-aa74593bce34",
    "name": "1pc Felt Pet Toy Box, Dog Toy Box, Storage Basket Chest Organizer for Organizing Pet Toys, Blankets, Leashes and Food",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/f7/36f7f97bd4c3c7ca82b2bb01cd55af3f.jpg",
    "cost_min": "5.21",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "00e3302c-0e86-45fc-a5db-ab02f5530f86",
    "name": "Canada Fashion Winter Jacket Man Down Coats Parka Thick Men White Goose Down Jackets Fur Collar Hooded Extra Long Padding HWY291",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/61/60/6160dd34ce520550f7b76f1aaa921108.jpg",
    "cost_min": "5.70",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "9454236a-9e68-4709-8494-26100f9205ba",
    "name": "Clip in Hair Extensions Human Hair Brazilian Straight Clip in Natural Black Color Clip Ins Remy Hair 20 22 24 26 Inch for Women",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/56/4a56403ecc411fd15f61ab1b859b79f2.jpg",
    "cost_min": "20.64",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "624a1001-22c2-4e35-96c6-b44daaed6781",
    "name": "LED Solar Firework Lights Garden Decoration Fairy Lights Waterproof Outdoor Dandelion Lawn Lamp for Garden Landscape Lawn Decor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a2/b2/a2b255b7dce502d04d2f46f4cb592c9a.jpg",
    "cost_min": "3.57",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "136cc421-313d-42da-9456-8fa16fe3e597",
    "name": "Glass+Cover for Apple Watch Case 9 8 7 6 SE 5 iWatch Accessorie Screen Protector Apple Watch Serie 44mm 40mm 41mm 45mm 42mm 38mm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5f/76/5f7644d227c3a79b429521d4a502662e.jpg",
    "cost_min": "1.54",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "17964f1c-0ad0-42a7-9b6e-badbb8676f03",
    "name": "Organza Yarn Women Small Transparent Tote Mesh Cloth Bag Flowers Embroidery Handbag Liberty Ladies Eco Fruit Bag Girl Cute Purse",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/43/d5/43d5d4c04dbaf39e88682f8db82fdb4f.jpg",
    "cost_min": "4.69",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "d1e7b309-c796-49e8-83a7-9c813ea9e53f",
    "name": "Nylon LED Pet Dog Collar,Night Safety Flashing Glow in the Dark Dog Leash,Dogs Luminous Fluorescent Collars Pet Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/0a/4a0a84ca4f29ac0cdb9109360f70abdf.jpg",
    "cost_min": "0.56",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "09e6dd83-839a-4d54-a358-c98433768400",
    "name": "Custom Kids Travel Stamp - Personalized Waterproof Name Stamp for School, Eco-Friendly Ink, Kindergarten & Daycare Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0a/dd/0add13d671e97890708808dde7125031.jpg",
    "cost_min": "3.81",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "342118fc-d55f-4c42-b4fc-fe1904d76328",
    "name": "10pcs/1pc Seeed Studio XIAO ESP32C3 BLE WIFI Wireless Development Board Module ESP32 ESP32-C3 Tiny MCU 4MB for Arduino ESP32C6",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/de/fd/defd21fcaf9ecd1190f0e10e48e9f738.jpg",
    "cost_min": "3.64",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "65f99f76-64a9-411f-befd-dc98eda86649",
    "name": "Canada Fashion Winter Jacket for Men Down Coat Parka Men's White Goose Down Jacket Long Padding Detachable Down Inner Liner H819",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6e/e5/6ee587130bd2d120f9d08f9dae3b3f20.jpg",
    "cost_min": "6.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "f18b8e55-2fcb-43d5-ad1e-641b6d2a2111",
    "name": "Luxury Personalized Custom Initials Gold Name Leather Case for iPhone 17 16 15 14 13 12 11 Pro Max Xs Max Shockproof Back Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/53/af/53afdf942264219bbd8bb5d4bce2f2d1.jpg",
    "cost_min": "3.68",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "6ba78281-00a9-4051-b699-9a14a78f7ac9",
    "name": "Flat Waxed Thread for Leather Sewing Wax String Polyester Cord Craft Stitching Bag Bookbinding Sail Bracelet Braid Jewelry DIY",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b4/e7/b4e75f6a23a73bd44f1132b44b95a4e5.jpg",
    "cost_min": "8.15",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "1196aba6-d188-4d1a-a394-e11630b77664",
    "name": "Personalized Toddler Name Stamp Kit - Custom Waterproof Seal for Daycare, Travel Essentials & Homework, Safe Non-Toxic",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/60/0a/600a581cfa3e0ac64d8a773c88b8ff46.jpg",
    "cost_min": "3.60",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "e13761b3-3a9e-41ad-80eb-8ebb0a5a790f",
    "name": "Custom Children's Name Stamp - Personalized Waterproof Ink for Clothing Tags, Books & Crafts, Toy, for School Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/85/43/8543f2f0308a314a6f071b96a5a4c8be.jpg",
    "cost_min": "3.78",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "5d67998d-3a82-4c68-b3ed-5aa27c4d815c",
    "name": "‌Personalized Custom Name Stamp for Kids - Waterproof Durable School Stamp, Non-Fade Ink,Unique Educational Gift for Students",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/91/70/9170dd738468dee9a398777989ab3b6b.jpg",
    "cost_min": "3.54",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "7dbd5b7a-3710-4dad-a6fe-87c4099b1d56",
    "name": "Summer Women' Maxi Dresses Sexy Split Fashion Sleeveless Backless Slim Dress Female Casual Streetwear Club Elegant Party Dresses",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ac/3a/ac3adba963d2240cc6f108e695fa4db8.jpg",
    "cost_min": "8.61",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "8b9550f4-bc44-4083-8eea-f8062727e092",
    "name": "Wire Cable Soft Silicone Wire 11AWG 10AWG 9AWG 8AWG 7AWG 6AWG 4AWG 35 / 50 / 70mm2 Heat Resistant 200° Cold Resistant -60°",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/52/e8/52e854293c174a7772dc6a4d10a17109.jpg",
    "cost_min": "9.55",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "5fe362fa-4da4-4a3b-be60-43153b0672ad",
    "name": "Winter Leather for Women Fleeces Warm Thicken Pencil Pants High Waist PU Skinny Leggings Female Fall Trousers Customized Skirts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/47/7b/477b8f683aee2e638659286289921161.jpg",
    "cost_min": "18.53",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "04c4bb67-5a41-4590-89b2-2a5923ea1740",
    "name": "ZENOTTIC Titanium Progressive Prescription Glasses Men Square Anti Blue Light Photochromic Eyewear Optical Myopia Eyeglasses",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/74/d8/74d885c6b6d8ecb880cb26746966df6e.jpg",
    "cost_min": "18.89",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "01779b96-3d93-4618-8530-6fe9bf2a22b3",
    "name": "Support Lightburn JPT Mopa M7 60W 100W Fiber Laser Marking Machine Raycus 20W 30W 50W for Engraving Jewelry Silver Gold Metal",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/72/fc/72fc51f40ec00d75114e315ba7e2b3ea.jpg",
    "cost_min": "1250.96",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "8772845f-96d6-436c-97d1-86f18e8d292c",
    "name": "Vnox Custom Baby Girls Bracelets,Anti Allergy Stainless Steel Bracelet for Newborn Mom,Personalized Name Birthday Boy Girls Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ed/53/ed53bbdd9e18ad42cff6301da784da82.jpg",
    "cost_min": "1.99",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "a8545aef-99c9-46e3-84c7-befd11ef7932",
    "name": "Personalized Custom Underwear Photo Face Customized Boxer Briefs Shorts Panties Soft Underpants for Husband Valentine's Day Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b0/be/b0be0bdafb83259bf86e8a810b0661cb.jpg",
    "cost_min": "6.38",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "bb042dad-34ff-4edf-987d-7ae9f116e784",
    "name": "100% Human Hair Deep Wave Bulk Braiding Hair Unprocessed No Weft Boho Braids Human Hair Bulk Extensions Brazilian Remy Hair Curl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2b/21/2b21bec93bcee597b6c18842ee70c3f7.jpg",
    "cost_min": "20.52",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "aa1e8467-fbeb-4312-8d8e-1471bb7052db",
    "name": "50pcs/11 Sizes Brown Bubble Envelopes Gift Packaging Bags Padded Mailers Shipping Envelope Self Seal Bubble Courier Storage Bags",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/32/ed/32eda21d59ea1997943cf8b810cbbfc5.jpg",
    "cost_min": "17.87",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "b3981fb1-a84a-494f-81f1-dd999da1f4fb",
    "name": "LED 50cm Aluminium Channel for Led Strip v/U Shape Aluminum Profile With Diffuser Milky PC Cover,LED Bar Strips Light Holder",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9d/e6/9de668d41b50a2a1a87af2324ac96a53.jpg",
    "cost_min": "2.02",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "5dc4a4fb-b39b-433d-af64-b3480775d23e",
    "name": "Wedding Party Team Bride Robe With Black Letters Kimono Satin Pajamas Bridesmaid Bathrobe SP003",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/18/c71837ed0148440380f94e1776843133.jpg",
    "cost_min": "5.57",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "0211e751-e3a7-481c-a9c2-bd37a39dfa33",
    "name": "50pcs/Lot 24 Colors Jewelry Bag Organza Gift Bags for Jewelry Packaging Bags Wedding Gift Storage Drawstring Pouches Wholesale",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/79/af/79af8d1eb96b1df95a8ebfee4408a686.jpg",
    "cost_min": "2.61",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "427616d0-88cd-4b74-8f93-6d4923b76c82",
    "name": "4pcs Set Professional Eyebrow Hair Removal Splinter Tweezers Set Perfect for Very Effortless and Relaxed to Remove",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/05/47/0547b718ca88fc8541ca9bc57c6e889d.jpg",
    "cost_min": "1.19",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "8cdce00f-82d4-4942-bbe5-35311bdb2520",
    "name": "1W 3W LED Bead Light Plate DC3-5V/6-12V/12-24V Drive Free Light Chip Battery Light Source Board With 15cm Line for DIY Bulb",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/04/94/0494fae87b9ebb5c715e76cb439dd6e4.jpg",
    "cost_min": "4.85",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "f60d35f6-66f5-4a0a-b099-bfb124ebeca5",
    "name": "2pcs/Lot BAOFENG BF-888S Walkie Talkie UHF Two Way Radio Baofeng 888s UHF 400-470MHz 16CH Portable Transceiver With Earpiece",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/42/06/42065e1a818cf27fe7e9155fd8f82d97.jpg",
    "cost_min": "16.18",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "b42a19f2-7b55-4a28-9c9d-afbdd8ca1a4f",
    "name": "Round Leather Sewing Wax Thread Cord Handwork Knitting Craft Wax Thread for Leather DIY Project Necklace Bracelet Round 63Colors",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/27/88/2788fa65f008169fce0e2ecab13d6aed.jpg",
    "cost_min": "6.00",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "42110723-1771-4948-a198-bfc440a732da",
    "name": "For iPad 11th 10th 9th 8th Generation Air Mini Pro 8.3 9.7 10.2 10.9 11 Shimmering Glittering Soft Silicone Case Airbag Shell",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/94/05/94053b9e8c53ed114ae5b06ec0536aef.jpg",
    "cost_min": "3.17",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "b38c03ac-08ed-4e0e-afef-47074edb046a",
    "name": "‌Personalized Teacher Stamp With Ex Libris Design - Customizable Library Book Seal for Educators & Academic Institutions",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/29/0d/290df6f88c5fbfade325a2287edfb040.jpg",
    "cost_min": "3.79",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "d7253d8e-d37c-4c58-bbd7-1fcae066823e",
    "name": "MiiOW Pure Cotton Short Sock Men Sport Non-Slip Invisible Ankle Sock Summer Anti Sweat Deodorant Breathable Business Dress Sock",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/79/fb/79fb8d04a69afea2a6c1ed52402c3eb8.jpg",
    "cost_min": "19.97",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "d8e9164f-0204-465e-9433-83a51f9ebf1b",
    "name": "Luxury Colorful Kevlar Carbon Fiber Magnetic Phone Case for Samsung S26 S24 S25 Ultra S23 Plus for Magsafe Wireless Charge Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/65/f8/65f8034e894f8b4ccd3c9a8a905f3e9c.jpg",
    "cost_min": "3.50",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "6be987f5-c781-40a6-94fd-52c68ab5694e",
    "name": "3-In-1 PTC Hair Straightener Styling Appliances Hot Combs Tools Heated Flat Iron Beard Styler Professional Brush Curling Iron",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ba/d6/bad6cfb8cae1823777235afa147b3517.png",
    "cost_min": "3.96",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "67abd50a-c240-4b6c-8a1c-bb68d917b97d",
    "name": "Korea Quality Stretch PU Heat Transfer Vinyl HTV Film for T-Shirts Iron on Hot Press Cut Vinyl Clothing Fabric DIY Decoration",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ff/e5/ffe5cb1f2057ecff4a92366f1c2fee68.jpg",
    "cost_min": "1.45",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "2b963328-9d15-4dbe-96de-e5b76018cfc3",
    "name": "Easy Weed PU Heat Transfer Vinyl Sheet/Roll for Clothing Iron on Hot Press Cut Film HTV Printed DIY Tablecloth Bags Dress Decor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/15/9c/159c373f1369b83ae287914a9c975dae.jpg",
    "cost_min": "1.57",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "bdea3f01-4231-432e-aa42-be454f8bb236",
    "name": "Custom3D Wall Mural Wallpaper Retro Nordic Style Papel De Parede  Plant Wood Grain Living Room Bedroom TV Background Wall Papers",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3b/0e/3b0e61255083c266b8243c4f43583235.jpg",
    "cost_min": "7.44",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "3e0a5504-17e5-44fc-8938-a6c6ae6e544c",
    "name": "Women's Jumpsuits Autumn New Long Sleeve Bodycon Fashion Zippers Sexy Grey Rompers Casual Streetwear Fitness Sports Yoga Overall",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/95/29/9529cbc6bd61f2957fe70b3cd3bf7558.jpg",
    "cost_min": "10.53",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "e615bd0c-d489-4cbb-8176-307cc8e92daf",
    "name": "Sexy Black White Soild Color Long Socks Women Over Knee Thigh High Over the Knee Stockings Lolita Ladies Girls Warm Knee Socks",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/58/9c/589c2619885590f35d8559c049fed65d.jpg",
    "cost_min": "1.78",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "6b0c8bba-0ed8-4b65-bbe7-d51fe0fa768c",
    "name": "10pcs/Lot USB Flash Drive 4GB 8GB 16GB Metal Pen Drive Pendrive 32GB 64GB Memory Stick 128GB Free Customized Gift USB 2.0 Sticks",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/be/3f/be3ff8316ba30054e301bba671787be5.jpg",
    "cost_min": "10.08",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "5fde7e1c-6b22-4747-b953-bd1949cc50dc",
    "name": "Remote Car Key for Buick Chevrolet Tahoe Cadillac Traverse Avalanche GMC Acadia Yukon Saturn Outlook OUC60270 ID46 Keyless Entry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/04/5a/045abc54d0644f60ec298e2a94d2a59f.jpg",
    "cost_min": "5.07",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "bde94061-3596-45a4-8511-14a52af04889",
    "name": "Band for Samsung Galaxy Watch 7/6/4/Classic/5 Pro 44mm 40mm Wrist No Gaps Nylon Sport Loop Correa Bracelet Galaxy Watch 7 Strap",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ae/d6/aed6b6be49254e0cf302154b00c1c6b6.jpg",
    "cost_min": "2.05",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "ae72b6c5-946e-4add-9f8f-3737da8592f5",
    "name": "LW28-20 LW26-20 YMW26 Series Electric 2/3/4 Position 8 Terminals Rotary Cam Changeover Switch With Screws Useful Tool 660V 20A",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fd/07/fd07c9cb8acc8cc8ad8741d1a5387d4c.jpg",
    "cost_min": "11.76",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "6556e387-0619-459c-a5d6-020a3736c9ad",
    "name": "Ladies Spice Sexy Zebra Fur Coat Fox Fur Mid-Length Coat Temperament Winter Thick",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/aa/04/aa04ab8a7cd8fdf1ac1352ece0d67318.jpg",
    "cost_min": "44.46",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "4119a058-78fe-440c-a568-9bfc84ecd8d7",
    "name": "Hot Brand Lemontini Phone  Case for IPhone 11 12 13 14 15 16 Pro Max Plus 17 Air Makeup Lip Gloss Silicone Cover With Lip Glaze",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ee/91/ee9175ebe89141e6bbedef4a5e072706.jpg",
    "cost_min": "5.97",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "be4468f0-acaf-4d01-abdb-f40e3f84e862",
    "name": "2026 Men's Red Sleeveless Suit Vest, Korean Slim Hot Stamping Printed Vests, Silver Blue Beige Waistcoat, Asian Size M-6xl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b5/99/b599e7b06523ce94ec503ded0c9f3d01.jpg",
    "cost_min": "16.82",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "f0d6f419-b3ca-4414-bf8d-2894cc9540fe",
    "name": "1-2Pcs Private Tempered Glass for iPhone 14 13 12 11 16 17Pro Max XS XR Anti-Spy Screen Protectors for iPhone 15 16 Plus",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ff/71/ff71b58e5f2e303d12f77675d9fb9990.jpg",
    "cost_min": "1.72",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "b758fe33-b4d2-442a-b379-55dbe2b92ee6",
    "name": "Kevlar Carbon Fibre PC Hard Case for iPhone 17 Air 16 Pro Max 15 14 Plus 13 12 11 Shockproof Camera Bumper Ultra Thin Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8a/6c/8a6c683006329a256130004e813149be.jpg",
    "cost_min": "1.65",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "dbb9c0e0-3ff3-48d4-847f-fc4bc7fae485",
    "name": "1-5pcs Anti Peep Privacy Tempered Glass for iPhone 12 13 14 15 Pro Max 16 17 Anti Spy Screen Protector",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1e/e4/1ee4eed554608e4bd0b94338aa5de52e.jpg",
    "cost_min": "1.93",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "f36f6411-0ccd-4e42-9337-9b0e5d3a382b",
    "name": "Sevich 100g Hair Fibers 10 Color Keratin Hair Building Fiber Powder Instant Hair Growth Fiber Refill 50g Hair Care Product",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/99/ad/99ad808e3d4bbf302dea12e651e4f1af.jpg",
    "cost_min": "3.99",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "ca3f6f31-9ade-482f-9101-9ccf11d6ba32",
    "name": "Sparkly Rhinestone Transparent Long Dress Evening Birthday Celebrate Luxurious Costume Dancer Flashing Dress Naked Party Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e9/12/e91270a34e3a473c68397f851f574e68.jpg",
    "cost_min": "28.90",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2fc185ed-44a7-4133-93c9-c01072e8b0f5",
    "name": "1-50pcs WS2812 4-Bit RGB LED Panel Module 4-Channel 5050 Full-Color Lamp Board for Arduino, DC 5V Smart Lighting",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e9/5e/e95ee1bc2432b3c2e4bbe56af53b5c21.jpg",
    "cost_min": "0.54",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "362dd39a-26a4-4945-b323-47a95174fe41",
    "name": "1-50pcs WS2812 3-Bit RGB LED Lantern Board Round Full-Color Light Module for Arduino",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/78/bb/78bbd774d5599f73793f4f9ce61da3f3.jpg",
    "cost_min": "0.63",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "12990dde-e599-4f31-b118-fe55e4b3aa68",
    "name": "1-50pcs WS2812B 5V RGB LED Module With Integrated IC 256 Colors 400Hz Scan Rate Smart Pixel Light",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/e3/93e3950d7b608dfe17d9acb6c95f5e93.jpg",
    "cost_min": "0.51",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "b14ab7ff-16ee-47b2-920a-9f465ee60c06",
    "name": "1-50pcs 8-Bit WS2812 RGB LED Ring Module Full-Color Lamp Board With Integrated for Arduino",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b5/b0/b5b003bd73accd68c0e4bc56545e60d6.jpg",
    "cost_min": "0.54",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "49e9e510-210a-45bd-bb85-a6822e25e574",
    "name": "Bluetooth-Compatible LED Name Badge DIY Programmable Scrolling Message Board Mini LED Display HD Text Digits Pattern Display",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ab/fb/abfb9548a7f52a7826cbcc0d5d8e44f0.jpg",
    "cost_min": "7.22",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "33870a5f-4cb5-447a-97c1-064ecae979c0",
    "name": "Personalized Stickers Custom Design - Upload Logo/Text for DIY Gift Labels, Creative Wedding Decor, Home Decals & Photo Crafts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a3/23/a323d3eb4871c2d37f2c0435d7f46fcf.jpg",
    "cost_min": "2.61",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "ecb4c2fc-e3fe-40f2-8a51-b5f80bdaba71",
    "name": "BraceTop 1 PC Sport Arm Compression Sleeve Basketball Cycling Arm Warmer Fitness Running UV Protection Volleyball Sunscreen Band",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/54/5e/545e565c023b7c116946c7e1d8bf24f6.jpg",
    "cost_min": "2.74",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "f64fcd84-aedb-4a8d-ae3a-ffd5442dd273",
    "name": "RGB Led Strip Lights 5m 10m 20m 30m Led Room Light With APP Control Flexible Ribbon Luces Led Tape for Room Bedroom Decoration",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/18/83/188363bfd6c14e021da46c87d5c426c9.jpg",
    "cost_min": "5.89",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "4febc21e-390b-4643-a226-cee8f3c2c5b0",
    "name": "ROCKBROS  Arm Sleeve Breathable Quick Dry UV Protection Cycling Sport Sleeve Ice Fabric Sunscreen Sports Wear Fitness Arm Sleeve",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/0c/930c516fe34b533d25df469e2ccbdf40.jpg",
    "cost_min": "5.08",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "f167f65b-2875-45a8-9b69-fb932d619c92",
    "name": "Metal Lens Ring Glass for Samsung Galaxy S26 S25 S24 S22 S23 Ultra Plus Camera Protector Cover for Samsung S26 Ultra Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4b/b6/4bb684e05ab93c403426b80a220fc77f.jpg",
    "cost_min": "1.93",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "6f7442fc-47ca-4aeb-9c28-347052c08861",
    "name": "Casual Street Sweet Autumn New Basics Ice Silk Pants Lantern Pants Solid Color Elastic Women's Sports Pants and Ankle Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c9/ac/c9acd247a28babd85ec914aebf9a617c.jpg",
    "cost_min": "5.70",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "69e06c69-23ff-4571-a3e8-b4960030e8ac",
    "name": "5Pairs/Lot Unisex Non-Skid Baby Shoe Socks 0-12months Cotton Baby Boy Girls Meia Infantil Cheap Stuff",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/55/5a/555a2cf8ac75688fa77d896614f95854.jpg",
    "cost_min": "5.64",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "7256c13d-fda3-4df4-bc97-6cd46e46e7ce",
    "name": "FGCLSY New Tripod for Smartphone Camera,Stand With Bluetooth Shutter and Light,Wireless Selfie Stick Brackets With Phone Holder",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cf/65/cf65dfb8cf9cfa76569f6abcd828d0d5.jpg",
    "cost_min": "4.74",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "b9002e7f-8587-4495-90d9-b53e905a96e8",
    "name": "10Pairs 8D Mink Lashes Natural Mink False Eyelashes Dramatic Volume Fake Eyelash Extension Faux Cils Wholesale Makeup Tool",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d9/4f/d94f1ddf022b46844e859935760abd47.jpg",
    "cost_min": "1.24",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "10a5e05e-1dcf-48ff-aef3-142bb36b7038",
    "name": "Lagabogy 2025 Winter Puffer Jacket Women Thick Warm Short Parkas Real Natural Raccoon Fur Female Loose 90% White Duck Down Coat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/82/86/8286ffd11c4da6548810bc1daf243631.jpg",
    "cost_min": "93.03",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "787a7508-de25-49ea-b5c7-079ccbb1c973",
    "name": "Save Ferris From Ferris Bueller's Day Off T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d9/c6/d9c6875248c9535c3c4fe240d5df6fec.png",
    "cost_min": "13.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "1000adad-df5a-44c6-9948-1a6087025d40",
    "name": "Hello Kitty 3D Glasses Cat Silicone Phone Case for IPhone 17 Pro Max 16 15 Plus 14 13 Mini 12 11 4 4S 5 5S 7 8 SE",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/73/ce/73cec7c3d0d9fe03fc133e9c2c247978.jpg",
    "cost_min": "5.75",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "49641cb8-0f6c-46c6-8343-8131c0941f23",
    "name": "BAKAWA  4 Strands Braided Fishing Lines Multifilament Pesca 100M 300M 500M 1000M Carp Wire Japan Abrasion Resistant Pe Line",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/85/e0/85e0bb832ab19bfab31a0d5ea324ea92.jpg",
    "cost_min": "2.62",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "316d6a47-678a-4700-84ba-1d7d5c922137",
    "name": "Male Hair Prosthesis Men Wig Mono NPU Toupee Human Hair System Wave Curly Indian Human Hair Replacement Natural Color With Grey",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e5/c5/e5c53dfabc2c3e8ebe1db39f602e386c.jpg",
    "cost_min": "72.80",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "f9f08587-5ce6-4bd8-b864-06c146fa5316",
    "name": "Find Your Coast® Heritage Sunset Explorer Hoodie",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fc/27/fc27538819744129ad4bc72dd01d8200.jpg",
    "cost_min": "37.13",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "f1be46be-d683-4ea9-acf2-b62b6f8b4df6",
    "name": "Summer Quick Drying Clothes 3D Printed Men's T-Shirt, Oversized Loose Round Neck Short Sleeved Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/43/ce/43ce32489fec607da10530289663f128.jpg",
    "cost_min": "3.87",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "34c6629d-34cf-4b4e-b825-aa39eb3f0cd0",
    "name": "Everlast Men's Sports Fitness Set Long Sleeve Tight+Shorts+Compression Pants Training Equipment",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/12/63/12633d310119e6547ce1b5d232bc8b7d.jpg",
    "cost_min": "26.02",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "16683297-3ee6-4065-8eb0-b481476011a0",
    "name": "1-100pcs 3W 4W 5W 6W 15W 18W High Power LED RGB RGBW RGBWY RGBWYV 4pin 6pin 8pin 10pin 12pin Colorful Chip Stage Lights Source",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a0/2e/a02ed34a46e50b5a18889b827cad3681.jpg",
    "cost_min": "1.27",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "74cbf0e9-03ff-477c-9de5-189274cb44e1",
    "name": "Power Supply Transformer 5V 12V 24V LED Switch 1A 2A 3A 5A 6.5A 8.5A 10A 12.5A 16.5A 20A 25A 30A 40A 50A 60A for WS2812B SK6812",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/33/0e/330e46faa18d81e76b37346944a23d5a.jpg",
    "cost_min": "2.45",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "f90973a3-f895-4db3-97e8-0328606fdc9d",
    "name": "Plus Size Underskirt Half Slips Dress for Women Summer Thin Ice Silk High Waist Elastic Anti-Penetrating Underskirt Lining 110KG",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ad/94/ad9404b6a61049383b5e68dabbd9e08d.jpg",
    "cost_min": "7.81",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "00e019e1-9ee3-4c02-a666-48936e87039e",
    "name": "1/5/10pcs 3x7cm PROTOTYPE Plate 2 Layer 3*7cm Panel Universal Board 2.54MM Green",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/3b/363bbea47fc24f2cf1c9dd94adf2db2c.jpg",
    "cost_min": "1.00",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "24a67b49-af56-4bf3-bd7c-f1bc0b41ab0a",
    "name": "Mid-Waist Hollow Out Panties Women Breathable Comfortable Lady Boyshort Knit Female Underpants New Style Women's Underwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/78/ae/78ae0fc9dafb4e0c2bd20f2caf5c294c.jpg",
    "cost_min": "3.03",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "59df8a43-2e91-4ce5-8d59-53ca0616ae70",
    "name": "DIYTZT 10/30/50pcs LM358 LM358N LM358P",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/97/369738502e09db1355f76bcbe5859906.jpg",
    "cost_min": "1.14",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "710e9890-a91c-48d2-b953-dbfd6569c83f",
    "name": "Anime Figure Clear Custom Acrylic Stand Model Plate Transparent Holographic Printing Desk Decor Sign Keychain Birthday Gifts Pet",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e4/3b/e43b714f018e2ac2aa5578325c6e0c75.jpg",
    "cost_min": "1.76",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "69c43988-73f9-4c85-b745-6e961c819347",
    "name": "Customizable Women Leggings Customized Skirts WCK917917",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b3/fc/b3fc9751b08c4165e9eba001269655fc.jpg",
    "cost_min": "9.40",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7cc7e0a7-2335-42fd-9c60-3e6ed93d1081",
    "name": "GPS Tracker Bluetooth 5.0 Anti-Lost GPS Mini Device Pet Elderly Kid Bag Wallet Car Tracking for IOS Android Smart Finder Locator",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fa/00/fa00f90e336af0b6a3031768638bb960.jpg",
    "cost_min": "1.71",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "564fd39d-3286-4f09-8aaf-496304007056",
    "name": "160x100cm Plush Fabric Polar Fleece Fabric High-Density for Winter Season Clothes DIY Bed Quilting Crafts Sofa Hat Warm Handmade",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0d/40/0d404b5f7a3d1929093e922a004375a9.jpg",
    "cost_min": "15.08",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "30667d40-fad7-48bd-a457-815a2f846907",
    "name": "0.5m/1m/2mVintage Style 100% Cotton Fabric Floral Daisy Cherry Print Fat  Print for Handbag Making Quilting Patchwork DIY Crafts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/12/ca/12caffbe4c3952957da033eef9670f84.jpg",
    "cost_min": "4.83",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "82c5b7e6-009a-42ea-b921-f0423233ecc6",
    "name": "Women's Tracksuit Suit Autumn Fashion Warm Hoodie Sweatshirts Two Pieces Oversized Solid Casual Hoody Pullovers Long Pant Sets",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/99/be/99beb14a15a17e2097113057e5ff447a.jpg",
    "cost_min": "14.81",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "40317585-2757-4944-b206-fe815394a453",
    "name": "Original 925 Sterling Silver Ring Love Heart Wishbone Moon Sun Rings Crystal Rose Gold for Women Wedding Gift Luxury Jewelry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a1/81/a18191dbbc227be3bdc5d2b2c8e08a65.jpg",
    "cost_min": "3.98",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "485a6147-c69b-404f-ac37-960e381e2742",
    "name": "Golf Blade Putter Cover Golf HeadCover Multiple Style Magnetic Magic Tape Open Close Golf Club Protective Headgear Golf Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fb/c5/fbc577105e873b820412fb87c0760d67.jpg",
    "cost_min": "8.32",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "1115ddde-7033-4a47-8e14-aeed1770d655",
    "name": "Golf Gloves Men's Glove Left/Right Hand 2 Color Soft White Dark Grey Swing Putting Training Particles Breathable Namib Gloves",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/df/b0/dfb04040cdea4acfa36fc56f16d1928d.jpg",
    "cost_min": "4.68",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "909f680a-5c41-4d19-bce6-fe52cbdcbb3e",
    "name": "Micro Loop Hair Extension Human Hair Straight Brazilian Remy Hair Extensions for Women Invisible Fishing Line Hair Nanolink Hair",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fe/13/fe13cc393b357a1d041f33499b598e47.jpg",
    "cost_min": "19.35",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "e760b9a9-334c-4c08-87b1-395310e3f7b6",
    "name": "Nanoring Hair Extension Straight High Quality Real Human Hair Extensions for Women Micro Ring Link Hair Extensions Human Hair",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/79/4f/794fe69a4f850f337958d8c677b028e0.jpg",
    "cost_min": "14.57",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "39f6a4fc-1f0b-40a6-a388-0ff2fac9d634",
    "name": "FANSGUY 1Set 1/64 Alloy Car Staggered Front Small Rear Large Wheel 11.2mm+13mm BMS-F/FP Serie",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/44/0b/440b157179e8828be5370876793c221c.jpg",
    "cost_min": "1.15",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "e47c8d96-e464-4eb6-ab58-4dc51df3f1c8",
    "name": "GEMOSA Geometric Picture Photo Personalization Bulk Customized Italian Charm Link Fit 9mm Stainless Steel Bracelet DIY Beads",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/46/ab/46ab7d578a1cd1ee28a1e0d946d01906.jpg",
    "cost_min": "3.04",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "e3624f1c-a365-418b-9876-d0c2aef5fb54",
    "name": "KAK 4Pcs Black Furniture Leg Gold Table Feet Replacement Cabinet Sofa Metal Feet With Screws 800KG Non-Punch Furniture Hardware",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d4/40/d4401616e6ab38bd1dd5c86ef4addaea.jpg",
    "cost_min": "26.84",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "1895a380-bb98-463e-865b-bb039fb11f3f",
    "name": "Winter Warm Clothes 2022 Pink Black Faux Fur Coats Women Long Sleeve Crop Top Gray White Faux Fur Jackets for Women Wholesale",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/82/c4/82c4617e2ce94b9397432a1504ff1adc.jpg",
    "cost_min": "17.40",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2c097092-bc21-4e23-a7f1-560bfe39aefe",
    "name": "Golf Mallet Putter Covers Magnetic/Magic Tape Closure Synthetic Leather Multi Style Panda Cat Akita Durable Soft Golf Headcovers",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/23/87/238754b8e95e6034df4bd20c02c6525c.jpg",
    "cost_min": "7.91",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "c0039773-21e6-499a-aa5f-c0eb268df8df",
    "name": "100m PVC Electric Cable Soft Copper Wire for Power Led Car Battery Jumper Wiring 1AWG 2AWG 4AWG 6AWG 8AWG 10AWG 12AWG 14AWG",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a2/40/a240bf853cb56c34afdff8ee4a35f9ca.jpg",
    "cost_min": "2.03",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "a3ad8f22-338a-49b0-8267-b08167d812d2",
    "name": "New Spring Solid Candy Neon Leggings for Women High Stretched Female Legging Pants Girl Clothing Leggins Plug Size",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ca/d2/cad20a2972074e0b2a029d7ead58b273.jpg",
    "cost_min": "3.80",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "ed380a08-3c99-4c8a-9889-bab6ca04bee9",
    "name": "Andy Warhol's Banana, 1967 Pop Art T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4f/bf/4fbf4ff745af583a481ec3bb6b134555.png",
    "cost_min": "13.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "99697252-1f3b-424c-a4ed-524031d6109f",
    "name": "2Pcs H8 H11 LED Bulb H16 JP 9005 HB3 9006 HB4 Led Lamp Super Bright Car Fog Lights Day Driving Running Light 12V 24V 6000K White",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/71/4b/714b8bd308135b8f5b2733bc3e1ccb6e.jpg",
    "cost_min": "5.17",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "b08a39f1-b808-4be7-b356-0023d207cdba",
    "name": "High Quality Custom Hoodie Cotton Sweatshirt Print Embroidery Brand Logo Text Photo Design Men Women Famliy Team Clothing 300g",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/4c/364c01b00c740146ec5dc8fe76f0a92b.jpg",
    "cost_min": "16.77",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "3849d801-a98a-42c5-b4ce-9fa6c0f46754",
    "name": "IPL Permanent Laser Hair Removal Female Electric Facial Epilator Women Makeup MachinesMan Shaver Choice Hair Cutting Machine",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/d6/36d63e1148a3839a8283289c3e7aab53.png",
    "cost_min": "31.77",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "3e65c306-16a1-4c6b-a83d-769bf6854fc7",
    "name": "1/2Yards Metallic Lustrous Ruffle Pleat Trims Crinkle Organza Lace Fabric for DIY Costume Skirt Border Craft Patchwork Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f1/41/f1414039201734d9b0e6220c0c3d1561.jpg",
    "cost_min": "2.90",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "891a2bb5-1f51-411e-a129-b7f10a30482e",
    "name": "10PCS Holographic Metallic Bubble Mailer Laser Gift Bags Glamour Colorful Foil Bubble Envelopes Padded Shipping Mailing Envelope",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e1/6f/e16ff4c54c96de3ea4f864dec72c1df6.jpg",
    "cost_min": "2.43",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "685d0365-9460-4f97-b157-e25b32b92063",
    "name": "Aroma Diffuser Essential Oil Hotel Scent 200ML for Home Office SPA Car Fragrance Oil Perfume Oil Ritz Carlton Burj Al Arab",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1c/5e/1c5ee1dd7eb69510af3589e88924f662.png",
    "cost_min": "13.68",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "1fb64b14-6381-4173-a1d8-4c23b2942b42",
    "name": "10pcs/8sizes Rose Gold Metallic Bubble Mailers Foil Padded Bags Aluminized Postal Bags Gift Packaging Padded Shipping Envelopes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/88/f3/88f374620471d07476cdd9f7d10b1eee.jpg",
    "cost_min": "3.60",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "59b3e342-7513-46f8-b0fa-db2580ad69c2",
    "name": "Handheld Clothing Plate Iron for Clothes Voor Mini Ironing Machine Portable Travel Steam Iron Home Appliance Garment Steamer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/77/5b/775b2298491f4c39dc79a7957a485b01.png",
    "cost_min": "8.45",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "3900531a-349a-451a-a65d-00f79b2bc10f",
    "name": "1-100pcs USB 3.1 Type C Connector - 16 Pin PCB Board Adapter, Socket for Data Line Cable Transfer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/98/28/9828ccd787f03c2c5bc397df4a60ff52.jpg",
    "cost_min": "0.88",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "0c86c1d2-a130-483e-b2e3-133f06172e3c",
    "name": "DIYTZT 10/30pcs MOC3063 for Power Module",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/df/93df578044876390b16d8e833800a947.jpg",
    "cost_min": "2.24",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "33a85855-71e0-431d-8e2e-bfc1046a4ffe",
    "name": "TZT 1BOX BC337 BC327 2N2222 2N2907 2N3904 2N3906 S8050 S8550 A1015 C1815 10Values*20pcs=200PCS",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/bf/92/bf9263623b784711d4204df150829ded.jpg",
    "cost_min": "4.54",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "bf5f7377-15d2-4944-9b70-7b8b09d66c25",
    "name": "High Temperature Heat BGA Tape Thermal Insulation Tape Polyimide Adhesive Insulating Adhesive Tape 3D Printing Board Protection",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a6/25/a6259adfd314e0982f9957df055b3fca.jpg",
    "cost_min": "1.95",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "fb3437ef-2ea9-4d13-9f2e-2a9e36da2ce9",
    "name": "Stylish Tiger Dragon Marble Texture Printed Tempered Glass Phone Case for Samsung Galaxy S25 Ultra S24 S23 Plus S22 S21 FE Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b9/31/b9314bef69fa419ac89449ea4007b59e.jpg",
    "cost_min": "3.26",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "5f7eb118-ac14-4c76-bacf-74b4e69bf7cd",
    "name": "New 2cm Wide Fashion Laces Men and Women Sneakers Flat Shoes Casual Shoes Lace Length 100/120/140/160cm Shoelace 18 Color",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/35/c8/35c8629f4c2012e0bea71391a225eabd.jpg",
    "cost_min": "1.56",
    "categories": [
      "rts.shoeAccessories"
    ]
  },
  {
    "id": "774c9a08-ae06-424c-ae26-09bbd852668f",
    "name": "Women's Dance Shoes Soft Outsole Woman Breath Jazz Hip Hop Shoes Sports Sneakers Ladies Girl's Modern Jazz Dancing Shoes for Men",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/20/a2/20a265e7fd30dda2cf50eb207e9ef14f.jpg",
    "cost_min": "26.69",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "c55ee645-6383-4673-b5c2-c250e419a8d6",
    "name": "AWAYTR Punk Girl Fabric Hollow Elastic Headbands Metal Rock Personalized Hollow Eyelets Hair Band Casual Sports Grommet Headband",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b4/4f/b44fac95c5131207dd997c769a65afb2.jpg",
    "cost_min": "2.66",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "d3815230-e51c-4a3c-a200-8d8d93287950",
    "name": "1-5pcs 50W 5000lm Super Bright LED Bulb AC 110V 220V E27 LED Lamp Lampada LED Light Bombilla  Lighting Lamp for Home Livingroom",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/50/6d/506dc0c88ced08bbfc48af09142cba34.jpg",
    "cost_min": "2.88",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "24e42857-53eb-483c-ad0d-faec1aa63270",
    "name": "Customized Sweetheart  Appliques Sequined Wedding Dress 2026 Court Train Tulle Off the Shoulder New Style Ball Gown Bridal Gowns",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/62/59/6259ae145fba28ad97a7d93dd7275ad3.jpg",
    "cost_min": "291.41",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "5ff69c4e-8442-4074-b730-2ce93c7dfb99",
    "name": "1/2/3/4/5m Car Interior Led Decorative Lamp EL Wiring Neon Strip for Auto DIY Flexible Ambient Light USB Cigar Atmosphere Diode",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8f/79/8f79ec2d54ad1ef1094b8a274040cb86.jpg",
    "cost_min": "2.60",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "ec11faa1-abe7-4c59-bf47-f5b5ed3b8b58",
    "name": "Custom Gobo Advertising Light Rersonnalisé Outdoor Waterproof IP67 Image Rotation  Led Logo Projector on Shop Entrance Floor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/22/71/2271cf5262b50fe69be24b1ed33cd19d.jpg",
    "cost_min": "10.90",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "0fe60076-1fe8-4b52-ad6b-8b642df58e49",
    "name": "Long Vintage Women 2021 Spring Summer New 100% Cotton Loose Flower Embroidery Short-Sleeved  Ethnic Chic Blouse Shirts Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e7/16/e716f8fbca9252a039813df34fc60f94.jpg",
    "cost_min": "13.28",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "789e1f29-8779-48dd-aaea-f55586b6eb6a",
    "name": "Home & Office Desktop Pegboard: Height-Adjustable Standing Storage Rack for Supplies, Also for Decorative Figurine Display",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0c/fd/0cfdb8da83e2ceede1e2b3c524febb9e.jpg",
    "cost_min": "2.59",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "0471aaad-3c57-4931-85fa-c09d1f74a84e",
    "name": "Very Warm Cold Trench Coat for Women Ultra Light Women's Jackets Winter 2025 Long Down Jacket Lightweight Padded Trend Parkas",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9d/34/9d34bd9d5155589049fe1681a10b7984.jpg",
    "cost_min": "35.84",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "757c702c-401d-42a3-aca4-1b02f951050f",
    "name": "Halloween Spider Brand New Day BND Cosplay Costume Men Bodysuit Zentai Full Adult Party Jumpsuit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f7/05/f705bed984d687c6e79a566d6dc76913.jpg",
    "cost_min": "31.61",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "0973abd2-e3b0-4c34-a421-3d6220f57da1",
    "name": "Halloween Men TASM Spider Cosplay Costume Superhero Zentai Suit Adults  Boys Male Full Bodysuit Jumpsuit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/18/ad/18ad168843783500d596c0c06f47648a.jpg",
    "cost_min": "29.00",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "99fd7c19-dfae-42d3-a73d-3921d754e741",
    "name": "40-55cm Width 0.6-2 Meters Length Plastic Rattan Cane Webbing Roll Wicker Sheet Outdoor Chair Table Furniture Repair Material",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f2/fe/f2fe75e71e3a188eec1c639ea1c16339.jpg",
    "cost_min": "9.88",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "d5396ff3-8016-4919-a0b9-f267b663de06",
    "name": "Alphabet Letter LED Lights Luminous Number Lamp Decor Battery Night Light for Home Wedding Birthday Christmas Party Decoration",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7b/83/7b8311a118889051f18f83cdf1c9b827.jpg",
    "cost_min": "2.95",
    "categories": []
  },
  {
    "id": "d7812107-35f5-46fb-bebf-cb2d218a1b89",
    "name": "Business Aromatherapy Leather Case for iPhone 17 Air 16 15 14 Plus 13 12 11 Pro Max for Magsafe Magnetic Frameless Armor Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/63/5c/635c9e4525fc5382bbe2c9682b785f08.jpg",
    "cost_min": "4.23",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "5ad64fb9-7f3b-4d01-a852-2a75a2fc12fe",
    "name": "1pcs Men's Long-Sleeved Thermal Underwear Male Thin Tight Fitting Fast Dry Elastic Fitness Tops Man Autumn Winter Sprots Wear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1b/40/1b40451179a94c3b3271c64bf8601c18.jpg",
    "cost_min": "7.08",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "4e23cba7-c6be-40ff-afa7-8bb26d137e91",
    "name": "4/1pcs Long Christmas LED Candle Flameless Pointed Candle Light Battery Powered Church Flickering Candle Light Home Decoration",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/76/8b/768b699f115ce79cfb09644effd7e903.jpg",
    "cost_min": "1.99",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "f18dc6df-7e58-4f17-8c2d-4f749ab9006a",
    "name": "Transparent Sexy Lace Mesh Skirt Elastic High Waist Black White Tulle  Mini Skirts Womens Skirt  Korean Fashion",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4f/b2/4fb2afcc63eeecea64521dbef0cf1cde.jpg",
    "cost_min": "4.42",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "809b6d90-c73b-40d1-823b-86f894602093",
    "name": "Silicone Strap for Apple Watch Band 49mm 45mm 44mm 42mm 46mm 40mm 41mm Bracelet Correa iWatch Series 11 9 8 10 SE 7 6 5 Ultra 2",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c6/5a/c65a6f8d615c7ac854d1fea497f380d0.jpg",
    "cost_min": "2.90",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "bee91ed7-f927-4063-aca1-5b762a9723e2",
    "name": "Kids Handkerchief Scarves Vintage Cotton Hankies Men's Pocket Square Children Dog Duck Animal Fruit Handkerchiefs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c2/7c/c27cf14ef03d8b7bc5eec0ddac80ef8c.jpg",
    "cost_min": "1.83",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "113ffa68-5512-4af4-a22d-7acf72481d14",
    "name": "Protector Film for Apple Watch 44mm 45mm 40mm 41mm 49mm 42 38mm Curved Screen Protectors Iwatch Series 8 7 SE 9 Ultra 10 42/46mm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/22/fe/22fe40eb7962307e18a25001bc573893.jpg",
    "cost_min": "1.77",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "8d3aebce-9e4a-46cd-bf3b-add94723b4f5",
    "name": "40-55cm Width 100-500cm Length Plastic Octagonal Rattan Roll Furniture Chair Table Cabinet Door DIY Making Material Repair Tools",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/13/83/1383af3b5a53bda197eb845596d3648e.jpg",
    "cost_min": "14.59",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "89cc219f-4124-4661-8483-5524683f9fb1",
    "name": "Anti-Spy Tempered Glass for iPhone 13 12 Mini 11 14 15 Plus 16 Pro Max 17 Air 16e Privacy Screen Protector iPhone XR X XS 8 Film",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/45/4e/454ecdddcf371d0888fb75e973a7de6a.jpg",
    "cost_min": "2.95",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "1c80f3fd-6228-4207-8ca0-b73b8fe7f459",
    "name": "Personalized Dog Collar Name Carved ID Anti-Lost Solid PU Leather Collar for Small Medium Large Dogs Puppy Cat Pet Supplies Pink",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/74/7a/747ad3541ebced87cb5c8f4a5b42e262.jpg",
    "cost_min": "5.91",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "58b6e021-51c6-4d16-b79f-4a99114a0012",
    "name": "10 Pcs/Set Black Wrap Woven New Fashion Handmade Men Bracelets Male Women Leather Bracelets Men Bangle Wholesale Jewelry Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/83/5d/835d622e1840383dc4777dcf3172d2be.jpg",
    "cost_min": "3.04",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "707fe50c-778f-4455-90cd-3141318392ab",
    "name": "1-6mmBlack PVC Steel Wire Rope 304 Stainless Steel Handling Suspension Steel Cable Rope for Guardrail Suspension Handling 5-100m",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6b/97/6b975d352abf92561fa1d001b2d873f6.jpg",
    "cost_min": "7.50",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "65e717cf-3861-4fb9-878e-fae59f965bd4",
    "name": "10-100pcs 3mm/5mm/10mm Red/Green/Blue/Rgb White UV DC12V Round Pre-Wired Water Clear LED With Plastic Holder",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ab/dd/abdd91d546211edd3390735daf4ca369.jpg",
    "cost_min": "4.26",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "21be22b4-b17b-4904-bdcf-b29da35fa553",
    "name": "Led Floodlight 50W 100W AC 110V 220V Outdoor Flood Light Street Lamp Projector Exterior IP65 Waterproof Led Spotlight for Garden",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a1/b5/a1b5761afe30329e07ab3fc02394826b.jpg",
    "cost_min": "5.52",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "d5542416-c060-48ec-a7f2-2c6e412840a0",
    "name": "Linen Mens Shorts Newest Summer Casual Shorts Men Cotton Fashion Men Short Bermuda Beach Short Plus Size 4XL Joggers Male Hot",
    "staff_picks": [
      "bestseller",
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d5/83/d583a692876e12efa964fb951d446f30.jpg",
    "cost_min": "15.70",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "31c7a28f-d0be-408c-8d07-aa51fff01830",
    "name": "Long Wrap Pink of Shoulder Lady Girl Women Prom Dress Party Evening Dress Performance Dress Wedding Sand Bridesmaid Guest Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8d/a2/8da2216b17836325d370dfe015909417.jpg",
    "cost_min": "47.61",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0876a103-5142-444e-a138-b53b6125e389",
    "name": "Molten Basketball Size 5 6 7 Basketball PU Outdoor Indoor Balls Women Youth Man Match Training Basketalls",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/21/99/21994fb69a54c6387a5c85a2fd60509d.jpg",
    "cost_min": "22.07",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "8fbca513-809c-4ea0-8f43-789de43ad43c",
    "name": "ROSES a Line Fuchsia Formal Dresses Pleat Sleeveless Prom Gown for Woman Deep v Neck Wedding Party Dress Robe De Bal Customized",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5f/9f/5f9f648db5f9ec1cf19064960f1d3d99.jpg",
    "cost_min": "86.00",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2c059122-01b1-453d-803d-1c4a4f80c61e",
    "name": "12A Lace HD Transparent Frontal 13x4 Water Wave 4X4 Closure Human Hair Brazilian Loose Closure Deep Water Kinky Curly Straight",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f6/b9/f6b947991a9d61ecc94d9d34c51f958b.jpg",
    "cost_min": "13.65",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "3a63698a-257c-45e8-9317-9a12d9eb16fe",
    "name": "10pcs 0603 SMD Very Fast-Acting Fuse 250mA 0.25A 500mA 0.5A 1A 1.25A 1.5A 2A 2.5A 3A 3.5A 4A 5A 32V 0467 Series New Original",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/64/d2/64d259748d52a68a92fb9920d3786fdb.jpg",
    "cost_min": "2.73",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "d945db9c-5b63-4d19-bb0f-d813b1fdba3c",
    "name": "Quick-Drying Sports Towel 40x80/80x160CM Blue Grey Green Orange Swimming Gym Fitness Camping Running Beach Washcloth Towels",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/69/ac/69aca2e3af34ac4ed2324062df9970e8.jpg",
    "cost_min": "4.49",
    "categories": []
  },
  {
    "id": "51dadce3-51b8-4fb7-ad63-12f0ab56faaa",
    "name": "Women Puffer Jacket 15 Colors Plus Size 5XL 6XL 7XL 2025 New Spring Autumn Female Ultra Lightweight Packable Hooded Down Coats",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/83/f6/83f66772aa2afd2440e297df54f79f71.jpg",
    "cost_min": "42.48",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "1438ebc0-7720-4fd4-9528-2a3160240248",
    "name": "Sexy Rhinestone Crystal Mesh See Through Maxi Dress New Women Long Sleeve Birthday Night Clubwear Long Dress Wedding Party Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a8/22/a822d7bda0352febbe9e8d4ff2803660.jpg",
    "cost_min": "32.42",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0153ff3e-7599-4e43-993a-9e44a941495e",
    "name": "90x90CM Square Scarf New Luxury Design Popular Silk Style the Four Seasons Scarves Women Sunscreen Beach Kerchief Hijab",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e9/76/e976fbeff2b8a8a69b3f2ca3c5f2e3bb.png",
    "cost_min": "2.72",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "1fa5194c-0ee9-4364-a633-30a583284e72",
    "name": "Kids Gloves Waterproof Outdoor Full Finger Thermal Gloves Children Winter Snow Mittens for for 3-13 Years Old Boy Girl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b0/3a/b03a122a9684cad87fe937b847862252.jpg",
    "cost_min": "2.84",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "e3b8d6ab-e000-42e6-a13c-305131a514ef",
    "name": "Men Mesh Running Shoes Off-Road Shoes Sneakers Outdoor Breathable Trainer Race Luxury Shoes Cushioning Couple Non-Slip Fashion",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/95/fe/95fea216e181fcd34597a2acfd3ce218.jpg",
    "cost_min": "29.54",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "0702fdc8-948d-4f8d-bad0-df2c4ce28dee",
    "name": "One Pair Personalized Name Shoe Buckle Jewelry Stainless Steel Custom Nameplate Year Date Logo Shoe Buckle Best Friend Gifts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/12/3c/123ca2a7fa8b511216419a7b37ebc0ad.jpg",
    "cost_min": "4.79",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "d644c984-e988-4a16-b4c8-34fe2a7551e4",
    "name": "20pcs 18x5mm Stainless Steel Fish Enamel Charms Pendant Stainless Steel DIY Jewelry Making Accessories Findings",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/18/87/18878337171a82aa2db447dcd3ae1dff.jpg",
    "cost_min": "2.39",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "bd0394b3-43ec-495b-bc95-fd68e5cf2e18",
    "name": "VaneAims 5PCS LED Metal Indicator 6mm Waterproof Small Flat Led Panel Mount Signal Light 3-6v 12-24v Red Yellow Blue Green White",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/8d/c78da04ec065e628308e1c760d738df8.jpg",
    "cost_min": "3.89",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "557ba02e-c0d7-4c02-a64c-a5285aa4ba38",
    "name": "Pokemon Blind Box Figures Collectible Anime PVC Model Toys Pikachu Charizard Mewtwo Eevee Random Mystery Surprise Gift for Fans",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/22/3f/223fc463f3530004034e363200ef7e98.jpg",
    "cost_min": "4.36",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "3c206ee9-38d1-4c07-8151-5b154e8d4056",
    "name": "LAIZE Pneumatic Fitting Tube Connector Air Pipe Fitting Black Adaptors BSPT & G Threads With Gasket",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ec/88/ec88c74935e3e160f362f10cf1f6eec6.jpg",
    "cost_min": "0.53",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "14b5c602-424a-45cf-937f-ca58d4874fce",
    "name": "Customized Luxury V-Neck Appliques Sequins Ball Gown Wedding Dresses for Women 2025 Court Train Bride Gowns Vestidos De Novia",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/47/a3/47a3a06554bdf7f3cbcd6b489c88ad2e.jpg",
    "cost_min": "250.42",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "3ebd6a08-82c7-430e-9bab-ff36240020d9",
    "name": "Adjustable Elastic Ankle Brace Compression Sleeve Foot Support Stabilizer for Plantar Fasciitis Achilles Tendonitis Sports Sock",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6c/65/6c653e4a8ce49f9f57a50c0950596afd.jpg",
    "cost_min": "5.45",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "0069947c-b3fb-4115-9bcd-5cd81973b7d3",
    "name": "THURAM 8l/15l Outdoor Tactical Bag Backpack Sport Bag Pack Sling Shoulder Backpack Tactical Bag for Every Day Carry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/90/04/9004fb570d54c0058afd931f6b3041a1.jpg",
    "cost_min": "11.22",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "a7571511-5538-4c80-960c-ca157eec416d",
    "name": "2025 New Winter Big Natural Fox Fur Fluffy Puffer Coat Women Button Warm 90White Duck Feather Down Short Jacket Waterproof Parka",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2f/75/2f7569d108b79c325cd4888c919eccf5.jpg",
    "cost_min": "140.18",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7e56039c-8a57-42d4-8028-5251f93d867a",
    "name": "1-10pcs 3 4 5 6 8 Inch LED Round Panel Downlight Lamp 24W 20W 6W AC100-240V  3000K 4000K 6000K Light Spotlight Indoor Lighting",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/17/49/17493a810c6875da1a4e6298e74882ce.jpg",
    "cost_min": "2.86",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "7fcac567-81c4-432d-99e7-bcec1c0da7bd",
    "name": "KAK Magnetic Door Stopper Punch-Free Adjustable Zinc Alloy Door Holder Hidden Door Stop Floor Mounted Stop Door Hardware 6 Color",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6f/5e/6f5e4702363e0c268e13ebb9bddcd32a.jpg",
    "cost_min": "8.99",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "3070fccb-3216-4437-8497-418a1bff5fc8",
    "name": "Hiking 2pcs Cycling Anti Light Glasses Men Women UV400 Sandproof Eye Protector Shades Outdoor Sports Goggle Anti Radiation Lens",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/d7/c7d7ce7a629e482f0f3cc8c4dc255de7.jpg",
    "cost_min": "2.21",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "91b28bf8-fd1f-4017-85c0-46606bb2760f",
    "name": "Lagabogy Puffer Jacket Women 2025 Winter Naturally Warm Loose Waterproof Female StreetWear Duck Down Coat Real Raccoon Fur Coat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/0c/930c9d0404619b0b8643db20f1f561b8.jpg",
    "cost_min": "151.91",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "943366af-acbc-4438-806e-ff474dd9b587",
    "name": "530-127pcs Heat Shrink Tubing Sleeves 2:1 Polyolefin Set Shrink Ratio for Wires Cables Multicolor Sleeves",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2f/b5/2fb5aceb40ea63ed36d34175e4803784.jpg",
    "cost_min": "3.23",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "fb9b0262-3bee-41f4-b50f-92f5a8f29da5",
    "name": "1/2w 1W 2W 3W Resistance 1% Metal Film Resistor Assortment Kit Set 30values 1R~750R 1K~820K Ohm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f7/81/f78161de45a7a59278abcb05d032d55e.jpg",
    "cost_min": "3.86",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "e50d4b97-7d3a-4fae-bfce-207309eef6b6",
    "name": "Wearable Electric Breast Pump Hands Free Smart Suction Milking Machine Wearable Silicone Portable Baby Breast Milk Breast Pump",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8e/a1/8ea1c4df337f48de5bb8fb97798e47e3.jpg",
    "cost_min": "17.48",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "ad69852c-6130-4262-9c88-a020ac294a1e",
    "name": "FANGTUOSI Underwater Buoyancy Bar Diving Extendable Selfie Stick Tripod for Gopro Insta360 DJI OSMO Action Camera Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/12/4c/124cb445e283232ac06f0a44e4c5ca58.png",
    "cost_min": "8.77",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "b7405486-b440-4a31-b4bc-3c474973d063",
    "name": "NNBILI 3Pack Oleophobic Coating Dust Free Easy Installation Matte Screen Protector for iPhone 16 14 13 12 11 15 17 Pro Max Glass",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5a/dd/5addfc0468e2ddf23e024c3b158d4c62.jpg",
    "cost_min": "4.20",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "73f1a9b5-375f-49ab-8387-099dd3652d81",
    "name": "Waterproof Coating Sealant Agent Transparent Invisible Paste Glue  Adhesive Repair Home Roof Bathroom",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/25/4e/254ee146d9272d21db4fa40637f83d13.jpg",
    "cost_min": "11.36",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "c1124a5b-97e4-4f8c-900f-fee6313716a1",
    "name": "Varicocele Socks Compression Socks Halloween Skull Bone Bat Tooth Men's Sports Stockings Cycling Running Nurse Women Socks Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e6/21/e621f953ac68fd6ca9f5f253533968f6.jpg",
    "cost_min": "2.92",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "5883ae0c-1234-4c7f-bcc6-cddebe1986ca",
    "name": "Women's Perspective Mesh Half Skirt Single Layer Long Skirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ac/71/ac7118931e59fa06126bea31fd7388b4.jpg",
    "cost_min": "4.28",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "ce64fcea-d877-4928-bcce-9d3816552cc1",
    "name": "Black White Long Tulle Lace Mesh Skirt Women Petticoat Underskirt Summer Korean Irregular Cover Up Skirt Tutu Skirt for Girl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8a/8d/8a8d2a09e19573cd8e2557b1406edda5.jpg",
    "cost_min": "4.91",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0f5831a6-bc28-4395-a391-1d8b426506c4",
    "name": "High Quality Transmit Tachometer Sensor for NAVISTAR Truck 450590 556915C91",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/46/70/46706f189d8af525ce5528a28164d11d.jpg",
    "cost_min": "26.40",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "f371b6c3-c158-4b17-ad14-3ad8391c0f6c",
    "name": "100pcs 24 Colors Jewelry Packaging Bag 5*7 7*9 9*12 10*15cm Organza Bags Gift Storage Wedding Drawstring Pouches Wholesales",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1d/8d/1d8d7393ae3df768af96677f14dcea03.jpg",
    "cost_min": "3.94",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "47e44849-03df-4076-a071-36c081baf2a3",
    "name": "Orthotic Insole Arch Support Flatfoot Running Insoles for Shoes Sole Orthopedic Insoles for Feet Ease Pressure",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/12/af/12af8c89a80ebf0a5b4ca335edbdd8e7.jpg",
    "cost_min": "3.49",
    "categories": [
      "rts.shoeAccessories"
    ]
  },
  {
    "id": "60ddfe88-6924-414f-a697-4ea33f741984",
    "name": "Greatzt 10pcs Tlp627-1 Tlp627 P627",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/45/01/450127f59918807dfc5a02b08230bafc.jpg",
    "cost_min": "1.46",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "95f7f396-63eb-455b-bff4-e2c0eb797320",
    "name": "TOMZN TD9 1/2/3 LED Signal Indicator Light 230V AC/DC 9mm Ultra-Thin Type Red Yellow Green Din Rail Hospital Factory School",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ff/76/ff764d74d2000b4033a76ee4cdbf3b79.jpg",
    "cost_min": "7.18",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "066a5c34-9a66-49e8-b166-6ab097078ef2",
    "name": "White Logo Transfer Gold Metal Silver Mark Label Personal Mini 3D DIY Name Red Black Blue Green Rose Gold Brown Bronze Trademark",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b4/96/b496d08b01197eeed7324d8c6404fcf0.jpg",
    "cost_min": "29.81",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "ea4a093c-a57e-4b0b-9d2d-0fbf3d33390f",
    "name": "JOF 4 Braided X4 Strands 300M 100M Fly Fishing Line Multifilament Wire Pesca  10-85lb  Carp Sea Saltwater Weave Extreme Japan",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/64/a5/64a5733c82bf710c7e7049005ed530fe.jpg",
    "cost_min": "2.15",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "ef7fc2d5-d3f4-4b89-8fed-8cd929e75911",
    "name": "KCD1 KCD3 Light Button Switch Waterproof Illuminated Rocker Switch 12V 220V Lamp 2/3 Pin SPST ON OFF Car Dashboard Boat Marine",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ae/e4/aee499b11a48b3c981e254247872ad18.jpg",
    "cost_min": "4.89",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "7f5a20f4-9c16-4dab-8b5b-42d0bb0e5072",
    "name": "8Pcs 5x35x5mm Coated POM Engineering Plastic Wheel 625ZZ Bearing Pulley Nylon Small Wheel Rolling Guide Wheel",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d2/8f/d28f3e8db4f720004472e6189ab5c659.jpg",
    "cost_min": "9.45",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "59ce8966-88aa-4893-8da9-87b6a27720f4",
    "name": "Men's Two-Piece Summer Thin Section Senior Ice Silk Feeling Round Neck Solid Color Short Sleeve Suit Sports Casual Homewear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/49/ef/49ef7719acd1c09576d7fcdc53f628cb.jpg",
    "cost_min": "7.90",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "8cd94b7c-3aef-4792-960d-9843d9f6512d",
    "name": "50W 100W Aluminum Power Metal Shell Case Wirewound Resistor 0.01R ~ 100K 1 6 8 10 20 200 500 1K 10K Ohm Resistance RX24 Hjxrhgal",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1f/e7/1fe784edf8a94a0981cdb122c82d9254.jpg",
    "cost_min": "1.79",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "741ee737-9a00-4559-9b15-7865b0996483",
    "name": "Lagabogy 2025 New Winter Women Big Real Fox Fur Collar 90%White Duck Down Coat Female Streetwear Loose Hooded Warm Puffer Jacket",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2f/8d/2f8d847c730414dda3a76d7b54c55d25.jpg",
    "cost_min": "161.06",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2086b9f1-4c77-4a80-90a8-729fe542654e",
    "name": "Customized Elegant Long Sleeves Evening Gowns Neck Appliques Beading Tulle Pink Floor Length Women Dresses Formal Prom Gowns",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/21/ce/21ce8e78a05584730bb39b96303c4c27.jpg",
    "cost_min": "89.36",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "968e9432-f8fe-427e-95c6-64046218a3f9",
    "name": "Super Strong Magnetic Pocket Metal Magnet Check Car Keys Keychain Split Ring Keyring Hanging Holder Hooks Portable Outdoor Tools",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6c/64/6c6467e2e0583d831825be9ae007c87e.png",
    "cost_min": "2.45",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "70a817b8-903f-4686-8ff1-305f0e863165",
    "name": "Men's Sports Suit MMA Rashgard Male Quick Drying Sportswear Compression Clothing Fitness Training Kit Thermal Underwear Leggings",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0e/a8/0ea8ec768d96fa96281f5c973577eab9.jpg",
    "cost_min": "14.49",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "31f87928-8407-4cfb-a5cc-21e541a4db12",
    "name": "New Suzuki Men's Hooded Sweatshirt Street Fashion 3D Printing Casual Fashion Sweatshirt Outdoor Sports Motorcycle Suzuki Enduro",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/10/63/10630cd97f9a945aef93ec31aafe2f62.jpg",
    "cost_min": "11.58",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "80b15013-e084-45cb-aeda-2407637ad19f",
    "name": "10pcs Bulk Purple New Jewelry Gift Candy Display Packing Storage Bags for Wedding Travel Drawstring Dust Velvet Ribbon Pouches",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/df/44/df44222fa577f34d2f9f0d3261af7fc6.jpg",
    "cost_min": "60.00",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "2d901fe5-55ca-4562-b230-2e6219bc6533",
    "name": "Mini Micro 25mm/1inch Gage Manometer Pressure Gauge Compressed Air Hand Pump Diving HPA Regulator M8*1 M10*1 1/8npt 1/8bspp",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/dc/43/dc43640f2ccde7d1583b79b373e5791a.jpg",
    "cost_min": "3.49",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "e7502579-0d5d-487c-832f-ec280602a4a5",
    "name": "45 Pcs/Lot Kawaii Cat Dog Daily Life Paper Small Diary Mini Cute Box Stickers Set Scrapbooking Flakes Journal Stationery",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/41/90/419036a3b91d1a2eb606adf3a69b1fe8.jpg",
    "cost_min": "1.52",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "8fc5d43e-4d74-4f07-83f9-5cb844775d70",
    "name": "New Pearl Hairpins Korean U-Shaped Metal Shell Hair Clip Pins Women Girls Hair Sticks Bun Maker Hair Styling Accessories Gifts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b1/13/b113c58f7137f6009a7e733d255c2b7a.png",
    "cost_min": "1.87",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "acc3ec0c-ab9d-48d8-98a6-4ad1bc1000a0",
    "name": "Solder Seal Wire Connectors 3:1 Shrinkage Rate Waterproof Electrical Cable Terminals Heat Shrink Tube Electrical Butt Splice",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/16/97/1697e0d044ea77969f77bf11dd2285fb.jpg",
    "cost_min": "2.06",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "982d9826-42ab-4545-b468-724caceb2437",
    "name": "Janveny Large Real Natural Fox Fur Collar 90% White Duck Down Jacket Women 2025 Winter Puffer Coat Female Parkas Waterproof",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/41/93/4193ed0aafc10ae08fa24b099fe251a9.jpg",
    "cost_min": "174.88",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "96f40108-4d22-4fd2-b34c-e5274099f489",
    "name": "For NAC3FCA NAC3FCB NAC3MA 3Pin Powercon Connector 20A 250V Power Male Plug Adapter for Stage Light LED Screen Audio Equipment",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/39/21/3921d9bdb0e061aa62d1415e9f650abb.jpg",
    "cost_min": "3.07",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "3950a8f6-3281-4e73-89e2-924ac9ef26d2",
    "name": "1Pcs Golf Ball Mark W Magnetic Golf Hat Clip Mark for Marking Golf Balls Position Two Styles Magnetic Alloy Golf Marker Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b4/b2/b4b217397bb3307098e517d458d129c1.jpg",
    "cost_min": "2.65",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "8555dfa7-7007-4420-8639-785a6eeface2",
    "name": "20Pcs 1206 PPTC SMD Resettable Fuse 50mA 100mA 0.1A 120mA 160mA 200mA 0.2A 0.25A 0.35A 500mA 0.5A 0.75A 3216 Self-Recovery Fuses",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f2/96/f296888e25b787975da2bb74eacbf7eb.jpg",
    "cost_min": "1.97",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "69def9fb-c532-464f-b738-fed73dc38329",
    "name": "1-5Pcs Ultra Clear Tempered Glass for iPhone 17 17Air 17ProMax 17Pro Rear Lens Film HD Camera Protective Tempered Glass Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7b/39/7b39baef571cb7678df6b7d6fc4766cc.jpg",
    "cost_min": "1.87",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "e22ab64b-6cff-437b-a244-8ea51c859e18",
    "name": "Summer Hot Sale Yoga Leggings High Waist Breathable Quick Drying Yoga Pants Fitness Running Cycling Workout Gym Clothing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7f/10/7f1028a2948f286ead9bd7ef14c50be9.jpg",
    "cost_min": "6.40",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f4b295f1-172b-41a5-9a0f-10636748ca44",
    "name": "Womens Bloomers Maid Ruffle Pumpkin Pants Shorts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9c/3a/9c3ac83c337548a72a0ebf2875f6150e.jpg",
    "cost_min": "4.40",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "ae555bad-84f5-456c-ba31-6224f71d6bbd",
    "name": "4 6 8 10mm Czech Rondelle Crystal Beads Faceted Glass Beads Bulk Wholesale Loose Spacer Bead for Jewelry Making DIY Needlework",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f6/13/f613f6cd0084a36c47459c3f1b0e27bc.jpg",
    "cost_min": "1.80",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "0224806c-7ee7-446a-bde9-b922d239dd3e",
    "name": "1pc Clear Acrylic Display Case,Display Box Stand With White Base,with Door, Dustproof Protection Showcase for Collectibles",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d9/f6/d9f6e4c978ebca38fed82f6b88b28284.jpg",
    "cost_min": "6.05",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "a23d9ab2-6423-41db-9e15-6895d1db5835",
    "name": "High Quality 100% Pure Cashmere Scarf+Gloves+Hat 3-Piece Set Men and Women Winter Warm and Fashionable Hat Touchscreen Gloves",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/91/e0/91e0f96cf6dd746c62d725c93ed1a99d.jpg",
    "cost_min": "50.04",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2aaae93d-3066-4fdd-90a7-6005d0c5a97d",
    "name": "Pokemon Psyduck Anime T Shirt Men Women Casual Cotton Short Sleeve Tee Top Summer Y2k Streetwear Graphic Print 2026 New Cartoon",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ad/ed/aded9de9cd91b9d5dab3833ebebd3e1a.jpg",
    "cost_min": "5.95",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "ced2940a-7865-4160-ad11-0feb732f8c15",
    "name": "Tempered Glass for iPhone 14 Pro 15 16 17 13 12 11 Pro Max Screen Protector for Iphone 15 Pro Mica for Iphone 13 14 Pro Glass",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/03/b4/03b405e5cdd04c2f1dbc421220407aa8.jpg",
    "cost_min": "2.63",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "30b95356-21a8-4893-9794-8054dcab4cfb",
    "name": "Women Seamless Hip Lifting Women Sports Leggings High Waist Fitness Leggings Push Up Yoga Leggings Gym Clothing Sports",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c1/e6/c1e6edca581bf9b6d7edb8ea2abb8561.jpg",
    "cost_min": "7.21",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "ba70f371-e57c-42ea-8765-7f2d696f0c5d",
    "name": "2025 New Fashion Knitted Good Elastic Real Fur Scarf Hat Sets Women Winter Warm 100% Natural Rex Rabbit Fur Scarves Hats Sets",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e5/66/e566df339d75dd4041fb46906173c1c9.jpg",
    "cost_min": "9.37",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0675ca59-3970-4d63-babc-f979719c26e8",
    "name": "10pcs/Lot Drawstring High Quality Velvet Bag Short Plush Multi-Color for Jewelry Packaging Christmas Wedding Jewelry Gift Bags",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ca/e3/cae3604b4012d1b502f37c456b3a98de.jpg",
    "cost_min": "1.91",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "ee34efdc-2a4e-43d6-b784-f00f054a1da6",
    "name": "5Pcs 8x24x7mm440 Stainless Steel U-Groove Bearing Steel Wire Rope Wheel Rust Proof and Waterproof Round Belt Idler Wheel",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5c/74/5c74568586b309dfea21fe1fb454b576.jpg",
    "cost_min": "9.45",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "3319b8b9-982e-427e-9248-db32ee335389",
    "name": "Custom Name Bangle for Women Stainles Steel Open Bracelets Girl Jewelry Personalised Double Name Couple Bracelet Christmas Gifts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/25/3f/253f1aa86675939b26d4fe36359e82f1.jpg",
    "cost_min": "3.52",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "10181109-3ab4-4784-b9c2-477015250836",
    "name": "Matelion 200M Diving Case 40mm Fit NH35 NH36 NH34 GMT ETA 2824 PT5000 Watch Case Jubilee Bracelet Sapphire Glass Slide Buckle",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/10/c0/10c0b22b3499d6d096c9d7a06366c13f.jpg",
    "cost_min": "37.85",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "ffb321bc-bf92-4a8f-a7fe-73f6cd3b678c",
    "name": "5/10pcs 12mm Auto Car LED Illuminated Toggle Switch ASW-15D SPST 2 Position 3pin ON OFF 12V 24V DC Red Green Blue Yellow White",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1c/3d/1c3d141afe4d7ab4f8bf5f6d90571901.jpg",
    "cost_min": "15.02",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "e13cf52a-0c50-4e16-9463-fa45204ab5a2",
    "name": "Personalised Initial With Name Monogram Luggage Tag PU Leather for Suitcase Baggage Handbag Tags Travel Bag Label Tag Best Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3c/67/3c676e0ed7b800b7265f426235cedebd.jpg",
    "cost_min": "2.72",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "9baa708b-d585-46d3-a31b-d5cdc472c25f",
    "name": "10mm Diameter High Temperature RFID NFC FPC Tags NXP NFC213 Mini Cards 13.56MHz Anti-Fake Anti-Metal Passive RF Card",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7d/2a/7d2a789ae218df1f5bc3f34779be4162.png",
    "cost_min": "9.31",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "3f3aeff2-a44d-4d98-99f9-9cbb2604e509",
    "name": "5Pair/Lot New Boy and Girl  Baby Socks Thick Newborn Autumn and Winter Warm Foot Sock",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/69/86/6986c76551d7b42eb7db4af58661fc77.png",
    "cost_min": "5.86",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "94e22cfc-2e0f-418a-8987-415519794d4d",
    "name": "Luxury Magnetic Matte Soft Phone Case for iPhone 17 Pro Max Air 16E 15 14 13 12 11 17 Shockproof Magsafe Wireless Charging Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7b/bb/7bbb38b9b36d88ebe044f1a583639ae6.jpg",
    "cost_min": "2.26",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "6e35ecb0-7ccc-470e-8399-712981a132af",
    "name": "Men PU Leather Jacket Motorcycle Fashion Slim Fit Leather Coat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9b/b8/9bb8f6a9899d0095760c7a7a72afae6e.jpg",
    "cost_min": "9.47",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "e959dc5b-ff28-4cd6-a183-8f7ea6e582b5",
    "name": "Portable Pool Heater Water Heating Boiler Swimming Solar Bath Tub Immersion Hot Fast Automatic Power Off Intelligent 2000W",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3e/05/3e05e28a2d72f203880e2df4942fc257.jpg",
    "cost_min": "10.69",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "5ce90ea7-1d24-4810-a5b6-6329f068d474",
    "name": "Customized Name PU Leather Men's and Women's Laptop Case Bag 13/15 English Computer Stand Computer Bag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b5/74/b574aeb4c0dbe6fa4e99f322d412e5f0.jpg",
    "cost_min": "9.42",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "006d6237-8d94-4b89-98e2-60880039619e",
    "name": "OTAUTAU Children Sofa Small Cartoon Couch Child Cute Chair Pouf Ottoman Princess Seat Futon Bear Armchair Kids Furniture SF165",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/44/4a44176f8084dd1aedfed8db6ed2aebb.jpg",
    "cost_min": "17.39",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "d0b2d574-d524-4a88-a6b3-362c49d3c710",
    "name": "15-Pack Hydra Tips Hydro Face Peel Tips Large Blue Clear Small Teal P/N 74111-15",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/bc/9e/bc9eae33b248df94481abea86483114b.jpg",
    "cost_min": "9.68",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "b510724d-5a64-4d47-ad73-3edbd854aeae",
    "name": "2pcs Couple Lock Key Heart Puzzle I Love You Pendant Couple Necklace Pendants Necklaces for Lovers Valentine's Day Jewelry Gifts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ef/11/ef117f91c9ef3e80c300f90c5159316b.jpg",
    "cost_min": "2.43",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "a4448a92-8165-43bc-b9cd-5c440acc5894",
    "name": "Sexy Mesh Transparent Stones Bodysuit Birthday Party Outfit Rhinestones Rompers Women Singer Team Dance Pink White Blue  Costume",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fa/0f/fa0f5fd8ee6e6491a4acb9f1f7280e5c.jpg",
    "cost_min": "93.98",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "eb2a705d-6337-4b41-8733-743e820f543b",
    "name": "Silver Color Square Signet Ring for Men Women,Brushed Stainless Steel Ring Band Ring,Basic Chunky Ring Thumb Ring",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/17/bf/17bf17fc13153a641da62c05edcd557d.jpg",
    "cost_min": "3.71",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "37029e98-64b5-4cfa-adf3-836ef61f4602",
    "name": "QY6-8001 QY6-8017 Canon G3100 Print Head for Canon Pixma G1100 G2100 G3100 G4100 G1110 G1111 G2110 G2111 G3110 G3111 G4110 G4111",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d3/e9/d3e929ab8cbeae7d1c6b5018db6f35fd.jpg",
    "cost_min": "21.15",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "97977f0f-93ff-4013-a3e9-37d4e5a71ebe",
    "name": "Swimming Goggles With Waterproof and Anti Fog High-Definition Professional Diving Goggles for Adultboys and Girls Swimming Sport",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ed/ef/edefa1418cc212fa9b170d8226e10572.jpg",
    "cost_min": "4.80",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "056c9c13-133a-4806-83ee-318b321f77a4",
    "name": "Quick-Dry Microfiber Towel - Ultra Absorbent, Compact & Sandproof for Gym, Beach, Travel & Swimming, Lightweight Sports Towel",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9c/95/9c95cf371eef564be424d7ff45d96604.jpg",
    "cost_min": "3.28",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "fee2d917-cfb9-4d88-87ef-cc8f49cb8369",
    "name": "For iPad Keyboard Case for iPad 2024 iPad Air 11-In 13-In M2 Pro 11-In 13-In M4 Pro 11 12.9 10.2 9/8/7th 10.5 9.7 Air 3 2 Case",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fb/25/fb2585f43edf14cd32275bfe82fddd6d.jpg",
    "cost_min": "11.92",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "5cee701a-cc16-4656-a078-25315fa98893",
    "name": "2025 New 0-12 Months Baby Boots Cowboy Boots High Top PU Leather Boots Embroidered Baby Boots",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c2/85/c285218ac30edc8368e656d4cab10139.jpg",
    "cost_min": "4.92",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "26fc1463-d5a4-4ca0-8be1-609597cf0841",
    "name": "New Women Solid Color  O-Neck Long Sleeve Hoodie Sweatshirt Fashion Ladies Streetwear Slouch Pullover Jumper Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8e/03/8e03abd5e00fd68a1dfc0f361134915d.jpg",
    "cost_min": "4.85",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "544d95c8-7579-4a11-bf54-086b3f997ad7",
    "name": "40pcs/Bag Vintage Ginkgo Leaves Flowers PET Sticker Package DIY Diary Decoration Sticker Album Scrapbooking",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0c/9a/0c9a7127b7c736a0dc84929dfc534706.jpg",
    "cost_min": "1.33",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "641376d5-192d-4fc9-9fc2-52b0bcfea04a",
    "name": "22 Inch Brown Blonde QVR Afro Kinky Bulk Hair No Attachment Afro Curly Bulk Human Hair Remy Dreadlock Natural Color Braids Hair",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/17/00/17002bc8c1612da1d5ab069163c302b5.jpg",
    "cost_min": "20.22",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "78ab09bd-fb88-4a55-b964-9682ea12c1b5",
    "name": "Diffused 5mm Led Diode Kit White Red Green Blue Yellow Orange 2V 3V Bulb Light Emitting Assortment Set Diy Arduino Pcb Circuit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/dc/5c/dc5cb6bbf5ad7fecc0fe4e740dfd86b3.jpg",
    "cost_min": "3.76",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "2a20e03d-a947-4652-b000-5bbdb226e586",
    "name": "African Men Clothes Smart Causal Customized Slim Fit Fancy Suit Blazer Jackets Formal Coat Business Dashiki Party Wedding WYN530",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fc/7f/fc7f2c83f8901ef657ca58e003ab7496.jpg",
    "cost_min": "36.70",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "03283a35-7c27-4c79-8b0a-0f5395f7cbbe",
    "name": "10~100pcs Rose Artificial Flowers Foam Fake Roses Wedding Bouquets Centerpieces Mothers Day Valentines Gifts Party Decoration",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/67/2e/672e88f3ab8c33c5f0a496dd457a3c25.png",
    "cost_min": "2.17",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "f4f2396c-0c7a-4726-94b7-6bd470d7da47",
    "name": "Blue EPLUS Universal Silicone Tubing Hose 90 Degrees Big to Small Connector Car Intercooler Turbo Intake Pipe Coupler Multi Size",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/39/62/396221d97582d77b3a4e0228ddaae104.jpg",
    "cost_min": "6.41",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "8f9ef2b0-03d1-4c4a-848f-5c8c31ebc6b4",
    "name": "5.5* 2.1mm 1 to 2/8 Way 5V 12V DC Power Splitter Cable Power Adapter Connector Cord for CCTV Security Camera LED Strip Lights",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7b/86/7b86a018df0baa3f5a28d121a401e98e.jpg",
    "cost_min": "6.21",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "6c94c1d6-dcba-413d-be54-aa7d5a7b9411",
    "name": "BT Mobile Head Phones Over Ear Phone Stereo Music Headset Over-Ear Headphones",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/dc/61/dc61cb6d25077ece25d8bf0f5d740a86.jpg",
    "cost_min": "11.99",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "3ac530f8-7cc6-472f-a9fe-3524a57e9862",
    "name": "Winter Custom Mens Hoodies DIY Logo/Graphic Autumn Fleece Warm Sweatshirts Casual Oversized Pocket Pullovers Basic Male Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/be/15/be1533457399cbf4d04bb92130ac2cbc.jpg",
    "cost_min": "16.03",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "c0c0b310-be77-4e56-a286-da1d0701899a",
    "name": "JayCreer Impeller Removal Tools for Yamaha WaveRunner / Sport Jet Boat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e0/0b/e00b8f7a7ebdcac39d12b8cf3d43b5b1.jpg",
    "cost_min": "23.22",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "7095cb01-5230-41f8-a5d0-3773a012f5ac",
    "name": "Black White Gothic Punk Anime Thin Soft Gloves JK Girls Mittens Oversleeve Man Women Cuff Fingerless Arm Warmers Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3f/00/3f00404ef8eea85771839f93466fbe3c.jpg",
    "cost_min": "2.44",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "12e260e0-eccb-490c-9257-04e1b3aa13a3",
    "name": "JayCreer 1/2-Person Paraglider / Paramotor Compress Bag Tube",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c0/16/c016e589623363cfbfa3a467dad7f884.jpg",
    "cost_min": "36.55",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "fe3ca158-5f20-4407-9b70-4e4d76d3226f",
    "name": "Men Jeans Long Pant Denim Flare Pants Hole Straight Trousers Slim Fit High Waist Casual Button Pocket Splice Autumn Winter",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/71/fc/71fc81a0571dc7a33cabe95a3b2cf89e.jpg",
    "cost_min": "10.59",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "e9d8cbf4-b9bc-42c1-8369-8be14ca394a2",
    "name": "Customized Letter Crocodile PU Leather Men's Laptop Case Bag 13.3/15.4 Pro Laptop Stand Cover Case, Unisex",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d7/ee/d7ee7f9744cd68b7f24f3f63c1fb2db9.jpg",
    "cost_min": "9.69",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "65299231-3abc-4de2-a426-63804f548853",
    "name": "Baby Peeking Maternity Tshirt Funny Zip Print Trendy Mom Plus Size T-Shirt Summer Fashion Pregnant Woman T Shirts Pregnancy Tees",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ee/81/ee81229bf24f89233900fcc4216ae014.jpg",
    "cost_min": "11.78",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "59499336-2e77-45fe-bcf6-aa42ded7ece9",
    "name": "Winter Warm Dog  Clothes Designer Fashion Dog Cotton  Color Block Pet Coat for Small Dogs Chihuahua Puppy Costume Windproof",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7f/6c/7f6c451534ef95764f5e611d2e5babd2.jpg",
    "cost_min": "8.63",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "80dab514-d806-4793-b37a-5b9aef80772e",
    "name": "1 Pcs Cake Cabinet Glass Hinge High Quality Punch-Free Wine Cabinet Cabinet Glass Hinge Furniture Hardware Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ce/8e/ce8eadc12daa2d02f5f7f71df6362d6b.jpg",
    "cost_min": "8.56",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "9f37ff05-a292-4a18-a5c4-5612d93dd8d5",
    "name": "Customized Name Set, Unisex Safiano PU Leather Passport Holder and Luggage Tag Gift Box",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f3/c5/f3c51d812f5e1dc1d6b24b4d02829463.jpg",
    "cost_min": "7.98",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "ad3dcce9-93ad-47c4-8dea-4ada49141017",
    "name": "Solid Color Sleepwear Silk Satin Pajamas Couple Set Long Button-Down Pyjamas Suit Pijama Women Men Loungewear Plus Size Pj Set",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e5/0d/e50d86a6b40d7fc73d10410300e31f8a.jpg",
    "cost_min": "11.49",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "aaaf2617-caa1-4702-9e64-f808da02ede5",
    "name": "1Pair  Plantar Fasciitis Splint Night Compression Sock Heel Supports for Heel Pain Plantar Fasciitis Support Foot Braces",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/df/4e/df4e1c488b363a50da070fd1b81d8109.jpg",
    "cost_min": "4.64",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "5e2b93ee-14f3-4c20-8d05-119636b5741a",
    "name": "20mm Strap for Amazfit GTS 4/3/2e/Mini/Stratos 3/2 Metal Magnetic Loop 22mm Watch Bracelet Amazfit Gtr 4/3/Pro/2e/Bip-U-S-Lite",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/34/a1/34a124c40557be9c384e47559e0cda59.jpg",
    "cost_min": "2.26",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "ce7d59cf-4faf-4200-85e2-30e8db34547d",
    "name": "10pcs Plastic Square Table Feet Cap 50x50mm Black Tubing Insert Plugs Hole Cover Chair Anti Slip Feet Protector Pads Home Decor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5f/0d/5f0dfb7130ff9c4ea883e6d62930fb51.jpg",
    "cost_min": "2.60",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "68de8a58-c470-46da-8bc0-39a1bfe0599e",
    "name": "Long Sleeve A-Line Wedding Dress 2026 Vintage Appliques Sweetheart Customized Bride Gown Princess BECHOYER T203 Vestido De Noiva",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/50/20/502024b937d3f0b90921f56531965a1c.jpg",
    "cost_min": "389.00",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "e054e527-6619-4460-9273-fc4499c9e5c0",
    "name": "2025 New Summer New Shock Absorbing Casual Sports Shoes Off Road Running Men's and Women's Shoes Fashion Trend Golf Shoes 39-45",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/53/43/534393a5ef564f4b76e3647f0d6d8c57.jpg",
    "cost_min": "25.39",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "c2d85f60-c6cf-4ce7-b327-5870f23fddde",
    "name": "AC 110-240v DC 12V 1A 2A 3A 4A 5A 6A 8A Universal Power Adapter Supply Charger Adaptor EU US UK AU for LED Light Strips",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e7/00/e700c171d618d4549d3b5eeab0510aee.jpg",
    "cost_min": "12.14",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "f26a2e61-4dae-4b06-98a2-b501f843adb4",
    "name": "Mannequin Head With Hair 100% Real Human Hair 10-18'' Cosmetology Mannequin Head for Styling Practice on Braiding Manikin Head",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a6/81/a6815ce7c2b7f81a4978cda2f8940b9d.jpg",
    "cost_min": "3.20",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "839f474b-7bee-4746-9db5-a8bccea36b92",
    "name": "Plus Size Ombre Cut Out Cami Top Casual Crew Neck Sleeveless Top for Summer Women's Plus Size Clothing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4d/21/4d218639d8f2a480b27829c724e5898a.jpg",
    "cost_min": "7.59",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "cd7de566-0321-49f2-b7ac-a0685ead40ee",
    "name": "1pcs 3D H Custom Badge Decal for Honda Civic VEZEL CRV City Accord Fit Odyssey Car Hood Front Grill Rear Trunk H Logo Sticker",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/56/3f/563f0d23c09240e5fad52d6a6e2e0770.jpg",
    "cost_min": "6.55",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "7ae0c2ab-f751-40fe-9d7d-5a16135dcff2",
    "name": "Kpop Stay Karma Album Fans TShirt Felix Bangchan Hyunjin Streetwear Casual Sport Oversize Short Sleeve Men's Clothing T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/31/c4/31c4ed939824ed25b93aeb87331e5847.jpg",
    "cost_min": "6.38",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "458dad87-53d3-40ea-818f-4fb5064dc168",
    "name": "Baby Romper Newborn Baby Boys Girls Clothes Gold Daddy Is My Hero Funny Print Infant Baby Jumpsuit Cute Casual Baby Bodysuit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c0/3c/c03c0e975c0bc331e021267af09aa127.jpg",
    "cost_min": "3.97",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "741a83df-4ce0-4f28-9f10-e707127a6af3",
    "name": "Mongolian Fur Coat Fur Jacket Women's Elegant Fluffy Solid Color Thickened Thermal Long Sleeve Coat Winter Fashion Oversized Lad",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c2/1d/c21db017b0f6cfbce7055369dfe68d2b.jpg",
    "cost_min": "238.61",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "3bbb3492-bd45-428f-8ca6-bd35fde43896",
    "name": "130x5cm Tassel Europe Spring New Cashew Nut Women's Decorative Small Silk Scarf Hair Band Binding Bag Handle Ribbon Small Scarf",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/03/18/0318376b0741a8c0dd4457043cc7f2f3.jpg",
    "cost_min": "6.37",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0e45deaf-3099-4eb2-9aab-15a4bee8d674",
    "name": "ZHONGYAN TAIHE 2000 Pcs Acupuncture Needle With Tube 4 Boxes 500Pcs/Box Disposable Sterile Sharp Needle Beauty Massage Needles",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/45/ca/45ca96d945a8731fcaa713de7f82302f.jpg",
    "cost_min": "33.93",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "ca0f74e7-e760-42c9-ac69-a13813f1d6b5",
    "name": "CoastFlex Sport Olivia II Leggings",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/56/c7/56c7faa72575c7e9a5d45a84b03f77ba.jpg",
    "cost_min": "36.00",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "f465eb28-2165-46c9-81ea-ade1b4c67e74",
    "name": "Women's CoastFlex Turtle Bay Capri Leggings",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/de/07/de075e54135e9f9da3679f25a392ffe3.png",
    "cost_min": "27.00",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "bed0f3de-2052-454f-acae-0b447ccb4121",
    "name": "Golf Ball Marker Alloy Mix Various Styles Men Women Golf Hat Clip Golf Cap Clips Mark Golf Supplies Accessories Drop Ship",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/49/fc/49fc84463e8603e9b57f0f1415c43727.jpg",
    "cost_min": "1.68",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "b2aca3c2-95d2-40ae-864a-66452aca9d64",
    "name": "Camisole Dress Sexy Sleeveless Women Denim Dresses Solid Spliced Sheath Slim Washed Distressed 2025 Summer Wrap Buttocks",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6b/a9/6ba98bad983829629c9418ce40d143ef.jpg",
    "cost_min": "16.95",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0ec3c4a2-d67a-4b8a-8858-5f3842114937",
    "name": "2000/2500w Heater Water Boiler Heating Pool Swimming Hot Fast Boiling Water Rod Automatic Power Off Stainless Steel Heating Rod",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a1/55/a15585eb2b926d186bb44387de68c91d.jpg",
    "cost_min": "10.54",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "e81ea257-b381-429c-a279-8dc2eb0608f0",
    "name": "8/40m Disposable Self-Adhesive Collar Stickers Women Men Hat Shirt Collar Neck Liners Pads Clear Tape Absorbent Sweat-Removing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6c/7e/6c7e21add705140ae49b14e46fb94579.jpg",
    "cost_min": "2.39",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "e114b546-211f-4820-a7f0-6b1a17dd872a",
    "name": "Leaf Corner Punch for Scrapbooking - DIY Paper Hole Puncher Craft Tool, Card Making Corner Cutter for Photo Albums",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d0/4a/d04aa7837068af7bd48a5cc951718b4c.jpg",
    "cost_min": "5.62",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "c7c8e927-ddfc-4b03-86be-805ff63de00a",
    "name": "OTAUTAU Portable Round Pouf Chair Rack Bean Bag Cover Without Filler Newborn Photography Accessories Props Ottoman Puff DDSY001T",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0a/b4/0ab491092d61ec0c8d34f4cf11e00783.jpg",
    "cost_min": "55.57",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "373157b3-b693-4c6c-a4de-65507f408992",
    "name": "Advanced Skin Regimen Kit (5-Piece Set)",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5d/23/5d23591ca2d00066566e7117f261cf38.jpg",
    "cost_min": "35.39",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "d2fe88f1-614a-4607-9120-8d6d315290eb",
    "name": "Sparkly Tulle Prom Dress Princess a Line Performance Dresses for Women Floor Length Birthday Gown 15 Quinceañera Graduation Gown",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2c/8c/2c8c2c95be8f7259450284a30653561e.jpg",
    "cost_min": "38.94",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "e72b2bb9-3e6b-4e9b-9cc9-5b589434ae2f",
    "name": "1PCS Applicable to S*hindler Elevator3300 3600 5200 5500 Elevator Sliding Guide Shoe Lining Length100mm Guide Rail Thickness16mm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0b/ab/0bab6a589898003e83d58a81124289af.png",
    "cost_min": "4.04",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "95ebc999-9278-4bf0-97fc-d43bb0d48b9c",
    "name": "50Pcs/Bag Colorful Basic Nylon Ealstic Hair Ties for Girls Ponytail Hold Scrunchie Rubber Band Kid Fashion Hair Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f7/a0/f7a02a37a6c0ac52533526b43a5e94a7.jpg",
    "cost_min": "1.45",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "5b0f5b73-356b-4c20-bd40-aa6c6309286c",
    "name": "Face Mask",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/19/c719fa980a650bbc3427f2523626cff2.png",
    "cost_min": "11.99",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "535d5c61-7b5e-4423-938e-539b0a8654f4",
    "name": "Girls Mesh Blouses Tees Female Autumn Transparent Full Sleeve Elegant Stretchy Turtleneck Shirts Tops Undershirts for Women",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ca/7e/ca7ede6da550386429380881ad8e25dc.jpg",
    "cost_min": "6.00",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0adf94bd-1f9c-4e8a-a689-71138d44cdfc",
    "name": "Girls Women Ballet Slippers Ballet Shoes Adult Split Sole Gymnastics Training Shoes Canvas Soft Kids Ballerina Dance Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d5/b9/d5b9ae37e515534a74738a6bf05313c7.jpg",
    "cost_min": "4.58",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "cbe2eb44-faef-4b55-b866-ede760e46e8f",
    "name": "A-Line Wedding Dresses Sweetheart Collar Bridal Gowns Mopping Length Lace Sleeveless Ball Vestidos De Novia Customized",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/11/30/1130263d8ac755f9dabf2934bc490e41.jpg",
    "cost_min": "99.29",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "c84b01aa-1874-438b-b54f-7d468d285a0e",
    "name": "99% Alumina Content High Purity Melting Crucible,High Temperature Resistance to 1750℃ 3-5000ml Multiple Capacities for Lab Use",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ea/17/ea178c28478a52b6687b57620f00e6f1.jpg",
    "cost_min": "2.44",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "7587327a-3720-4fb0-97f2-488b04375cd5",
    "name": "Citgeett Summer Newborn Baby Boys Girls Cotton Romper Sleeveless Button Jumpsuit Playsuit Overalls Casual Outfits",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/1a/c71ac0d1074347400ea0774ee1cf6d77.jpg",
    "cost_min": "4.85",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "17ae5a2e-b20d-4be5-8b14-e97277c9165b",
    "name": "14K Gold Plated Copper Wire for Jewelry Making,Beading Wire Cord for DIY Bracelet Necklace Making Accessories Jewelry Materials",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b9/84/b984457b55abf2070ede4f1e938f31c3.jpg",
    "cost_min": "3.66",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "b48bc3f9-cdd1-4430-a936-574d40673b15",
    "name": "20/50pcs Kids Elastic Hair Bands Girls Sweets Scrunchie Rubber Band for Children Hair Ties Clips Headband Baby Hair Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f6/96/f6963e31702208c11e8845901f122b65.jpg",
    "cost_min": "1.33",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7fe32d30-4945-42f7-907d-fede56ac2d98",
    "name": "Men Long Sleeve Cargo Overalls Bib Pants Zipper Pockets Rompers Jumpsuit Fashion Labor Casual Coveralls Plus Size S-4xl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5e/c6/5ec6972a65cd76ae80047966bf98efef.jpg",
    "cost_min": "22.63",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "33dc6689-52b7-4fd6-8b37-c0ecd247931d",
    "name": "Blue Men's Suit Trousers, Jacquard Fabric Pants, Wedding Party Dress Pant, Asian Size M-5xl 6XL, Pantalones Hombre",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3f/24/3f248b905b09714ceff67833ac5c76ea.jpg",
    "cost_min": "16.73",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "d9ad757e-3c00-403f-9ad7-3d320be96a0b",
    "name": "Fashionable Women Printed Elastic Jumpsuit New Summer Casual Seamless Tight Thin Women's High Waisted Leggings",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3c/1c/3c1c8c6ceb946eaf8ffe2ea858716127.jpg",
    "cost_min": "21.17",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "19642cea-4e7a-4d0d-9f28-ac3979bc6cf3",
    "name": "Summer Thin Ice Silk Sun Protection Jacket for Men Fashion Hooded Sports Uv Protection Skin Clothing Breathable Couple Outwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9a/da/9adaeef3895b27395c547157b43735fb.jpg",
    "cost_min": "4.99",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "daa8120f-a552-49e3-9462-8ea0e7833be4",
    "name": "ROCKBROS Heated Winter Glove Cycling Gloves USB Electric Rechargeable Ski Gloves Touchscreen Motorcycle Riding Hiking Snow Glove",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3d/02/3d02015932b44ea8aa18fe539a219aaf.jpg",
    "cost_min": "32.37",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "167d2e09-98ed-47f7-b511-119e252608d1",
    "name": "Tactical Cargo Pants Men Cotton Overalls Outdoor Work Trousers Big Size Hombre Clothing Camo Hiking Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d7/56/d75632c8f6f1948fb823458e236df968.jpg",
    "cost_min": "14.73",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "1ca5041e-ddaa-4945-b454-e81a3843079a",
    "name": "Synthetic Messy Bun Hair Piece 60g Elastic Drawstring Loose Wave Curly Hair Buns Hair Piece Extensions for Women Dark Brown",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c5/5a/c55a40d25f235fbd3a9e705566ff0092.jpg",
    "cost_min": "3.98",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "35ee15a5-f44d-4086-bf38-b9afdb8c1ff2",
    "name": "Underarm Odor Removal and Purification Whitening Cream Is Suitable for Dark Skin, Brightening, Deodorizing, and Smoothing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d2/bc/d2bc3a7f67357253ee3f46cb9c634c9a.jpg",
    "cost_min": "15.74",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "874ec43a-475a-4493-aa87-7626d1b3917c",
    "name": "VITALINOVO Women's Athletic Jacket Lightweight Quarter Zip Pullover for Golf Hiking Running Windbreaker UPF50+ Waterproof Jacket",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/03/f8/03f8f97197b882f8bca8cf5ad445fa77.jpg",
    "cost_min": "26.71",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "74d22e8f-f6ef-425d-921a-2221609f024d",
    "name": "Women's Casual Button Pocket Jumsuit Female Ladies Summer Cotton Linen Vintage Shift Spaghetti-Strap Rompers Playsuits 2020",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/f2/36f2e828e4798c96a7b26b6cdcd4665c.jpg",
    "cost_min": "18.51",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0daa472a-acb1-4655-a297-94006c655307",
    "name": "100pcs/Lot Natural Cotton Bags 7x9 9x12 10x15 13x18 15x20cm Drawstring Gift Pouches Home Storage Sacks Packing Bag Custom Logo",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e2/0f/e20f40bcdf426850c6e35b6c9683a3ab.jpg",
    "cost_min": "31.24",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "fc75e99f-f8b0-4a8b-9dcd-4ac73f161c32",
    "name": "Men's Designer Belts Luxury Business Belts High Quality Alloy Buckle Automatic Buckle Adjustable",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/88/41/8841e73c41364d4dfd4105530bb1905b.jpg",
    "cost_min": "7.35",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "9c4d9877-fa3c-44c1-9f60-9edf9250d7f1",
    "name": "Horse Riding Boots Male Microfibre Leather Rider Boots Equestrian Equipment Boots for Summer Winter Outdoor Sports",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ec/41/ec41141fa4d0769be444acd3ab1a28f1.jpg",
    "cost_min": "49.87",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "7e19fc4b-9311-43fb-a90d-81ee076b68be",
    "name": "Men's Solid Color Stand Collar Long Sleeve Zipper Casual Trendy Goose Down Coats Winter New Fashion Male Simple Basic Cothes Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/87/7c/877cfce30f85a0d7956c58183582214a.jpg",
    "cost_min": "34.15",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "161d6d47-a3a6-4206-baf0-1d08ac9cc5ec",
    "name": "Janveny Luxury Natural Real Mongolian Sheep Fur 2024 Winter Female Short Feather Puffer Coat for Women 90% Duck Down Parkas",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/61/d0/61d0c54680e227a95a3af4791dbc395f.jpg",
    "cost_min": "166.42",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "70a18764-a612-4c0b-b683-1696e91a9ea7",
    "name": "Pet Clothes French Bulldog Puppy Dog Costume Pet Jumpsuit Chihuahua Pug Pets Dogs Clothing for Small Medium Dogs Puppy Outfit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ab/cc/abcceadb7f5dc1bc0d154f5257ff2068.jpg",
    "cost_min": "3.56",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "fa56f248-0485-453e-a6e4-1ebc7931897e",
    "name": "50Pcs Purple Courier Mailer Bags Packaging Poly Package Plastic Self-Adhesive Mailing Express Bag Envelope  Postal Pouch Mailing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/74/fa/74fac1ab27e26e85d4b2d72f43b934aa.jpg",
    "cost_min": "10.82",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "2126f970-0c56-4d91-a8f6-78d8d9369ed6",
    "name": "Finger Rehabilitation Robot Gloves Stroke Hemiplegia Cerebral Infarction Training Equipment Therapy Hand Exerciser",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d1/2d/d12d38b4b866975052e958b8942f0a7f.jpg",
    "cost_min": "44.01",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "07ebb848-f56b-4a21-b1f0-0cacd16ef325",
    "name": "Essentials Skin Regimen Kit (4-Piece Set)",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f5/63/f563beec7f536451d59c692091e7e597.png",
    "cost_min": "23.99",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "d4554701-8d91-44b8-9ecb-852432064a8b",
    "name": "Promotion Blue Chinese Style Women Summer Blouse V-Neck Shirt Tops Silk Satin Tang Suit Top S M L XL XXL XXXL JY0044-4",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/90/35/90358aad471a38889be7bf8176c0ab34.jpg",
    "cost_min": "11.20",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "83ea43fd-c373-4057-b260-8dd1d7679f59",
    "name": "Waterproof Shipping Bags 25x35cm - Extra Strong 0.9mm Grey Poly Mailers, Tear-Resistant Self-Adhesive Envelopes for Secure Packa",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cf/ca/cfca96940929da17f71446f746cde049.png",
    "cost_min": "6.01",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "bae7e83a-f764-45d9-b39d-ec6e7a9e6b97",
    "name": "6Pack 30x40x0.9cm Sound Proof Acoustic Panels Soundproofing Wall Stickers High Density Noise Insulation Door Bedroom Foam Black",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/5f/c75f1db5cc81c55fdd1c2297bc580063.jpg",
    "cost_min": "27.74",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "8cd1b5b7-58a2-49e8-ae54-5c2e4047b5e5",
    "name": "5-100m PVC Coated 304 Stainless Steel Cable Suitable for Hanging String Lights Deck Railings Porch Fences  Clothes Hanging Ropes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/04/4a04537149609bfb3b545fdd63a960bb.jpg",
    "cost_min": "5.44",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "c8ef1e58-caeb-4096-a8e5-39d0d9ef7742",
    "name": "JayCreer  1/2-Person Paraglider / Paramotor Backpack Bag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/78/b2/78b2736b5b0e657b08ea21f4275e6597.jpg",
    "cost_min": "71.97",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "ef4df5f8-cfb3-487a-be4c-7fd11678ce77",
    "name": "Riding Helmet Children Equestrian Safety Multicolored Shockproof Professional Hard Shell Sporting Knight Helmets Pink",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e9/7a/e97aa7faa1f9b5a2985dbe7bfe7da9ce.jpg",
    "cost_min": "24.99",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "cb6893f4-05c3-4023-ac70-f22d6b942708",
    "name": "Ceramic Pellet Igniter 220V 350W Ceramic Igniter Heating Furnace Wood Pellet Biofuel Ignition",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3a/d1/3ad1eb7a5b7d17053b180336a1cca073.png",
    "cost_min": "21.72",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "79f83b1c-b653-453d-b0ec-b3f5d03325fb",
    "name": "Men Onesie Christmas Pajama Adult Jumpsuit Winter Warm Sleepwear Flannel Outfit Festival Party Suit Print Kigurumis Unisex",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fa/12/fa127322a9984f2958383ea9fb761621.jpg",
    "cost_min": "30.49",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "82c4f4b9-916c-4f8b-9647-4954088568d2",
    "name": "Dimmer AC Module High Power for 40A 600V High Load, 1 Channel, 3.3v/5v Logic",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d1/0e/d10e7b75f519c274e8d59a1fd62c18a6.jpg",
    "cost_min": "18.42",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "57477f09-f89b-4240-afa4-b0a9627155c0",
    "name": "JayCreer  1-Person Paraglider / Paramotor Organize Bag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7b/ac/7bac23f4fcecd67bf825b68109e54d21.jpg",
    "cost_min": "36.15",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "9ad77061-2cd2-4472-a24c-9835706a23cf",
    "name": "Expensive Talks Back Funny Printing Womens Plus Size Hoodie Multicolor Pullovers Fleece Autumn Sportswear Casual Pocket Hoody",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0a/26/0a2689c7dc0eed79649aec163d83c6ef.jpg",
    "cost_min": "10.88",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "9030ac57-1e83-4420-ae9e-539adba25160",
    "name": "2024 Men Long Pants Autumn and Winter Mens Casual Fleece Sweatpants Soft Sports Pants Jogging Pants 5 Colors S-3xl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/63/10/631052f8a0038a805625bfabb0a367e5.png",
    "cost_min": "7.38",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "b337c52d-96db-4207-943f-0e6888f1b59a",
    "name": "ETHIKA 1Pcs Men Underwear Boxers Breathable Mesh Crotch Mens Trunks Plus Size S-3xl Man Swimming Underpants Men's Panties Trunks",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e4/f0/e4f0215aff11a305d3964a6864564ed7.jpg",
    "cost_min": "5.13",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "ac0f8c5c-341e-4d2c-a0ca-634a41a24a37",
    "name": "New Style Women Real Genuine Rabbit Fur Vest Fashion 100% Real Rabbit Fur Gilet Lady Real Rabbit Fur Short Sleeveless Coat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5c/5b/5c5b206b166a0fec2835c749d62735cc.jpg",
    "cost_min": "29.89",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "99aa182f-6134-4374-9543-92d1f0a486e0",
    "name": "Men Fitness Built-In Pocket Sports Shorts Summer 2 in 1 Quick Dry Gym Beach Shorts Running Double-Deck Shorts Mesh Sweatpants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7e/1a/7e1a9c62bc9ed8251cfbde28fc98997a.jpg",
    "cost_min": "7.26",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "956f4565-2ecb-43a4-84b7-26410c953e33",
    "name": "Artificial Plants Potted Bonsai Green Small Tree Plants Fake Flowers Potted Ornaments for Home Garden Decor Party Hotel Decor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/aa/93aa011c9a43292cd24edb632e9f1a1c.jpg",
    "cost_min": "2.54",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "de16b674-4fab-4c9e-8fcd-84977160e92f",
    "name": "24mm Macarons Plastic Binding Ring Suitable for Loose-Leaf Notebooks Planner Scrapbooking Mushroom Hole School Binding Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/c2/c7c2ad381a0c0559a3d5934bb74ab870.jpg",
    "cost_min": "4.64",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "ad453842-180d-466a-ac29-0b136e1efad9",
    "name": "Breast Prosthetic Bra Female Fake Lady Men Larger Small Chest Pad Silicone Bra Underwear Enlargement Cosplay Push Up Insert Dres",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/04/b4/04b43cb4a6e95687d8d32e715027d5c6.jpg",
    "cost_min": "34.77",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "5ed3f431-1d28-46fc-b9be-28680698b186",
    "name": "Pneumatic Quick Connect Coupler Push to Connect Air Fitting Kit for 4/6/8/10/12/16mm Tubing PU PY PE PV Nylon Hose Water Pipe",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d8/d3/d8d372f2dc464ded3cb7f34fbec38a1f.jpg",
    "cost_min": "4.93",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "ab20fa36-1b64-4f71-989f-31c100345ed7",
    "name": "Negative Pressure Wound Therapy System Accessory Tubing With the Pad Drainage Tube With Small Tubing for Washing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cc/0c/cc0cc8d5ae7e1f63c9c1064c7f3c6051.jpg",
    "cost_min": "5.96",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "2905c96a-b456-48bd-b967-89b05c3e451b",
    "name": "ARENA Professional Racing Goggles High-Definition Waterproof and Anti Fog UV400 Competition Training Swimming Goggles",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fa/d9/fad90e17ff0d637d1bba414ff0ca8f9a.jpg",
    "cost_min": "10.34",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "6eb4ed76-acc7-4c7a-bf28-61b37fe2dc4a",
    "name": "22CM Classic Men's Suit Pocket Square Colorful Solid White Handkerchief Korean Dress Chest Pocket Towel Fashion British Hanky",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fb/a2/fba2cc9b91fa08a27e6f76d9040e188b.jpg",
    "cost_min": "1.46",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7fa4ceed-aea5-4261-ba14-df7d0866b2e1",
    "name": "Womens Modern Lyrical Liturgical Praise Dance Costume Praise Church Choir Dresses Irregular Hem Ballet Contemporary Dance Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/38/a2/38a2bc76e05712324a5e8fd92d3f6cc8.jpg",
    "cost_min": "15.78",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "8cdde701-5cf8-4184-baee-b57888c90c31",
    "name": "3Pcs Set Japanese Style Infant Toddlers Baby Bibs Cotton Cartoon Embroidery Newborn Burp Cloths Boys Girls Saliva Towel",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4c/9e/4c9eaf45df78c2e87e0313c8fc937869.jpg",
    "cost_min": "8.77",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "30da31c0-dfcc-44e5-9347-2a6d70ec9754",
    "name": "Children's Spring Autumn Sneakers Boys Breathable Comfortable Running Shoes Girls Fashion Sports Casual Soft-Soled Non-Slip Kids",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4b/77/4b7724abd91d4ce6bd1708e4efa4fa52.jpg",
    "cost_min": "6.24",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "281a295b-5964-454e-9af3-d70b5c2f0469",
    "name": "Customized Elegant Blue Straps Luxury Appliques Spaghetti A-Line Beaded Evening Dresses for Women 2026 Prom Dresses Party Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e2/41/e24164b76b37f0558f73c2e972b995ad.jpg",
    "cost_min": "299.52",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "290c9663-6c14-4828-a671-81b93b96e40d",
    "name": "Fashion Custom Your Logo Zipper Jacket Outdoor Sportwear Long Sleeved Men Personality Printing Sweatshirts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/58/7b/587bf70bf9ef58b94a9d9f820baa069e.png",
    "cost_min": "20.35",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "26a6b2c8-b825-4a4b-b0f7-ddf373e685ff",
    "name": "25cm Mens Classic Pocket Square Towel Polyester Paisley Striped Handkerchief Suit Shirt Accessories Wedding Party Navy Red Hanky",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a4/f2/a4f20be3665b91b9fa37af3ba119c69e.jpg",
    "cost_min": "1.80",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "ff0fd16d-b674-447e-94bf-4c66a716d14c",
    "name": "100pcs/Bottle Eyelash Extension Cleaning Swabs Lash Lift Glue Remover Applicators Sticks Makeup Micro Brushes Tools",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/df/4b/df4b095db3887b4f00a9a3752cdb1162.jpg",
    "cost_min": "1.41",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "ce81dfcc-6672-453d-b2e7-00a99572b68b",
    "name": "YJKVUR Unisex Summer New UPF 50+ UV Sun Protection Hoodie Jacket Men Women Lightweight Hiking Outdoor Long Sleeve Sun Shirt Coat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/91/9b/919b99cd8c83254f746d35d69c3b2e57.jpg",
    "cost_min": "9.16",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "40f66f08-e77b-4a4d-a819-d629fe8215dd",
    "name": "Candy Color Hoodie Loose 14 Solid Color Spring Autumn Winter Men Women Plush and Thick Versatile Top Sweatshirts Couple Pullover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c3/2d/c32d14567dec134622a92c19c0300152.jpg",
    "cost_min": "8.02",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "389c8b9d-4d32-4bcc-8bd2-3531eaa7e11d",
    "name": "HPA Regulator Valve of Compressed Air Accessries CO2 Oxygen Nitrogen Cylinder Tank Bottle 4500psi Input, Output 800psi to 3000ps",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/1a/931aa41c40a868bdc0e76988c2367e7e.jpg",
    "cost_min": "24.73",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "8b10f114-3375-4a63-b7b4-0558ab22571a",
    "name": "Wireless Halloween Neon LED Purge Mask Masque Masquerade Party Masks Light Grow in the Dark Horror Mask Glowing Masker",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/83/16/8316e694e3757b17e4bf68486befc6ef.jpg",
    "cost_min": "5.62",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "bad5c18c-6002-42d9-b703-4a158b50381f",
    "name": "2026 New 3D Printing Pen DIY Three-Dimensional Painting Children Toys With LCD Screen Power Adapter 200M PLA Filament Toys Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/61/6f/616f23fec24b3985ebd65cfd807ffe7c.jpg",
    "cost_min": "11.11",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "94945cf3-38e3-4aac-9902-4af7d939d993",
    "name": "Sexy Skinny Leotard Singer Dancer Show StageWear Sparkly Blue Rhinestones Women DanceCostume Fringes One Shoulder Bodysuit  7G",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a1/6a/a16add26906ca3436b3de79b5af62aac.jpg",
    "cost_min": "23.82",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "a72a4ba9-a6e1-408f-8eaa-171c5f8c2c14",
    "name": "Suspenders Man Bowtie Solid Color Elastic PU Leather Suspenders for Man Belt Adjustable Straps for Wedding Bow Tie Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/bb/ab/bbab4748d049543c0d74ad431c1ffa09.jpg",
    "cost_min": "2.62",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "acd3dc12-7885-4c34-90e3-1a613d3fdacc",
    "name": "12 Style Superhero Spiderman Costume Set Iron Miles Venom Amazing Spiderman Party Halloween Christmas Cosplay Bodysuit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d7/1d/d71dac46293415fb1d2ad99e892d4eab.jpg",
    "cost_min": "9.63",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "2895037a-1a3a-4956-94e7-ecce8c56cfea",
    "name": "Wholesale L9 Triple Proofing Rugged Elder Phone Feature Phone Mobile Phone",
    "staff_picks": [
      "bestseller"
    ],
    "image": "https://media.modalyst.co/cache/90/33/9033e430f91162eaf6bc45ef04d6be45.jpg",
    "cost_min": "11.10",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "f5cd9d8e-a66d-455b-9f3e-37f8392a1746",
    "name": "Golf Tees Rhombic 10 Degree Diagonal Insert Increases the Distance Speed Golf Ball Holder Zero Drag Outdoor Golf Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b6/fd/b6fdfa6a3f0f207ab71e6bb23769ca5c.jpg",
    "cost_min": "1.52",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "9df6e5c5-686a-4a12-9b0e-718773a0d6f1",
    "name": "Natural Handcrafted Grey Himalayan Salt Lamp 1.5-5kg",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5f/c9/5fc9ff92bdef9d14b7cd9d781663bd20.png",
    "cost_min": "16.79",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "956e19d8-bd82-47e2-bf99-7403f842b2b2",
    "name": "JayCreer Airbus Cockpit Windows Sunshade Set for Airbus A350",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4b/b2/4bb257784f9a13e5f68c0462e690ca95.jpg",
    "cost_min": "39.35",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "df462056-41b1-4067-81e1-aac78237644b",
    "name": "IGBT Voltage Capability Transistor Tester Diode MOS Triode LED Voltage Capability MOV Withstand Voltage Tester 0v-3500v",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0f/88/0f8849a5d88a3e96178a2041375c2460.jpg",
    "cost_min": "12.31",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "38789daa-73ea-4f53-b83c-423c2b28f9d6",
    "name": "2x Horse Spurs Anti Rust Western Style Spur for Competition Equipments Decoraation for Boots Men and Women for Equestrian Traini",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ff/25/ff2525b0d728260f3240e765dbca48c5.jpg",
    "cost_min": "28.35",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "36e86de8-fdc8-4ea8-b3d4-9ff568f65025",
    "name": "JayCreer  Glider Paraglider Training Seat for Glider Trainer on the Ground",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0e/30/0e306084faf7c93f7c55d342db21fc45.jpg",
    "cost_min": "93.46",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "02e826db-9cea-42ea-83bf-23a4ad0e5d45",
    "name": "Women Halter Neck Triangle Bikini Sets Vintage 90s Aesthetic Bathing Suits Summer Boy Shorts Swimsuits Y2k Coquette Swimwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5d/88/5d88537df7e0ced42b6c06dfbc43c010.jpg",
    "cost_min": "5.17",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "60d320fe-7714-4586-85a0-3add427d9223",
    "name": "TIDRADIO Q2L Wireless Speaker Mic for Walkie Talkies, Zello & Odmaster App, AI Noise Reduction, Program Radios",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/74/dd/74dd507b2e906e5d3b6110e513fc20ed.jpg",
    "cost_min": "19.99",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "fbc8025d-dd50-4148-8dc3-b24bf013ad12",
    "name": "Diytzt 10/20/50pcs Tda2822m Tda2822 Tda2822d 2822",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/58/88/5888893f53b040b7e5880993ab036ae1.jpg",
    "cost_min": "1.06",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "cef29f08-6b1a-4590-9b19-c0f1a00ec87a",
    "name": "Genuine Car Thermostatic Gauge Radiator Cap 0.9 1.1 1.3 Bar Small Head Water Temp Meter",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a6/b9/a6b98b8c588759e07343aa50924f7e4e.jpg",
    "cost_min": "7.09",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "af482ba6-dfde-421f-a6b0-224443b310d3",
    "name": "Desk Storage Box, Pen Holder Stationery, Pencil Accessories Storage, Suitable for University, Home, Office, 5 Compartments, 3 Co",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1b/5f/1b5f1e0c000e2f709505ebffdb0e3c9e.jpg",
    "cost_min": "4.93",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "eedefe8f-9dc4-4bd9-bbb2-c67572b960c0",
    "name": "Gadinan Ethernet PoE Gigabit Extender  1 in 3 Out Repeater, 3-Port Outdoor Waterproof, With 1000Mbps Power and Data Transmission",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/71/86/718634a92f15d178ebac85036e626ec2.jpg",
    "cost_min": "10.77",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "c9f3b4fa-afb8-4fa1-af8f-16a4404e1e7a",
    "name": "JayCreer  1-Person Paraglider / Paramotor Backpack Bag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ec/05/ec059d05937d1766adb600fe71341de3.jpg",
    "cost_min": "47.94",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "e2f2764e-56d4-4ccf-97b2-ab00251819a7",
    "name": "2025 Luxury Formal Pocket Square Navy Striped Floral Silk Handkerchief 24cm Brown Color Hanky Wedding Banquet Accessories Cravat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/70/b5/70b50c4a4071d8fbef0c9736ba2e1855.jpg",
    "cost_min": "1.85",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "9f752b66-e8f0-4c28-ac9c-6f09e3d65bf0",
    "name": "PWM Electronic Robotic Arm Air Pump 2/4pcs Suction Cup Support Servo MG996 for Arduino Control Board Programmable Robot DIY Kits",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/35/6d/356d3791779e1a301cbeaa894a02d7c4.jpg",
    "cost_min": "20.22",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "071ef004-8006-4bc0-a481-1e0f9e61f2cc",
    "name": "Sweat-Shirts à Capuche Pour Hommes Tendance / Sweat-Shirts Vêtements De Sport KTM Streetwear Pulls Pour Femmes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f6/08/f608003bf68d02059a19b17d3e73e097.jpg",
    "cost_min": "10.24",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "8108d5b1-1f6d-4e90-9e1e-34193466682f",
    "name": "Acrylic Y2k Knitted Sweater Women Fashion Aesthetics Solid Color Versatile Gothic Streetwear Casual Long Sleeved Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2f/04/2f04d6b17f6b625315d246c6642f8f28.jpg",
    "cost_min": "13.53",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "5dfd173b-a36e-41dc-8adc-21156f043dfe",
    "name": "Hair Serum",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/45/00/4500e22b76320b42456a76d911ce078b.png",
    "cost_min": "16.79",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "521b416f-867a-4a4c-aaec-ae15cf02554c",
    "name": "1pcs Applicable to O*IS Elevator Button Type BR27C Opening Closing Door Direction Keys Wordless Button Red White Blue Glow",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1e/3c/1e3c354207ee748a934e177b2618b883.png",
    "cost_min": "3.30",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "6cd60fbd-dfb1-4091-bf90-f758cdd728a7",
    "name": "Detachable 1 Pair False Cuffs Sleeve Women Lace Cuffs Wrist Pleated Flared Cuffs, Elastic Sleeve Cuffs, Sweater Sleeves Cuffs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9c/17/9c17d89e197789bb431216594fae624b.jpg",
    "cost_min": "4.25",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "326bc122-bdc6-4368-934c-2820e2e8a09b",
    "name": "1 Pair Universal Fake Cuff Lace Cuffs Pleated Flared Sleeve Pearl Mesh Lace Cuff Sleeves Sleeves for Women Removable Lace Cuffs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/28/f0/28f06e6221b23c4c412ad5f0cddfe2ff.jpg",
    "cost_min": "4.96",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0b76947e-1fc8-49c8-8367-e0c51e921d40",
    "name": "Yoga Leggings Women Fitness Leggings Running Cycling Pants Breathable Sports Leggings High Waist Summer Workout Gym Clothing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8b/3e/8b3ec307905da823f9ede0cac9f1a513.jpg",
    "cost_min": "9.79",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "9ad897c4-f7e4-49ae-828c-60ed9c4347f0",
    "name": "Solid Color Handkerchief Cotton Unisex Pink Blue Pocket Square Hankies Colorful Scarf Chest Classic Style Towel Bowtie Accessory",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d0/f6/d0f6ba348852c85c79bc90a41c0636fe.jpg",
    "cost_min": "1.99",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "4d2d6983-cd90-42dd-9d0d-23c82c09603e",
    "name": "5 Pcs Ceramic PTC Heating Sheet 12V~220V Constant Temperature PTC Heater With Aluminum Shell Electric Heater Accessories 35*21",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a6/cc/a6ccab537b0dbc8e0b6378217248a391.jpg",
    "cost_min": "8.41",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "dfc5a7c4-06ab-4e07-a246-ca9cf4c64ffe",
    "name": "Hot Sale Girl Real Rabbit Fur Coat Women Real Rabbit Fur Jacket Genuine Real Rabbit Fur Outerwear Casual Short Real Fur Coats",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/51/46/5146ef0bbd83ead1ad07955190028f67.jpg",
    "cost_min": "2250.00",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "cfe1bfbe-582e-4f44-ac40-356c595a2579",
    "name": "Pickleball Paddle Carbon Fiber USAPA Approved Pickleball Set Sports Outdoor Beach Tennis Racket Cricket Ball",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8d/94/8d949efb1c256f61871c0c773106631c.jpg",
    "cost_min": "11.10",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "6423e79b-6ffd-494f-8aef-f171de07d5ed",
    "name": "5 Pairs/Lot High Quality Men Ankle Socks Breathable Cotton Sports Mesh Casual Athletic Thin Cut Short Sokken Plus Size",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/79/b1/79b1f94d4000fe9328ed680d349adf5f.jpg",
    "cost_min": "2.69",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "a90ee5f4-5b01-43c0-a1e3-4d333a145fa5",
    "name": "10/20/50pcs PT4115 PT4115-89E",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/19/2d/192df37e1e00495193b7a666f2c10db4.jpg",
    "cost_min": "1.01",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "2f8b706c-7e61-47d7-8fe6-6b5b9be409f0",
    "name": "Plata De Ley 925 Silver Charms Hot Star Wars Sries Mandalorian Helmet Pendant Beads Original Womens Bracelets DIY Jewelry Gifts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/82/a4/82a4aad66f7cc6f911a98e2ee2740de4.jpg",
    "cost_min": "5.59",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "d7b16f64-09fb-440e-ab4e-d6c351c236ce",
    "name": "2026NEW Kpop Devil Hunter Rumi Zoe Mira Anime Polyvinyl Chloride Character Collection Desktop Trinkets Childrens New Year Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/28/8d/288de587ec8f96975e90170824dca7fa.jpg",
    "cost_min": "2.13",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "d5b70516-d511-4d7a-9fd0-69e1eb307565",
    "name": "Customized Your Logo Men's Winter Thick Jackets Long Sleeve Zip Up Hoodies Fashion Outdoor Warm Loose Coat Personalized Clothing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/09/2b/092b4d4b168de066796387bccba4b26e.jpg",
    "cost_min": "30.87",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "6520f3bd-bba0-48d1-b78b-b4828f2038c5",
    "name": "Muscle Suit Bodybuilding Costume Short Sleeve Seamless Chest Binding Flat Compression Realistic Muscle Enhancement Thin Insert",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/83/8b/838b5e9a6a49dc55e268fa86e017fafe.jpg",
    "cost_min": "35.97",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "5d284aac-c85e-4339-a562-9ef90fa6b34c",
    "name": "Ultra Thin Clear TPU Phone Cases for iPhone 17 16 15 14 13 12 11 Pro Max Plus 17 Air 16E XR XS Max Transparent Silicone Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7a/30/7a30a8b3bebe80fbaff09aa263f40893.jpg",
    "cost_min": "1.89",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "b2c97e82-fe7e-47a9-bdb1-aa4fb7f9dfbe",
    "name": "JGY370 High Torque Speed Reducer Metal Worm Gear Motor Reversible Low Speed Worm Gear Motor 6V 12V 24V 0.6~375RPM",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7f/15/7f15cc7fbcaf3ac400a85fe6cf8ecbda.jpg",
    "cost_min": "4.07",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "ae7f07f4-f67e-4325-af1d-f563d7570ca0",
    "name": "ETHIKA Underwear Boxers Breathable Mens Boxershorts Men's Panties Underpants Plus Size Fashion Print Man Boxers Briefs Trunks",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/94/5d/945de3b2767ff5b30acb31be302a4e22.png",
    "cost_min": "3.93",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "fbeac01f-6523-47c0-ac18-b0c0216af7dd",
    "name": "3Pcs Glueless Wig Caps for Women Black Mesh Wig Cap for Making Wigs Easier Sew in Dome Wig Cap Weaving Cap Wig Liner S M L Sizes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cf/7e/cf7e8dec57de8ac756bb7b7d812cd10d.jpg",
    "cost_min": "3.96",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "606d5862-496f-4d32-a4ca-161e4499d265",
    "name": "Compression T Shirt Men Long Sleeve Bodybuilding Sport Tees Casual Quick Dry Gym Fitness Workout Jogging Sport Tops Men Jersey",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8d/5a/8d5acddbf33b0d7fb224f7689dfca2de.jpg",
    "cost_min": "6.03",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "5df95c9e-2185-4d53-bc38-564a3e6985f3",
    "name": "Comwarm Fashion Women's Suede Mules Slippers Men Clogs Cork Insole Sandals With Arch Support Outdoor Beach Slides Home Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/df/83/df836c5f9883aafcc89b1524a63cb9eb.jpg",
    "cost_min": "21.19",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "d1d5d75c-c456-4708-9059-455ce81f238e",
    "name": "Wireless Neon LED Purge Mask Glow in the Dark Cosplay Horror Mask Halloween Masquerade Party Masks Glowing Funny Dress Up",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7a/3f/7a3f0ae80ae73344a81eed9d6648ac53.jpg",
    "cost_min": "4.06",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "26a6e758-313c-4fe4-907a-3b6c361bb4e2",
    "name": "2PcsTO220/To247 RTP Highpower 35W50100W5RF25R1K10K50K4R100R2R47R8R200 Ω 50R Thick Film Non Inductive Resistor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/44/d0/44d08e7f76d3587f642a559c558d3a6a.jpg",
    "cost_min": "5.05",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "3be35010-3ccd-4644-bb0d-01c00486127d",
    "name": "10 Sets 11.2mm 1/64 Model Car Wheels or Removable Rubber Tires for Hot Wheel/Matchbox/Dome 1:64 Diecast Cars",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/af/77/af77636301d7efe299af4bd8fd757d83.jpg",
    "cost_min": "4.60",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "df798d7f-d8d9-4eb4-b969-02dc6c6fd229",
    "name": "60Colors Luxury Scarf Women 70*70Cm Silk Feel Square Hair Wrapping Foulard Satin Shawl Big Size Head Bandana Hijab Handkerchief",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c0/51/c05116afb657c9fe3a4e301ea118e6af.png",
    "cost_min": "1.93",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "c665c668-55bf-4d84-82b7-68d77851d2b9",
    "name": "Stuffed Plush Animals Toys Hand Finger Story Puppet Kawaii Dolls Educational Baby Toys Lion Elephant Bunny Monkey Children GIft",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/05/6c/056c29fc6c123947c519036042ce1116.png",
    "cost_min": "5.18",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "b8b374f7-85fe-4a13-b017-11b08dfd74a8",
    "name": "Summer Men Slippers Indoor Outdoor Casual Non-Slip Beach Shoes for Women Breathable Home-Based Shoe Large Size36-48",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3e/12/3e12dc4eda962c0f04366b45ae68dab7.png",
    "cost_min": "8.39",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "55b6765e-238d-4f5e-a302-ba9fe03be6cf",
    "name": "90*90Cm Square Scarf Twill Silk Feeling Women Head Shawls and Wraps Luxury Hair Tree Print Neck Scarves Hijab Bandana Pashmina",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/df/5b/df5b8a9f61eb295b1ca5ce0113ff19be.jpg",
    "cost_min": "2.91",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "6c37c209-8c2a-4989-9573-2520bd437bed",
    "name": "18K Gold Plated Round Crimp End Bead,Brass Crimp Beads for Jewelry Making Supplies,Lamps for Jewelry,DIY Bracelets Accessorie",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4c/2e/4c2e8a00827e8b5f3703715e5808ff5e.jpg",
    "cost_min": "1.96",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "a4aa4f62-174f-43ea-9d54-1ceb331a70ea",
    "name": "Keyboard Cover for Lenovo LOQ Gaming 15 16 17 15AHP10 15IRX10 17IRX10 15ARP9 15IAX9 15AHP9 11 Silicone Protector Skin Case 15.6",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f4/22/f422b5d60cb35cbfb4319f9afa7c950c.jpg",
    "cost_min": "3.97",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "ab2d4b9e-a1ad-468a-9c1a-ba4a55fc3b65",
    "name": "1-200pcs LED Bottles Coaster Lamps Luminous Cup Stickers Lights for Bar KTV Wedding Party Cocktail Drink Cups Vase Decoration",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8a/2c/8a2c6c8f30ca2412b664b0a9d86c5c3f.jpg",
    "cost_min": "1.08",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "57100ad0-3fb1-4eeb-8729-cd2a41e46689",
    "name": "6Pcs 8x40x16.5mm DT/STG/slot Width 12.3mm Slot Diameter Φ 30/With 608Z Bearing I-Shaped Black Plastic Wrapped Pulley H",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b8/91/b891cd16177867172223ec26f0346f0a.jpg",
    "cost_min": "9.99",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "86796e4f-ec53-424e-a370-d11e599b1133",
    "name": "PCF Pneumatic Quick Connector American Standard NPT Internal Thread N1/8 N1/4 N3/8 N1/2 PU Hose Air Pipe 4 6 8 10 12mm 6-Npt1/4",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/14/8f/148f234618b95c39a1d3bda65d57a734.jpg",
    "cost_min": "6.36",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "0ce1f8ea-c759-489c-9bef-235574bb1e42",
    "name": "Round Solid Wood Table Legs for Furniture Wooden Chair Sofa Foot Cabinet Bed Support Hardware Replacement Dressers Desk Feet",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/04/64/0464ea34effe4ebc4011edacbbfc4e4f.jpg",
    "cost_min": "6.89",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "a5c8c562-274b-4ef7-a3ee-7dfb3a9638ca",
    "name": "New Winter Women Real Fox Fur Hooded Coat Thick Keep Warm 100% Natural Real Fox Fur Jacket Lady Fashion Geunine Fox Fur Overcoat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e9/a2/e9a2742766033df35265e2d02784ef0f.jpg",
    "cost_min": "45000.00",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "a1bde747-d358-4b27-9448-54079253ff5e",
    "name": "Men's Muslim Dress Long-Sleeved Clothing 100% Cotton Pullover Kaftan Robe Men Jubba Thobe Pakistan Saudi Arab Caftan Islamic Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ef/e5/efe53c70f9758a2c003c825f00ffd82a.jpg",
    "cost_min": "19.26",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "79032fdd-9cab-494f-850b-ace8f79827ec",
    "name": "1 Pair Women Lace Cuff Sleeves Gauze False Cuffs White Elastic Sleeve Cuffs Detachable Blouse Wrist Warmers Cuffs for Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/95/e0/95e04d8fce160074038edb7b5148edb5.jpg",
    "cost_min": "2.35",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "491c47b4-5fdd-472e-b64a-50d61e2a2ca0",
    "name": "62Color Solid Women Winter Scarf Warm Thicken Cashmere Shawl Outdoor Fashion Luxury Tassels Pashmina Lady Wrap Windproof Scarves",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5d/af/5daf5d7a7f1afb657ce41841ce3f1f72.png",
    "cost_min": "4.89",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "4b2a95ae-bd48-47a9-9e81-b6c41f5db4f1",
    "name": "Promotion! 1mm/2mm/5mm/3mm/10mm Choose, 3M 300LSE Super Strong Double Sided Adhesive Heavy Duty Tape for LCD Lens Digitizer 55M",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c3/f9/c3f9b2516007e9e1ed2a823e7d3f35b5.jpg",
    "cost_min": "4.99",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "7ce3d6a4-efea-477e-b34e-304c994ac4c2",
    "name": "HUISHI Luxury Hankerchief Lapel Male Female Pocket Square Vintage Wedding Dress Accessories Scarves Men Red Blue Pocket Square",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ee/83/ee83923290fd61c877262c5eb573b705.jpg",
    "cost_min": "3.49",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "dfa80e2f-8452-43fc-aacf-72f03c71bea0",
    "name": "LED Green Leaf Garland String 20/50/100 LED Green Leaf Garland With Fairy Lights Battery Powered Suitable for Holiday Decoration",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4e/94/4e94174181c0148897d1477c87c2a193.jpg",
    "cost_min": "2.67",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "5426b860-f9b4-47ca-aafc-9196a0b95f18",
    "name": "6Pcs  8x36x16mm V-Groove Bearing Pulley 608zz Bearing 90 Degree Right Angle Wrapped Plastic Pulley With M8 Screw",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b9/0c/b90c44d6a27e50556038f9ababac4de0.jpg",
    "cost_min": "9.45",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "9d969420-cbbe-4ee6-9634-265a60f5b5ae",
    "name": "13/16 Inch LCD Drawing Tablet Writing Board Color Doodle Counting Practice Chalkboard Educational Toys for 3-12 Years Kids Gifts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/df/09/df0916d3823bf5aac875fbc0bbe52841.jpg",
    "cost_min": "6.11",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "bfb01540-34b4-449e-9e9b-9afd08e97c74",
    "name": "Free Personalized Medical Alert ID Bracelets for Women Men Engraving Anti Allergy Stainless Steel Cuff Bangle Custom Jewelry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/05/08/050840b9fb0754a18b996fa7ff0017f5.jpg",
    "cost_min": "4.99",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "efa7e1eb-79ad-42a9-8329-dc7d741296f3",
    "name": "Cartoon Pikachu Gengar Charmander Mobile Phone Bag Mini Nylon Crossbody Cash Letter Messenger Bag Wallet Coin Purse ShoulderBag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/99/27/99276091e28c334725c8905c5cf2afc0.jpg",
    "cost_min": "6.46",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "ebdd1da0-02b8-40a4-8794-86be0e21873a",
    "name": "High Grade Handkerchief Pocket Square 24 Striped Solid Colors Formal Business Party Wedding Suit Hanky Accessories Performance",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4e/89/4e8974067be432cca3debdb96cd80e3a.jpg",
    "cost_min": "2.46",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "4d42f66f-1c7a-4c74-b347-8a4b0ad4759b",
    "name": "Canada Fashion Winter Jacket Men Down Coat Parka Men's White Goose Down Jackets Fur Collar Hooded Warm Thick Long Padding HWY287",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8f/29/8f295cb18195bfa70df6b25f3505e5cf.jpg",
    "cost_min": "68.12",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "3783e51a-4be7-4e5b-a88e-26e208661a8e",
    "name": "Simple and Versatile Square Women's Watch, Instagram-Style Steel Band Fashion Quartz Watch, Trendy Ladies' Wristwatch",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/37/d5/37d55fc5e11a4d83eba73fc97073ca18.jpg",
    "cost_min": "4.84",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7b424bcd-563b-4ae7-9e19-655fb998f399",
    "name": "Men Plus Size Retro British Style PU Leather Shoes Ankle Comfortable Foot Feel Casual Shoe Wear-Resistant Outsole Walking Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e4/8d/e48d10c65c285ffb564c23446e1de809.jpg",
    "cost_min": "21.79",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "6a720fea-6a9f-4add-b3ec-34a565822b5f",
    "name": "Self Adhesive Thick Sponge Foam Pipe Insulation Tape for Outdoor Water Pipe Freeze Prevention and Winter Thermal Protection",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1b/f9/1bf9257148004c24382df521fce08a13.jpg",
    "cost_min": "4.02",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "6e93f314-6be8-4cc0-9d60-fef03ecd5a44",
    "name": "2025 New Popular Women's Slippers Party Plush Summer New Best-Selling Furry Home Shoes Fur Flip Flops Female Slides Fur Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/37/6e/376ef7c263e5e6c45461211ac030654d.jpg",
    "cost_min": "14.81",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "16d131c2-ccde-4acf-9d46-18877a3da4a5",
    "name": "Kids Boys Girls Metallic Harem Pants Jazz Dance Costumes Elastic Waistband Shiny Trousers for Modern Hip Hop Street Dancewear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ed/60/ed60b5283058ad291665a7376d6f3491.jpg",
    "cost_min": "11.83",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "6132b6a8-5dac-4539-9d91-ac76c1fcdb11",
    "name": "10pcs/Lot Brown Black Red White Kraft Paper Bags With Handles Bulk Small Paper Gift Bags Small Business Colth Shopping Bags Xmas",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/31/67/3167cf67dd25e3f9875bf6c0b681e2cf.jpg",
    "cost_min": "5.03",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "4567a693-82dd-434e-a6c2-257bf12ecec4",
    "name": "Summer YAMAHA Men Women Motorcycle Riding Suit Loose Breathable Quick Drying Off-Road Racing Suit Long Sleeved Sports T-Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/75/c5/75c50d029ed7346ffa3b82e2367bec1c.jpg",
    "cost_min": "9.66",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "1dc1b7fd-6795-4904-aca0-b7bbde52636a",
    "name": "Cute Blue Celebrity Dresses With Silver Edge Sparkle Sequins Mini Cocktail Dresses Short Two Pieces Perform Dresses New in 2024",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/61/97/6197360cb207ff4df7f4373b15e1a346.jpg",
    "cost_min": "83.20",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "58ad9880-c2e4-43c2-973c-711c979a3b52",
    "name": "New Hot Sale Mens Skull Printed Tank Top Breathable Cool Vest Running Shirt Cotton Tees Bodybuilding Singlet Fitness Sleeveless",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/11/33/1133dac8349f9b7906d18c28f7053667.jpg",
    "cost_min": "6.94",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "e935f02f-ba86-4c7b-afaf-649dddc26596",
    "name": "Fake Beard Trimmable and No Itching Fake Mustache Realistic Faux Facial Hair for Men Theatrical/Holiday/Drama/Party/Movie",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2e/01/2e012b5c9ecb43f9858f3b4bba1e08ce.jpg",
    "cost_min": "6.95",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "43e3e43b-f7c6-4e7a-a881-9b8f7dc85d92",
    "name": "Ballroom Dance Shoes Women Latin Dance Shoes Salsa Shoes Bachata Tango Shoes for Women Jazz Dance Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5b/c1/5bc1663ffc1412ffdaf9369953c0a4fe.jpg",
    "cost_min": "29.10",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "41b0d055-7310-4ba1-a717-0f704b2e592e",
    "name": "Antique Black Zircon Square Stone Earrings Trendy Female Geometric Crystal Champagne Gold Color Party Jewelry for Women",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ec/21/ec216fb58f2ca378e392874e1ee05a19.jpg",
    "cost_min": "2.71",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "d27fbfd0-dc09-4cab-ab81-f5496fe544cb",
    "name": "25l/50l Sturdy Nylon Waterproof Tactical Sports Trekking Fishing Hunting Camping Hiking Bag Backpack Outdoor Rucksacks",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8a/de/8adef0d154621efa6536a8910a7b26c3.jpg",
    "cost_min": "19.02",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "a3db5e0c-8668-4674-a17c-3ffece86350f",
    "name": "Chinese Men's Navy Blue Satin Robe With Belt Kimono Bathrobe Gown Nightgown Sleepwear Home Leisure Pajamas S M L XL XXL 20701",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b7/b1/b7b1ed62490f448dd5f05b205dad4410.jpg",
    "cost_min": "13.99",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "b897d522-661d-4cdf-9ad6-0d7ed9792a1b",
    "name": "HUISHI Classic Black Bowtie Bow Ties for Mens Butterfly Bowknot Pocket Square Cufflinks Suit Set Bussiness Accessories Gift Box",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2d/3d/2d3d901d1ad56d5c95231f3fd5561ace.jpg",
    "cost_min": "4.70",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "f291d3c8-1ec1-4f2e-b77f-3551514b4da0",
    "name": "7/8/9/10 Pcs Set Travel Organizer Storage Bags Suitcase Packing Cubes Set Cases Portable Luggage Clothes Shoe Tidy Pouch Folding",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f1/3c/f13c38fd2c0eafc3c21fa60e755d90f4.jpg",
    "cost_min": "7.32",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "2aeae348-29ab-44d3-b0c2-c06e36ab7d85",
    "name": "ZADORIN Autumn Winter Cropped Faux Fox Fur Coat Women Luxury Raccoon Long Sleeve Warm Fur Jackets Female Outerwear Pink Red",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/67/01/6701613c176740478dc37e91b0e393c2.jpg",
    "cost_min": "48.24",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "44b2add9-8edc-46ff-9ce6-261219c8f12c",
    "name": "Handmade Kojic Acid Soap With Loofah 100g Lemon Lavender Rose Turmeric Essential Oil Bath Bar New Design Exfoliating Cleansing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7e/fc/7efceecf16180e27577d255047fe2c40.jpg",
    "cost_min": "3.03",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "93ab2f8b-bbba-4968-b117-e097e42e7bc4",
    "name": "1Set RAM Heatsink Radiator Cooling Heat Sink Cooler for DDR2 DDR3 DDR4 Desktop Memory Heat Dissipation Pad",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/74/40/74409128ea6ae4f34a7b84ef94be95a9.jpg",
    "cost_min": "74.28",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "29256325-a088-497b-8247-9cd2303d0b73",
    "name": "18K Gold/Silver Color 6mm Full Sideways Necklace 8/18/20/24 Inch Chain for Woman Men Fashion Wedding Engagement Jewelry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ae/e2/aee267d6b48879f47c2bc40ca3e8fca8.jpg",
    "cost_min": "2.42",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "65486f38-f468-4c25-b658-265705a307c4",
    "name": "Make Friend 1Pc 50x200cm Acoustic Foam Self-Adhesive Egg Crate Sound Insulation Panels High Density for Studio KTV Office Home",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/04/64/0464c4664b71e63b394c0f8167f4fe5c.jpg",
    "cost_min": "18.92",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "f833c72d-869e-4a4d-bf6a-b2d2cfc68d28",
    "name": "Magnetic Stirrer High-Power Magnetic Mixer With Stir Rod 3000 Rpm Max Stirring Volume: 3000ml",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b2/44/b2449fdaf297a62cdc2b519075bbb7b2.png",
    "cost_min": "25.80",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "9881b167-1b83-4b5e-bf48-792b9eabafb0",
    "name": "30Inch 200Grams Red Burgundy Blonde White 613# Nature High Temperature Bio Synthetic Hair Extensions Grey Body Wave Bundles",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e3/c1/e3c19ceabdbd80ed105f2d58f0e521ef.jpg",
    "cost_min": "12.94",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "69b416bc-f4c7-4b0d-bef8-1485d03d68d7",
    "name": "Temperament Elegant Party Diamond Pearl Long Bodycon Dress Women O Neck Long Sleeve Glitter Club Evening Black Sheath Maxi Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f0/76/f076064b3c13090c537169b711ab94f6.jpg",
    "cost_min": "29.52",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2b1dd332-24bf-4755-9706-096178775105",
    "name": "WinvyNee Autumn Women's Vest Wool Tops Y2k Solid v Neck Warm Soft Vest Girls Tank Inner Wear Streetwear Tops Winter C1003013A",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/61/ed/61ed93e570256da4b33556e9200fb226.jpg",
    "cost_min": "37.38",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "356faa52-6f1c-44fc-ba69-f2099e8bd660",
    "name": "Joyroom for Samsung S26 S25 S24 Ultra HD Glass Screen Protector for Galaxy S26 Ultra S26 S26+ Full Cover 9H HD Tempered Glass",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/f1/4af1b4ba41f26982b0968437f56a9a73.jpg",
    "cost_min": "11.08",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "082c3746-d745-4664-84c5-06915e8a4f6e",
    "name": "New White Duck Down Jacket Men Winter Warm Solid Color Hooded Down Coats Thick Duck Parka Mens Down Jackets Winter Outdoor Coat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/78/ad/78ad9a5866ff0b40514e3d8a38c41163.jpg",
    "cost_min": "14.22",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "3037806b-a83f-478d-ad36-0dc06ff86849",
    "name": "2025 New Hot Sale PARIS Jogger Pants for Women's Trousers High Quality Autumn Winter Fleece Casual Sports Sweatpants Women Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/30/e0/30e0277a8e9008d1a9ac25026f6459e0.jpg",
    "cost_min": "3.38",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "fab842c8-4dc2-4b29-863e-8c421b088c1a",
    "name": "No Pull Dog Harness Front Clip Heavy Duty Reflective Easy Control Handle for Large Dog Walking",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/69/f0/69f0ba8c95f37c08a5f8e37a52b0b71d.jpg",
    "cost_min": "5.89",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "697da940-1bc4-4c09-b1e5-e37e909be2c9",
    "name": "2025 Winter Thick Warm Scarf Women Cashmere Shawl and Wraps Pashmina Neckerchief Bufanda Female Rainbow Hairy Tessel Echarpe New",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ba/19/ba1996851d4e9e4221d6436aa2a123d3.jpg",
    "cost_min": "7.16",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f475c0b3-39fd-42c9-bb53-fd7be7abe9ff",
    "name": "23cm New Men's White Handkerchief Colorful Rim Pocket Square for Men Women Party Wedding Groom Suits Black Hankies Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0e/a2/0ea2f7475f59fbeaccb2bf0c08326453.jpg",
    "cost_min": "1.88",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "75c3a087-7065-4a50-9d21-78e2e57cec0a",
    "name": "Long Purple Braided Wigs for Women/Kids Long Ponytail Braided Costume Wigs for Cosplay Wig for Halloween Party Costume Anime",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c0/e8/c0e8ba2820d3060b70988e11354e8bb1.jpg",
    "cost_min": "5.37",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "75aca6f1-e76b-483b-8b54-926c6c26ca60",
    "name": "1Pc 50x200cm Acoustic Foam Self-Adhesive Egg Sound Insulation Panels High Density for Studio KTV Office Home to Isolate Noise",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e0/e7/e0e7da1cd4b0ae5f825877d10c008347.jpg",
    "cost_min": "17.64",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "d017e172-e72b-4b6f-b93a-53e88240967c",
    "name": "5 Dof Humanoid Hand Five Fingers Metal Manipulator Arm Left Right Hand With A0090 Servo for Robot DIY Kit Programmble Robot Hand",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/73/67/73674eef3eaede8c2885d2a6b2893041.jpg",
    "cost_min": "55.29",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "3924ec29-d269-4cbf-9f22-9ee3e43f5d16",
    "name": "Outdoor Sports Long Sleeved Women Slim Yoga Clothes Quick Dry Zipper Cardigan Stand Up Collar Jacket Running Fitness Jacket Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a7/fa/a7fa9922bfdf9c9a52bd25a73663dc0e.jpg",
    "cost_min": "7.77",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "2c504188-f420-4532-b64f-19dbebe4d11f",
    "name": "Catwalk Style Rhinestones Customized Women's Suit 2 Pieces пиджак женски Slim Diamond Luxury Womens Clothing Pant",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/11/47/1147d2ec52c7f0a4c65d2a7b9e231fd8.jpg",
    "cost_min": "191.25",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "258cbbb1-b16e-4533-bbd1-7954d886eb38",
    "name": "JNLN Men's Women's Waterproof Hiking Jacket Quick Dry Sun Protection Windbreaker Camping Hunting Climbing Outdoor Rain Coat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9f/06/9f061da0913070a6bbde35203971fb5c.jpg",
    "cost_min": "8.68",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "ac5d29d9-0c73-4ecd-83bd-8cd8a35bb9d9",
    "name": "Creative Pencil Case Large Capacity Double Layers CPC Certification Safe Material School Case Pouch Stationery for Girls",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8f/cc/8fccaff86fd0146f1271a76e5c78ceff.jpg",
    "cost_min": "6.19",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "833ea128-e13c-4fca-9339-31d13aae2100",
    "name": "1Pcs Golf Hat Clip Magnetic Golf Cap Clips W Magnet Mark Golf Ball Position Removable Metal Various Styles Golf Marker Drop Ship",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f1/7b/f17bd5265db26db8c366c0e417442b8d.jpg",
    "cost_min": "2.44",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "cb45b0b7-28fd-4455-a1be-dbe694671046",
    "name": "Respiratory Muscles Breathing Trainer Sport Electronic Portable Lung Fitness Trainer Exerciser Smart New Product",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/75/54/7554e394529c27571cb5acdd3b1607f2.jpg",
    "cost_min": "34.11",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "d6587f51-84b9-4e62-ada6-284e24b95927",
    "name": "A0NC Mini Car Fridge Cool Heat Cooler and Warmer Box Home Office Car Freezer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/90/84/90844977189ab1c65b55496be9773f07.jpg",
    "cost_min": "9.79",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "15d13069-58d3-4e46-8cbf-624585ea759a",
    "name": "Hot Bloody Rabbit Bear Luminous LED Mask Halloween Horror Bunny Mask Carnival Party Props Cosplay Dress Up Headgear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1e/1f/1e1fb7a5cd57d6b5a945c3c9c309796c.jpg",
    "cost_min": "19.21",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "aa21c20a-4f30-499d-9fe6-0248d6243220",
    "name": "JayCreer  Glider Paraglider Harness",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/05/19/05197577d4df062acbc014aba16ee0e2.jpg",
    "cost_min": "74.32",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "c28d9894-a1a2-4223-97c8-3cd9068257cd",
    "name": "Natalink a Pair SFP+ Fiber Media Converter SC Single Mode BiDi Fiber to 10/100/1000m Gigabit RJ45 Ethernet Converter Transceiver",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5f/c3/5fc3f38363799f0d479b0cc35afd5318.jpg",
    "cost_min": "22.76",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "17fb04e3-873e-44cd-bb34-4a42a30e30fc",
    "name": "9esim V3 Physical eSIM Write Card Mobile Unlimited Download Profile Compatible With Esim Unlocked Mobile Phones Support STK Menu",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4f/bc/4fbc1da5b987f3e6ee7510c4a7042bf5.jpg",
    "cost_min": "37.98",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "0c1d6ab2-c391-48a7-b992-308f12f9a818",
    "name": "Black Carbon Fiber Pattern Plastic License Plate Frame Fiber Black Aluminum Metal Car Tag Holder Tire Screw Cap Universal Amagi",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/47/35/473533317fcf47cb7830adbd0c8a20a5.jpg",
    "cost_min": "2.20",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "6f1a0a54-18bf-4d7e-8647-619ce6f15305",
    "name": "1pcs Applicable to Elevator M*nack Control Panel  Server MDKE MDKE6 Debugger Maintenance Device",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5c/52/5c52fc70f08cd090183b8f6cb25a55e0.png",
    "cost_min": "18.14",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "28c3548c-7619-4937-a64e-11632e162188",
    "name": "JayCreer Airbus Cockpit Windows Sunshade Set for Airbus A330",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ff/71/ff71923be11a311743871a3db103a7ce.jpg",
    "cost_min": "25.45",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "173cac6f-4659-4d07-a3a7-ba8014594e07",
    "name": "FAGADOER Winter New Sexy Fur Patchwork Bodycon Jumpsuits Woman Halter Deep V-Neck Sleeveless Rompers Female Streetwear Overalls",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e6/7a/e67ae844c23c6b6da517f2bcfb3e8a7c.jpg",
    "cost_min": "20.27",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0a7ebc67-62f6-4083-b99a-69fb86fd5ed5",
    "name": "1PCS Elevator Guide Shoe Lining Applicable to KONE Elevator 16mm 10mm Elevator Guide Rail Nylon Sheet Rubber Skin",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ec/aa/ecaa43a65307542f66bcb7efd88dd519.png",
    "cost_min": "2.86",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "317bf21c-6534-4adf-80f4-2a499368dfdd",
    "name": "Drawing Glove Palm Rejection Two Finger Gloves for Apple IPad Capacitive Tablet Screen Artist Right/Left Hand Graphic Tablet",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/37/15/371523abd74d2712b5559b8c64e6bdde.jpg",
    "cost_min": "1.78",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "15190910-82ae-4099-98e2-11666914bb3c",
    "name": "SINGREINY Fashion Lace Sheer Two Pieces Sets Women Lapel Long Sleeves Slim Bodysuits+Elastic Long Pants Ladies Sexy Sets",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0c/bc/0cbca8281259f1d419942a7a7d44d8a6.jpg",
    "cost_min": "24.70",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "e05ea642-9dc9-464d-9684-0c8965902acf",
    "name": "1pcs Applicable to T*yssen Elevator Door Motor Elevator Toothed Pulley K200 Containing Magnetic Ring K300 Without Magnetic Ring",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3f/54/3f5456a0c8b68c476bc8e2107af9c63b.png",
    "cost_min": "5.52",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "48af2e39-074d-4b7c-86f4-c23710d70808",
    "name": "ALWAYSME Cup Holder for Cybex Child Car Seats",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e7/95/e795361b2fcf6b190f051f42fbf95f41.jpg",
    "cost_min": "10.93",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "ede76509-56c3-4fce-8cea-dff6dd5d2697",
    "name": "Women Lace Floral Fake Shirt Skirt Blouse Tail Hem Detachable Underskirt Shirt False Mini Skirt Fake Hem Adjustable Fake Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/49/08/4908c8feea0cae7d2dc080ccf2b104dc.jpg",
    "cost_min": "4.20",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "41e3bf1d-8fd8-4ffe-b8a4-1e0aa537f9f2",
    "name": "3/2/1Pcs Stainless Steel Hanging Clip Anti-Lost Metal Phone Lanyard Tether Tab Card Ultra Thin Cell Phone Sling Piece Patch",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/42/a8/42a86075f84363371cd8efd69848a4f8.jpg",
    "cost_min": "1.57",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "dcd96ddd-9453-4a0f-864d-adf7be75743f",
    "name": "6/12Sheets Bluey Animation Family Cartoon Puzzle Sticker DIY Phone Laptop Luggage Skateboard Graffiti Decals Fun for Kid Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3f/7b/3f7b9c3c1f714a76781ae25cdd2f4621.jpg",
    "cost_min": "2.30",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "4be77943-94ce-4955-89ba-275f77a3adaf",
    "name": "Soft Short Maternity Pants for Pregnant Women Summer High Waist Solid Breathable Elastic Sexy Mini Capris Pregnancy Ice Silk",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a0/b2/a0b2f625876591846a73f4ad00d5828d.jpg",
    "cost_min": "5.53",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "c75f707f-a21d-4e7e-b96c-53d149110cea",
    "name": "Aoweziic  BOM  ONE STOP SERVICE",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6c/90/6c90f731241df8f83478bd1e1416d3b3.jpg",
    "cost_min": "13.57",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "62359c8c-9025-458d-b42c-b5142213c757",
    "name": "Vintage Luxury Designer Super Large Square Sunglasses Women Popular Punk Men Sun Glasses Trending Ladies Shades UV400",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d6/c3/d6c371fb084209fd5a725d4e0bd13504.jpg",
    "cost_min": "8.51",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "2e388802-f35d-43e8-ae1c-fbb4510530eb",
    "name": "1pcs Flat Staple Remover Push Style Portable Magnetic Staples Removal Tool for Office School Stationery A6687",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/66/36/6636144edf74fb18d877d2cdef56b5f6.jpg",
    "cost_min": "2.18",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "3d1203f4-001b-4f16-a152-2fdd1575b3ea",
    "name": "2018 Fashion Mens Cotton White Handkerchief Colorful Rim Pocket Square for Men Women Party Wedding Groom Suits Pocket Hankies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7b/da/7bda2514386ec2c5d57318045d9a7a7e.jpg",
    "cost_min": "1.57",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "4b0ae7ce-0df8-4bd8-b2d6-3bf68d1373ea",
    "name": "Make Friend Music Studio Foam Sound Insulation Panels 12 24 48 50Pcs Acoustic Foam Sound Absorbing Treatment Panels With Tapes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b2/d5/b2d5cd688d34ba006b028201283bb186.jpg",
    "cost_min": "17.83",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "86db6739-123c-49cd-a6a2-f78cadda0d87",
    "name": "Natural Stone Beads Lava Tiger Eye Amazonite Turquoises Jaspers Agates Beads for Jewelry Making DIY Bracelet Necklace 4 6 8 10MM",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/29/af/29af51d1863a941a3c8f46dde1e14c97.jpg",
    "cost_min": "1.33",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "33dad23f-7bfa-4cb3-a625-bdbfe61210dd",
    "name": "New Oil Shiny Women Ultra-Thin Tight Stockings Gloves Transparent Glossy Full Finger Female Club Sexy High Elastic Long Mittens",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c9/0b/c90b9347e460b21465558e98504af993.jpg",
    "cost_min": "4.85",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "c2434239-3853-45f0-83ae-327e85dc4683",
    "name": "Pikachu Charmander Game Storage Card Games Box Card Sleeves Board Game Tarot Poker Cards Protector Multicolor Birthday Gifts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5c/77/5c77e1fcb06916b860db3af89c1ddc54.jpg",
    "cost_min": "3.83",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "0a3c4677-6357-443b-a063-ede227b2c570",
    "name": "Tie Men Business Necktie Set Classic Plaid Cufflinks Handkerchief for Suit Wedding High Quality 3pcs Ties Sets Formal Gravata",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fd/26/fd266d7afca436393aa3c42d085eb459.jpg",
    "cost_min": "3.93",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "96957db4-e771-4c22-8cd8-8d51e60411e9",
    "name": "Metal Adjustable Detachable No Sew Waist Clip Button for Jeans Waist Size Reducer Tool",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f9/42/f942519211c2f5ea90336a34d05bc4e8.jpg",
    "cost_min": "1.70",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "59280410-3f69-4f86-82e2-e6ca5851101e",
    "name": "PGM Golf Gloves,Men's Left/Right Hand Anti-Slip Particles Wear-Resistant Gloves,Microfiber Cloth Golf Gloves ST017",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/18/33/1833d3a3b1b501afbc77c5d81c51e417.jpg",
    "cost_min": "7.23",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "e851e9ce-ba5f-4856-81d6-99fa62e0c582",
    "name": "0-36 Months Ergonomic Baby Carrier Infant Kid Baby Hipseat Sling Front Facing Kangaroo Baby Wrap Carrier for Baby Travel",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/47/b1/47b126c9a977d28d165357b206efc648.jpg",
    "cost_min": "9.88",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "0fcbc60a-65d0-4732-839b-f8ffd3727813",
    "name": "1/2/4/6pcs Nordic XL Dining Chair Covers High Back Stretch Chair Slipcovers Jacquard Chair Seat Cover for Wedding Banquet Party",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/20/2a/202a2e20b3034496a50e6ff8cfa5f265.jpg",
    "cost_min": "19.33",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "508560f6-1a39-4cf4-83d6-d0183d9205cc",
    "name": "Women Knit Real Rex Rabbit Fur Hat Scarf Sets Natural Warm Rex Rabbit Fur Scarves Hat Winter Lady Real Rex Rabbit Fur Hat Scarf",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f4/7a/f47a5bff2a31b14d04ef35ff131cad8b.jpg",
    "cost_min": "11.46",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "366165d1-de5a-47c7-b1bd-de4d2f5430d6",
    "name": "Youth Fashion Street Hooded Plaid Shirt Men's Slim Fit Long Sleeved Shirt Couple Travel Casual Shirt Men's Sports Shirt Jacket",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/49/29/4929e483caa690ea7bc9f1542bdfd948.jpg",
    "cost_min": "11.60",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "8a78419f-cfd1-41b0-a1ec-d66a989954a6",
    "name": "Soda Water Carbon Dioxide Cylinder Tank UFA Universal Fill Adapter Quick Charging Refill Station HPA Adapter on/Off",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/62/d2/62d2ff19e19bdb44f60193895f2350f9.jpg",
    "cost_min": "7.59",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "bd4d44b0-ba01-4f4c-83ac-0c882d535c4b",
    "name": "Men's Solid Color Simple Basic Casual Business Daily Trendy Loose Straight Wide Leg Suit Trousers New Fashion Male Clothes Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3c/8a/3c8a2121882e0a4d3b3303b21e98f0e0.jpg",
    "cost_min": "11.84",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "15a0fdb4-1cfe-4194-8544-8a4b038c2f35",
    "name": "Bag Shoulder Pads for Chanel 25Bag Anti-Slip Leather Shoulder Rest Anti-Strangulation Wide Modified Bag Strap Bag Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/57/2b/572b651d63d43ceadb4a1fb2124d7584.png",
    "cost_min": "8.94",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "969c9fa6-9f9b-485d-a951-5749a9536251",
    "name": "10/20pcs Artificial Flowers Fluorescents Butterfly Home Room Decor Christmas Wreath Wedding Bridal Headwear Brooch Diy Ornaments",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/da/ca/daca2daa5044fd9b5afb7e8031989b71.jpg",
    "cost_min": "2.38",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "d8d74ee9-8ccf-4424-a85f-0960f62dfc49",
    "name": "High End Velvet Suit Coat for Women XS-2XL Customized Double Breasted Autumn Winter Suit Jacket Long Peak Laple Formal Suit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ae/30/ae3097edc7ca5f67727bc245ef3c9615.jpg",
    "cost_min": "91.63",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "3c29df4b-c4b9-43df-830b-c93e1c529dd7",
    "name": "Top Grade Graphene Warmth Technology​ Men's New Winter Parka Jacket Windbreaker Diamond Quilted Bubble Puffer Coats",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7b/8e/7b8ebdc5d9923672863af6991088e507.jpg",
    "cost_min": "72.11",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "58dfacf8-6a49-4457-aa1e-4e66728ecde3",
    "name": "Navy Blue Pinstripe Double-Breasted Suit for Men Wedding - Formal Groom Suit Set With Classic Jacket and Pants Wedding Suits",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0d/b1/0db15664ba64871c26dda1844368bbdb.jpg",
    "cost_min": "88.00",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "fccb17da-8936-441e-8913-8f340c1d9f75",
    "name": "Egg Incubator Controller Temperature Controller for Incubator Incubator Temperature Controller Hatcher Controller ZL-7918A",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/77/f6/77f62af0a9e823b00d79227fb9945a75.jpg",
    "cost_min": "34.70",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "aa90aaa9-f188-40ee-ab6f-9c2bbc53c304",
    "name": "Brand Luxury Women's Winter Down Jacket Coats Parkas Woman Clothes Hooded Cotton Padded Puffer Jackets Bread Outerwear HXY275",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9d/d8/9dd89cb8037de7070b7e83ebf9f78235.jpg",
    "cost_min": "22.79",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "743b3e79-568f-49e4-af7a-550cea786bdf",
    "name": "Garden Solar Lamps Outdoor Wall Light Sconces Outdoor Gardens Decoration Led Lights Sunlight Lamp Lighting Waterproof Furniture",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5f/ce/5fce50f17824fd27250d029d608d7377.jpg",
    "cost_min": "6.40",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "28fca39d-b27d-4002-93ef-b9bccebe8d0d",
    "name": "Personalized Hebrew Name Bracelets for Women Kid Men Jewelry Custom Stainless Steel Nameplate Bracelet Femme Jewish Jewelry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/6f/936f4013745201f98069f7b88ac6d9d1.jpg",
    "cost_min": "4.07",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "cbf9a3b4-cfcc-46aa-b2d3-8b3d67081518",
    "name": "10Pcs Colorful Toothbrush Natural Bamboo Tooth Brush Sets Soft Bristle Charcoal Teeth Eco Bamboo Toothbrushes Dental Oral Care",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/39/47/39474e84e422685ab3e234372e665ab9.jpg",
    "cost_min": "3.86",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "e53ff5df-1951-42be-b8e8-8f21c0f01390",
    "name": "JayCreer Propeller Blades for DJI T30",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/82/99/829968c99ac3c1517075365441b4cc26.jpg",
    "cost_min": "9.70",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "8022c2d4-ddbd-49a6-be70-cbe2e19b1bc4",
    "name": "New Hoodie Men 2025 Autumn Casual Solid Long Sleeve Mens Hoodies Sweatshirts Slim Zipper Hoody Sweatshirt Men Hooded Streetwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0a/be/0abea154d06a18935916ae43518c3c0a.jpg",
    "cost_min": "16.08",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "c2bdb657-2445-4f55-ad63-418fa2b1e1f1",
    "name": "Elastic Sexy Skinny Pencil Jeans for Women Black High Waist Jeans Woman Y2K Streetwear Denim Pants Cargo Jeans Trousers Leggings",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a9/d6/a9d69a654bbd8a585d6b00448797e5ab.jpg",
    "cost_min": "21.28",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "8a6c2516-7c15-4e15-ba9b-dc58aa6f8dad",
    "name": "Black Simplicity Sexy Garter Belt for Women Thigh High Stockings Adjustable Elastic Leg Sock Suspenders Belt 4/6 Metal Clips",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/57/8b/578bd33c0666d555b2c7303b65cb1536.jpg",
    "cost_min": "3.72",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "613eec4a-b4f1-47f2-bd18-2223857b2d39",
    "name": "3 Pcs Newborn Photography Props Baby Sofa Pillows Set Infant Photo Shooting Posing Assist Chair Cushion Fotografia Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cd/ec/cdec3f44bea43e93e8774588c6bd233d.jpg",
    "cost_min": "16.55",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "83907726-3baa-48f2-90d9-2d9795ec94b5",
    "name": "3Pcs/Lot Cartoon Print Baby Pants Cotton Baby Leggings Autumn Toddler Boy Girl Pants Newborn Infant Clothing 3 6 9 12 18 24M",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/64/7f/647fdedbee058bc30129113e6c7f5a7f.jpg",
    "cost_min": "7.80",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "d7f841c8-5072-4438-8195-0a9cb49b4f75",
    "name": "New Men's Muslim Robes Solid Long Sleeve 100% Cotton Stand Button Tops Robes Leisure Vintage Islamic Arab Kaftan Dubai Male",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/79/31/7931eaa988c67eaab3824057bc4318b9.jpg",
    "cost_min": "19.26",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "e52e3e2e-54ac-4516-9e24-f3d057461e5b",
    "name": "Rex Rabbit Fur Coat Winter Thick Women 100% Natural Real Rex Rabbit Fur Jacket Female Warm Soft Genuine Rex Rabbit Fur Overcoat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4e/a9/4ea92c53c12f1f8102feade76c92a9eb.jpg",
    "cost_min": "45000.00",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f6c8cf84-7e49-4ab0-8975-df15db11a3ed",
    "name": "Summer Men's 100% Pure Cotton Casual Loose Fit Plus CALIFORNIA Printed Sports Comfortable Round Neck Short Sleeved T-Shirt Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a7/c5/a7c5d4c6b10b042844501e7a54f7c31d.jpg",
    "cost_min": "6.54",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "366ea43a-d5aa-4700-8b04-79d06a914fcd",
    "name": "Womens 3-Pieces Set Mother of Bride Dress Party Dress Pant Suits Bussiness Elegant Formal Chiffon Plus Size for Formal Wedding",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e7/61/e7612fcb92d7f8934f9fb988c737fa47.png",
    "cost_min": "60.85",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "40a00a41-4d59-4abe-872a-e5fafdbdfb2b",
    "name": "Street Wear Punk Hip Hop Men Suit Y2K New American Gothic Harajuku Embroidery Design Jumper Oversized Casual Loose Sports Suit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/72/7c/727cc133b0b9ed6db8e93afcb911fb14.jpg",
    "cost_min": "25.34",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "4fa475d2-3b6d-42c4-b2c4-0b162f84e05b",
    "name": "New Fashion Hip Hop 100% Cotton Bandana Square Scarf 55cm*55cm Black Red Paisley Headband Printed for Women/Men/Boys/Girls",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f8/f3/f8f350f2560992f744dad1549b0c496d.jpg",
    "cost_min": "1.87",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "a1c184cb-884d-4db2-b388-41217e67433e",
    "name": "Thin Cotton Linen Sunscreen Shirt Women Elegant Vintage Long Sleeve Blouse Women Streetwear Casual Blusas Beach Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/19/b0/19b01b0c03bab1ee8328c9d548c98207.jpg",
    "cost_min": "15.31",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "944f060f-e37f-44f6-8806-5fd669290f1c",
    "name": "50 Strands 8-14inch Natural Loc Extension Human Hair With Curly Ends  100% Human Hair Loc Dreadlock Extension for Men Women Kids",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fb/91/fb917b1623f88bde431732028b7b55e7.jpg",
    "cost_min": "14.87",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "98b9fd87-b78d-41b3-888a-dd450491fe6f",
    "name": "Satin Ribbon 25yards 6mm - 50mm Sash Gift Wrap Bow Handmade DIY Craft Halloween Christmas Wedding Birthday Party Decoration",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/4b/c74b21f22c36a3621a0e7128ab5530d7.jpg",
    "cost_min": "1.71",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "c8e93e1a-48f8-4fb4-ac1d-f7149f1f1422",
    "name": "TZT 10Pcs SMA Female / Male Jack Solder 1.6mm Nut Edge Clip Straight Mount Gold Plated RF Connectors Receptacle Solder",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cd/05/cd0512bf5c3c88c72ec71dbe8d612975.jpg",
    "cost_min": "2.40",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "94d2e969-982b-4511-8bff-ee03ed592335",
    "name": "Cane Webbing 35/40/45/50/60/70/80cm Width Natural Caning Material, Ratan Roll Large Size Rattan Webbing for Furniture Chairs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/27/57/275780ad48f398fc45a91cacd9794143.jpg",
    "cost_min": "13.27",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "66272e90-c4fd-41b4-b22d-3986972dc80a",
    "name": "New 2 Layers Telescopic Magnetic Car Window Shades Mosquito Net Sun Cover Sunshade Uv Protection Block Mesh Curtain for Kid Baby",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/72/22/7222a48505925cb2b16fbcaa7ab144e0.jpg",
    "cost_min": "6.67",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "e13f0c4c-464e-4799-94bb-e78caff4ef6f",
    "name": "925 Sterling Silver Charms Fit Original Bracelets Star Moon Sun Spaceman Pendant Beads DIY Women Necklaces Jewelry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/dc/2e/dc2e00173b1d28d3b150e641a3240bae.jpg",
    "cost_min": "2.71",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "f2c7a413-054e-4654-9f9e-df1e3adf5fa4",
    "name": "Custom Jackets Mens Autumn Loose Baseball Jersey DIY Logo/Graphic Tops Comfortable Coats Basics Pocket Fleece Warm Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b6/14/b614effbc909f0a5099eaba78efc430d.jpg",
    "cost_min": "19.46",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "9a4b0f8f-f2f1-44b7-938a-7118fffb8fb8",
    "name": "TIDRADIO Global Walkie Talkie Long Range 4G 5000KM POC Radio With 1 Year Sim Card for Hiking and Camping",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9c/1b/9c1be100af685f93fe2c065fd468a301.jpg",
    "cost_min": "71.99",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "09f49cca-244f-4d4d-b880-26292aedab4c",
    "name": "The Endless Summer 1966 Surf Documentary T-Shirt",
    "staff_picks": [
      "bestseller",
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/53/45/534592c59fe11ec07698865f27f5abf4.png",
    "cost_min": "13.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "420966a8-a0eb-4a5e-8282-698bce50fd49",
    "name": "6W 110v/220v High Torque AC Gear Reducer Motor With 2GN Gearbox + Speed Controller CW CCW and Bracket Combo for Industry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/39/d4/39d4e7a39b0538b9281dfa640257f29b.jpg",
    "cost_min": "33.84",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "bb11b595-7bfc-4196-933d-4a9ddd2802a6",
    "name": "Summer Soft Platform Slippers Women 2025 Fashion Peep Toe Wedges Flip Flops Woman Light Med Heel Casual Beach Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b3/97/b397ecc409ac4e5971bb4a3664e3cb85.jpg",
    "cost_min": "8.01",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "6b6bfa3e-051e-4e91-af2e-a59d4e387be6",
    "name": "SUPER Worth McGala 83A 110mm Inline Speed Skates Wheel 4X110mm 3X110mm Track Race Marathon Skating Tyre 110 6/8pcs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1a/5b/1a5ba818e8a42dcf85495157511e4414.jpg",
    "cost_min": "31.28",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "e4c5e371-a13b-4534-9c85-4397a6c16516",
    "name": "LED Floodlight Spotlight 10/20/30/50/100/150/200/300w Outdoor Lighting  Waterproof Garage Gym Street Gate Wall Lamps AC220/110V",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9c/cf/9ccf6907c60037bafb402fbf00e93f16.jpg",
    "cost_min": "4.42",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "798b08a9-7ddd-43ff-a4e2-54579179949d",
    "name": "Cane Webbing 35/40/45/50cm Width Rattan Roll, Large Size Natural Rattan Webbing Caning Material Rattan Fabric for Furniture DIY",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/71/1b/711bef447c5c5cc48cc1c3081a6f01f4.jpg",
    "cost_min": "20.74",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "04cb72ee-bd7d-45b2-837a-3724e7529f15",
    "name": "Latin Dance Shoes Women High Heel Silk Dance Shoe Lady Soft Bottom Dance Shoes Heeled 5/7cm Girls Salsa Ballroom Shoe",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1b/08/1b086bdda69c61a3ddaadc0e74d7bebe.jpg",
    "cost_min": "18.94",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "617efb51-12da-4577-bc74-d974af6074cc",
    "name": "AYN THOR Dual Screen Flip Up Handheld Device Protective Case Storage Bag Lanyard Soft Bag for AYN THOR Gaming Accessories Custom",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/23/73/2373e38b029fc958a18c4cf2852711a3.png",
    "cost_min": "11.69",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "50c362cf-e698-40b9-b56c-a963b3ee3105",
    "name": "High-Quality Wedding Ties for Men Fashion New Style Blue Strip Print Neckties Daily Office Apparel Accessories Gift for Man",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/13/51/135123dc3a22a4c91f9af1af740caf0b.jpg",
    "cost_min": "4.65",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "91927c01-813c-4070-9e77-0f5eb0f15872",
    "name": "ETHIKA 1Pcs Sexy Men Underwear Boxers Breathable Swimming Man Underpants Plus Size S-3xl Mens Trunks Men's Panties Boxer Briefs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/ff/36ff341468ec5642fed855b71fbcbb65.jpg",
    "cost_min": "5.43",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "9b9d43c9-b8bc-4bdb-b856-5c46371c4f32",
    "name": "Sexy Women Lantern Sleeve v Neck Solid Maxi Dress Elegant Autumn Ladies Gauze Party Dress Fashion Femme Princess Dress Vestidos",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/c5/c7c5e4855b33e2c96d93e2065ec1f1cb.jpg",
    "cost_min": "29.17",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7cc9ae13-2afc-4b28-b95f-cd2934227260",
    "name": "D16~D42mm Super Strong Neodymium Fishing Hook N52 Heavy Duty Rare Earth Neodymium With Countersunk Hole Eyebolt Salvage Magnetic",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/39/ea/39eacced8b359d8ee7ba45693992e25d.jpg",
    "cost_min": "1.97",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "c46085aa-6eb1-4e7d-b94d-8b6acc55b501",
    "name": "12 Color Lipstick Waterproof Long Lasting Cosmetic Black Blue Purple Green Matte Make Up Lip Gloss Makeup Red Lipstick",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b8/a1/b8a13053d40c1e6206794c8bddd16762.jpg",
    "cost_min": "1.77",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "93c8a1d0-2c68-4e79-88b1-c935b466e19c",
    "name": "35/40/45/50cm Width Rattan Roll, Natural Caning Material, Rattan Cane Webbing Roll Rattan Fabric Rattan Material for Furniture",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ac/61/ac61e1984a24307385a8b6e2a0b71f68.jpg",
    "cost_min": "16.32",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "7d191dff-22a6-41e5-a491-0098eefae3dd",
    "name": "ORUSS Couple Watch Waterproof Casual Fashion Women Men Quartz Watches Ladies Stainless Date Week Men Clock Lover's Date Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ee/34/ee348df3e221492a536afcfbba611422.jpg",
    "cost_min": "7.67",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "b5370c52-f073-4ddb-95ed-e1635b7bd016",
    "name": "Automatic Hair Curler 32MM Auto Rotating Ceramic Hair Roller Professional Curling Iron Curling Wand Hair Waver",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/76/3f/763f163c557b640759fa5e5dffc5ab84.jpg",
    "cost_min": "13.40",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "a777271f-b5b8-49f4-bb8b-5f6ccf8d09a1",
    "name": "POEDAGAR Lovers Wristwatch Mechanical Waterproof Boyfriend Watch Hollow Tourbillon Automatic Stainless Steel Men's Watches Reloj",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d7/b3/d7b35105e181c815b23b5542d59f4efb.jpg",
    "cost_min": "56.49",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "cf29d44b-9877-4526-8d5b-cf69937d8d7c",
    "name": "30×30x1.0cm Anti-Slip Thickening Puzzle Mat Carpet for Baby Children's Room Game Playing Activity & Livingroom & Bedroom",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/47/d0/47d0a3785c69f6da3d5e47cfb66d2dc2.jpg",
    "cost_min": "2.91",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "6f891dab-2ed8-4467-9003-9176840924cd",
    "name": "Soda Water Accessories Cylinder CO2 Refill Station Adaptor With Hose on/Off Adapter W21.8-14 or G3/4 or CGA320 Connector",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/71/f7/71f7970e072431654abce00c72468d32.jpg",
    "cost_min": "30.17",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "9c194708-f0cf-4b5b-af1d-1777302a2b3f",
    "name": "Silk Brocade Jewelry Drawstring Gift Bags Coin Purse Embroidered Candy Chocolate Bag for Wedding Party",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/90/bf/90bf4e2f4a67cfe1bba14dbf55f9589e.jpg",
    "cost_min": "530.00",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "fe9de564-9380-49d4-9cb6-00786fa5794e",
    "name": "FOCUSNORM 0-18m Lovely Baby Girls Sandals Shoes Flexible PU Leather Non-Slip Flower Embroidery Summer Flats Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/08/8c/088c13dc1204f3a68172fbf23d143a5c.jpg",
    "cost_min": "2.90",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "74432c57-f0f7-4965-b121-2202197a3ff6",
    "name": "Dog Clothes Hooded Down Jacket Thickened Fashion Warm Pet Coat Puppy Clothing French Bulldog Pug Costumes for Small Dogs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/12/fb/12fbf836b202c9a5f819bf0d36ac4f62.jpg",
    "cost_min": "7.62",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "87614361-58f4-46ad-867f-200dd31c933e",
    "name": "Newest Women Sexy Elasticity Harness Heart Fashion Bondage Goth Decor Garter Belt Thigh Harness Leather Lingerie for Stockings",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/82/c1/82c12f41beda83a60c50ddf8185c05b2.jpg",
    "cost_min": "1.53",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "155cdeda-9acf-4a37-ba60-35b0ecead727",
    "name": "Vintage Brown Women's Faux Fur Vest Solid High Collar Sleeveless Thicken Female Waistcoat 2025 Autumn Winter New Lady Streetwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fe/63/fe633ec3b5b6231c546ee42f61daa28b.jpg",
    "cost_min": "19.20",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2ea8f2ae-f0c3-4c46-9f99-9c679b16ba4a",
    "name": "10 Sets 1/64 Alloy Car Wheels Pack Tires Diameter 9.8mm/11mm/12mm/13mm/14mm for Hot Wheel/Matchbox/Domeka/Tomy 1:64 Car Model",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/24/5e/245edd9b2a4ef749a64a63776348f813.jpg",
    "cost_min": "5.71",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "c4140e6c-fdb3-4a04-8d7d-5f50493e77a9",
    "name": "Joyroom 1/2/3pcs Tempered Glass for iPhone 16 15 14 13 12 11 Pro Max Screen Protector for iPhone 16 Full Screen Protective Glass",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/66/37/663782e31c709aa85f36e215f10422c2.jpg",
    "cost_min": "4.18",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "c83703c5-71c0-48b6-92e3-b0e6f4180a8e",
    "name": "Sanrio Hello Kitty Tshirt Cartoon Sportswear Women Men V-Neck Loose Casual Lightweight Breathable Streetwear Beach Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c8/bf/c8bf33586a9ba7b67967278dd979129c.jpg",
    "cost_min": "6.98",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "2fd2ae87-93ea-4078-8426-ef3576e28728",
    "name": "Winter Fleece Parkas Men Warm Windproof Jackets Thick Hooded Parka Coat Mens Fur Linner Outerwear Casual Cotton Padded Jacket",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b6/dd/b6dd5cb038895a2b692ea441970e670d.jpg",
    "cost_min": "78.67",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7bc0d557-4c74-45a6-b519-e6820b9a3368",
    "name": "2025 New High Top Canvas Shoes for Women's Korean Edition Long Boot Lace-Up Zipper Comfortable Boot Zapatos De Mujer Tendencia",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/59/83/59834a056a01359ca23987800b74f5d2.jpg",
    "cost_min": "15.06",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "68961a31-7cd2-4176-9ed7-31f6f091bcea",
    "name": "1 Pair Detachable Blouse Wrist Warmers Gauze Elastic Universal Sleeve Cuffs Fake Cuff Women Lace Cuffs Sleeves Sweater Cuffs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/06/97/0697142136b552db468c3a4c87ede9d8.jpg",
    "cost_min": "4.77",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7ccd547f-f807-492e-a773-be0e2b30efcb",
    "name": "20pcs 20-70mm PVD Stainless Steel Eye Flat Ball Head Pins Needle for Beads Earrings Crafts Connector Jewelry Making Materials",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5d/de/5dde6ecb757a3c4cfb4c0a50a253acd7.jpg",
    "cost_min": "3.51",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "0af1ad8d-77de-4c6b-aa3a-202e9ef018c5",
    "name": "Synthetic Hanfu Ancient Style Headband Braid Integrated Headband Wig Women Chinese Style Hair Piece Antique Modelling Cosplay Ha",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/96/64/9664eba6d37eaa76b458e07733a56e53.jpg",
    "cost_min": "5.89",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "9c3a42de-667d-48ae-82c9-05868d6575b5",
    "name": "Lenovo Wireless Bluetooth AI Real-Time Language Translation Earphones 144 Languages Ear Hanging Headphone Translator for Busine",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5d/1c/5d1c8b28f2fd8b50e575d8378eaf0814.png",
    "cost_min": "2.06",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "480893bb-02cb-44ce-89ef-3a98505dd1be",
    "name": "New Autumn/Winter Honda Racing Men's Black Hoodie, Stylish Men's Sweatshirt, Sporty Women's Street Style Pullover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c4/79/c479bb7260c94e6aca5841ee106e9d9d.jpg",
    "cost_min": "11.11",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "9fab511b-a79b-49b0-87eb-ef7cff38d7a3",
    "name": "Girls Swimsuit One-Piece Mermaid Fish Scale Unicorn Children's Swimwear Girls Beachwear 2 3 4 5 6 7 8 Years",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ee/83/ee83fe3431f7959530be5043d4b2081e.jpg",
    "cost_min": "4.67",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "ad397176-a2b8-41bd-9785-be8c54b50f25",
    "name": "Chinese Character Practice Workbook for Primary School Students Grades 1-6 (Simplified Chinese, Textbook Edition)",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f2/81/f28196ef71a73c483bd47273c4d03d81.jpg",
    "cost_min": "6.66",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "08725d41-060e-43e4-80ee-c8abce3ea510",
    "name": "AF3000-02/03 AF4000-04 G1/2 AF4000-06 G3/4 Air Source Processor Pneumatic Pump Filter Oil and Water Separator Manual Drainage",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ae/d4/aed4e9d7270503258bb4bd371ed3c186.jpg",
    "cost_min": "60.54",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "7050119e-aee0-4911-bc84-dcbe9bd14a65",
    "name": "Mailepu 295W Metal Halide Lamp Moving Beam Stage Light Lamp 295w Beam Sharpy Bulb SIRIUS HRI 295W 280w 260w 380w for Mailepu",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/db/66/db66bf249e4a8c8f452eea2361436d44.jpg",
    "cost_min": "14.93",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "afdd9b42-2d31-430f-933f-eafba68baa04",
    "name": "Cotton Baseball Cap for Men and Women, Snapback Hat, Leisure Cap, Fashion Accessories, Wholesale, Fashion",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/35/8f/358feb009477c380945fe4716c02768c.jpg",
    "cost_min": "7.25",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "6b5fd050-38e4-44de-92c5-ececf378b770",
    "name": "Japanese Style Kawaii Girls Swimsuit Sweet Printed Halter Bikini Swimsuit Women Ruffle Bikini Set Bather Bathing Suit Swim",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/68/8d/688d4a05265f0658041b61d656278fe0.jpg",
    "cost_min": "6.87",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "1fd2cd17-29bb-45d3-b2b3-ee88ea0ec70e",
    "name": "Women's Cat Ears Crop Tops Hot Kawaii Solid Color Cropped Hoodies Women Long Sleeve Sweatshirt Harajuku Streetwear Clothes Femme",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1b/ef/1bef1a57ddbfbf3f4e624f6e01e56bf5.jpg",
    "cost_min": "9.96",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "a6ef3226-8550-4989-ae29-290abde36eea",
    "name": "150mm 100mm Electronic Digital Caliper Carbon Fiber Dial Vernier Caliper Gauge Micrometer Measuring Tool Digital Ruler",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/65/81/6581f942b69185f1d84ecef3ff31ede6.jpg",
    "cost_min": "3.76",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "e10f5c6a-b615-463b-956d-03eb07e78c00",
    "name": "2025 Summer New Cycling Sweatpants Trendy Sweatpants Honda Men's and Women's Shorts Motorcycle Enthusiasts Five-Point Shorts HRC",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e8/a5/e8a55418d1d3c18e8c52ae6383bce93e.jpg",
    "cost_min": "7.75",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "5317d11d-0fb3-47dd-849e-f447001b2658",
    "name": "Girls Ballerinas Canvas Soft Sole Ballet Dance Slippers Children Practice Ballerinas Woman Dance Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e8/fa/e8fa9641d11d69590231953d3b059375.jpg",
    "cost_min": "2.56",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "1f2764fc-281d-4b94-8940-6089926eb8a7",
    "name": "Women Boots Cosplay Ladies High Heel Platform Wedges Women High Boots Gothic Buckle Strap Long Tube Leather Female Boots Plus Si",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d4/4d/d44d45d4ef5ec1d94a2a2fe421f855f3.jpg",
    "cost_min": "39.21",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0369f2a3-3f9e-4f05-8866-01af07a6ec78",
    "name": "Sexy Mens Seamless Thong Ice Ultra Thin Sports Fitness Bulge Pouch G-String Male Panties Low Waist Plus Size",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/dc/23/dc23948aa58e88a7752aaa58bd5d168e.jpg",
    "cost_min": "3.78",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "32aa8e2e-c357-44f2-8a38-fd82785a01fa",
    "name": "MAOMAOKONG 2023 Removable Real Fox Fur Collar Coats Woman Winter Jacket Hooded Rabbit Fur Lining Long Parkas Female Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8c/16/8c162dde5294d3d9e7d475f211978284.jpg",
    "cost_min": "240.12",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "3e73ee2c-ba61-4133-bd0c-db9510d25407",
    "name": "30*30cm Thick Baby Mat EVA Leaf Pattern Fitness Floor Mat Yoga Fitness Non-Slip Interlocking Carpet Room Decorative Floor Tile",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/07/a4/07a4ca87eddc8701a54b7e0d81e86110.jpg",
    "cost_min": "4.96",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "13700a49-daed-4f00-97ed-7f7c5be0f3fa",
    "name": "Anti-Theft Backpack Men Waterproof Rucksack Backpacks for Women of Fabric Casual Travel Backpack Senior School Student Schoolbag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8c/33/8c33aeeefa32b703e99a8ae7f3cde826.jpg",
    "cost_min": "19.54",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "b9eddba2-7195-4ad6-a150-c4f503034192",
    "name": "Professional Gym Fitness Breathable Anti-Slip Women Men Half Finger Summer Fishing Cycling Fingerless Gloves Female Bicycle Bike",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fb/da/fbda98fee259e42726ee3a2ed3655190.png",
    "cost_min": "2.37",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "605376d6-3137-4b2f-b810-0d38f9a5084d",
    "name": "24cm Fashion Mens Pocket Square Luxury Hanky Wedding Party Business Chest Towel Tie Suit Accessories for Male White Handkerchief",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f7/f8/f7f864f3f248f9151f9a1604f54d5767.jpg",
    "cost_min": "4.18",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "3da4e9ef-dbee-4858-9ab3-97b551b88e29",
    "name": "1-24pcs IP65 Waterproof Solar Garden Light Outdoor LED Solar Power Deck Lamps for Railing Stairs Step Fence Yard Patio Pathway",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/88/aa/88aa903044fdebc2e69d08975a26088d.jpg",
    "cost_min": "4.79",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "680f4143-0664-4d3c-970a-9dbc22db6a3d",
    "name": "5 Inch Hook and Loop Sandpaper Mixed 30/50/100 Pcs 125mm Assorted 80-10000 Girts for Polishing and Sanding Metal Wood Car Body",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/4b/4a4b64688dc78bf7c5ca5eac799b208e.jpg",
    "cost_min": "17.88",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "cbb300e7-6b55-48b7-857d-47681c3e1c06",
    "name": "1l/2l Refrigerated Bags Oxford Cloth Insulated Water Bottle Storage Bag Suitable for Summer Travel Hiking-Climbing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0c/ba/0cbabd10437dd4903cae0a82a16423eb.jpg",
    "cost_min": "4.64",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "08b4a50a-2f6b-404c-b6aa-de5eb4ad106e",
    "name": "1-3 Toddler Baby Head Protector Safety Corner Guards Prevent Back Injured Angel Bee Cartoon Edge Security Protective Headgear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/54/3a/543a5adb447bc0fd4b31872d7ebd01b4.jpg",
    "cost_min": "7.32",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "737f3132-bd48-4222-8883-737ac6ebb3d4",
    "name": "MAILEPU Multi Model Ballast 295w 132W 5R 200W 7R 230W 8R 250W 9R 260W 10R 280W 12R 14R Beam Moving Headlamp Ballast",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0a/f4/0af44a7c4933776d3248deda852dc3c1.png",
    "cost_min": "21.24",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "787a5139-267d-49d2-9390-f17497db0c71",
    "name": "For Iwatch Series 11 10 9 8 7 6 5 4 SE3 Ultra 1 2 Silicone Strap Sports Band for Apple Watch 49mm 46mm 45mm 44mm 42mm 41mm 40mm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/79/ee/79eed697ca58b275266f92d2a0b5667e.jpg",
    "cost_min": "2.91",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "c021039a-db4d-40f2-a44d-9ea2b49d3439",
    "name": "IEFB Korean Style Vintage Men's Jeans Summer Loose Male Wide Leg Knee Length Shorts New Washed Fashion Short Denim Pants 9A8825",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/08/dd/08dda5f855c37a25a7102cd825773256.jpg",
    "cost_min": "23.12",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "42d85bb4-bdd7-496c-9fad-29e3393af7bd",
    "name": "Instant Lip Plumping Essential Oil Nourishing Antiwrinkle Moisturising Sexy Lip Care Ultimate Plumping Lip Gloss Serum Cosmetics",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5a/dd/5add721d6e416934953826c3ddfd0a2d.jpg",
    "cost_min": "6.90",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "21a16de4-a740-4f61-8c1f-998105c8b4a8",
    "name": "CCMT060204 CCMT09T304 CCMT120404 Internal Turning Tool Carbide Insert High Quality Lathe ToolCNC Steel Processing Turning Insert",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6d/2d/6d2da543bfa194f1355ed693b1bc6ab7.jpg",
    "cost_min": "8.09",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "3427ca78-8e26-4fc9-b965-75540690e01a",
    "name": "LED Neon Sign With USB/Battery for Bar Bedroom Game Room Wedding Party Wall Decor Christmas Gift Customizable Lighting",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b2/f3/b2f39a98539bb57d97b499e38f151195.jpg",
    "cost_min": "5.00",
    "categories": []
  },
  {
    "id": "92dbf330-d417-467f-86b8-8971c62a5946",
    "name": "2026 Muslim Thobe Comfortable Men Caftan Long Sleeve Contrast Color Muslim Clothing Mandarin Neck Muslim Robe for Middle East",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a7/85/a785a5f5d5579150fc29c208fb6748b5.jpg",
    "cost_min": "9.62",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "dc9a61d8-75ce-4e4b-82c4-e74bd5c524e8",
    "name": "99% Alumina Square Crucible Specification 1 Multiple Specifications",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cd/13/cd13fcd0584039f1cb43844a4def8ada.jpg",
    "cost_min": "1.67",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "56f5e6ea-30e3-4816-bc46-5d9186c59b14",
    "name": "Men Watch New Fashion Wooden Quartz Wristwatch BOBO BIRD Top Japanese Movement Business Timepiece Great Gift Box Reloj De Hombre",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/30/56/30568eeb532a223cc744ce6840a31cd4.jpg",
    "cost_min": "17.59",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "78ae1c7e-5d39-4917-b832-6c6ea7ba61da",
    "name": "Personal Mark Black Tone Stainless Steel Classic Men's Wristwatch Customized Family Photo Picture Watch Gift Relogio",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/22/ff/22ff1eefc9e6070611914c315d0d3dd4.jpg",
    "cost_min": "26.99",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "cfb70708-43c2-43a2-a653-8fff10a15ddf",
    "name": "Men's Solid Color Detachable Stand Collar Long Sleeve Casual Business Trendy Down Coats Winter New Fashion Suit Blazers Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/04/63/0463b4f7b4196d490e9ac3fa03d23c62.jpg",
    "cost_min": "44.57",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "e3c4687d-5e3e-4377-bf1b-8462b7def82a",
    "name": "2026 Winter Shiny Hooded Cotton Jacket With Belt Women Elegant Long Sleeve Zipper Lace Up Coats Lady Y2K Street Warm Outerwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/11/02/110202230de99c4376aae3e3c7901ebd.jpg",
    "cost_min": "36.71",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "d589a9a8-9d97-4f08-b7ae-efe80835bbf9",
    "name": "Modern 3D Steam Fireplace Silent Decorative Humidifier Electric Flame LED Water Vapor Fireplace Indoor Remote TV Wall Room Decor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/70/22/70227e2f474a10b2f8f7913eb749eb0b.jpg",
    "cost_min": "386.61",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "f66520e5-78f8-4a31-8512-6f44ac3e739d",
    "name": "Halloween Party Prop Colorful Short Straight Bobo Wig, Funny & Novelty, With Free Frameless Heart-Shaped Sunglasses",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e5/55/e55514b2a150e58928425f3923ac6eb3.jpg",
    "cost_min": "8.93",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "6a2fd35f-8af9-4ef0-9f66-4e94ec3d09b0",
    "name": "Fashion Flower Print Quilted Jacket With Hood for Women Oversized Long Sleeve Zipper Pockets Coat Lady 2025 Winter Outerwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/62/93/62934441aa681e4f2b2cfc5750fe1204.jpg",
    "cost_min": "26.76",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "679724dc-4669-4b23-a581-86db84976684",
    "name": "New Elegant Solid Color Dark Patterned Pocket Square Men's Gentleman Formal Black Handkerchief Business Wedding Party Suit Hanky",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d9/4c/d94c56f03c9aeb40dfec32f7e737aa12.jpg",
    "cost_min": "1.96",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "e1362a85-fbd3-4bae-a31e-a47d1f6f0056",
    "name": "Jirai Kei Sailor Black Dress Lace Patchwork Slim Fit Dresses Japanese Sweet Inner Shorts Set JK School Uniform for Women Girls",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5e/e5/5ee55acf9379673ce222a9125cac2911.jpg",
    "cost_min": "13.32",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "9e32505a-2e3f-4f69-b94d-2e0166302519",
    "name": "Warm Ballerina Boots for Women, Training Shoes, Winter Boots, Up",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/94/ca/94caa567df84ecdcf0a088f38b639e58.jpg",
    "cost_min": "8.92",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "8b33706d-d9c5-4681-8b27-0fab207b2219",
    "name": "Suitable for Lg OLED TV Screen Testing Tool",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/a1/93a1d2b3f2355967f0e9ae1e91e90756.jpg",
    "cost_min": "13.85",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "dffe16ae-0606-452e-88b2-e9f84a296378",
    "name": "Women's Summer Dress Lady Lace Boho Beach Swimsuit Bikini Cover Up Lace-Up Long Blouse Hollow Out Sun Protection Cardigan Shawl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/00/a1/00a19f1429cb3fa1b1359cee74a8ac34.jpg",
    "cost_min": "11.80",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "3f232eb9-b3fb-44c6-bf3e-b02ea6d93e61",
    "name": "Genuine Adult X-Ray Protective Thyroid Collar Hospital Nuclear Power Plant Nuclear Radiation Protection 0.35/0.5mmpb Lead Collar",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8c/7b/8c7bf1fd055db171759aebf0cecf2608.jpg",
    "cost_min": "28.95",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "a5ec2501-0899-402c-aab5-0f5d12d8f097",
    "name": "For Yamaha  MT 03 09 07 MT09 MT03 MT07 MT-09/SP MT-03 2014-2025 Motorcycle Falling Protection Crash Protectors Frame Sliders",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d8/80/d8800099f5cda261e3aabe5396f4448a.jpg",
    "cost_min": "29.07",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "8357cb54-2328-45bf-8736-76d4beda6903",
    "name": "2023 New Women Real Rabbit Fur Mandarin Collar Coat Natural Pure Genuine Whole Skin Fur Jacket Full Pelt Fur Customize WSR61",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5b/e0/5be050ae4591c8d0b3323bbdfc0eafb4.jpg",
    "cost_min": "74.34",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f0099a31-e56f-4a9b-a499-5c59611e1588",
    "name": "Women Blazer Jacket Spring Summer New Thin Cardigan Sun Protection Clothing Hollow Lace Three-Quarter Sleeve Suit Top Ladies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/90/cc/90cc3fd33548cf27beb512acf5be7cac.jpg",
    "cost_min": "10.21",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "ddc6fa46-8554-42d3-8cc9-07368dd897e2",
    "name": "Women's Ankle Boot, Short Boot, Winter Boot With Thick Lining and Insulation, Stylish and Versatile, Thick-Soled Winter Boot",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d5/f4/d5f43cbb763553cdcbc77a153b4430e9.jpg",
    "cost_min": "13.77",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "297c9262-40e7-43f4-84c5-da3477c510e1",
    "name": "2mm  3mm 4mm Transparent Glass Balls Pinball for  Home Decor Fish Tank DIY Jewelry Making Shooting  Traditional Marbles Games",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/45/ae/45ae6dac1151b824608f1b959c954191.jpg",
    "cost_min": "3.96",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "6155f531-ee2d-4c4c-b933-2af3fe68d80f",
    "name": "In Stock Halloween Cosplay Costume 230 Thanos Tracksuit Jacket T-Shirt Pants Suit Teenagers Squid Player 456",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ae/53/ae53a0ccb6a8dbfe409c086f1046017f.jpg",
    "cost_min": "32.48",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "fcdb7568-4e43-4e6a-90ba-8b8255aec3bb",
    "name": "Child Remy Superhero Spider Mask Costume  Halloween CharacterJumpsuit Holiday Performance Wear for Boys & Girl Birthday Party",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/28/9c/289caa3f9f9c87161351f0fd88287bb3.jpg",
    "cost_min": "7.03",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "b91e9762-7c82-418a-b6b0-059ad0286791",
    "name": "New Men's High Neck Sweater Solid Color Pullover Knitted Warm Casual Turtleneck Sweatwear Woolen Mens Winter Outdoor Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0f/29/0f292c07b3be25d0a557d49ea58897e0.jpg",
    "cost_min": "10.02",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "8b9cbf8c-e025-4d7b-a543-12b9e45d2acc",
    "name": "Eco-Friendly Sneakers Sport BYMANYC® New York BROOKLYN BLISS",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/93/ab/93abd877eab80131129e24aaccea96de.png",
    "cost_min": "165.00",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "c186d667-fefb-4b78-9939-f36f375544b2",
    "name": "Luxury Boots BYMANYC® HUDSON STROLL",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a2/61/a2613d8f6e3279c242af8af4febea7c8.png",
    "cost_min": "150.00",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "6c26ae9b-df6a-4643-a604-ccccf92cc5c1",
    "name": "Easy Installation Automatic Shoelaces Without Ties Black White Swivel Buckle Laces Thick Rope Sneakers Shoelace Shoe Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/47/6a/476ad48ec365116f0089c9437e400c33.jpg",
    "cost_min": "4.10",
    "categories": [
      "rts.shoeAccessories"
    ]
  },
  {
    "id": "1a7874ac-24bb-44c8-9322-00cadd52faae",
    "name": "Lightweight Polyester Maternity Long Dress for Comfortable Pregnancy Photo Shoots Feature Stretchy Breathable Fabric A2UB",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/54/1b/541b56e306e1bef3bf3b3ad800b56e11.jpg",
    "cost_min": "26.61",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "ca5e09e8-97d7-4026-8fa9-146b70004eaf",
    "name": "5.5/8mm TYPE-C Android Endoscope HD Camera IP67 Waterproof 6 LED Adjustable Borescope Mini Camera for Sewer Pipeline Inspection",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d7/6c/d76c977e409e4db7e0fd7a779c3d384a.jpg",
    "cost_min": "4.50",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "ccd14c5d-a46f-4e5f-afdf-9591be4c4474",
    "name": "4pcs for GLE MB AMG W203 W204 Mercedes Benz E300 GLC W168 W169 W176 W177 W205 W212 W213 Car Buckle Door Lock Cover Styling",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/40/dd/40dd455f3c8cf658f65f44200d2bc8dd.jpg",
    "cost_min": "6.53",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "8388bbc0-f6ef-4720-86cd-83806eb554c1",
    "name": "HUISHI Fashion Plain Black Suspenders for Men Navy Red Burgundy Braces Unisex Strap Bretels Mannen Women Bow Tie Suspenders Blue",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/79/b1/79b115440adcc426cffafc8f5fe1e4f9.jpg",
    "cost_min": "5.25",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7692906c-1fbc-452c-adab-ddbe060b8293",
    "name": "50pcs Morandi Disposable Face Masks Individually Packaged 3 Layer Breathable Earloop Adult Masks Anti Pollution Protective Mask",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/14/ac/14acfd6642e71069b5d9e1d2bd843bfc.jpg",
    "cost_min": "1.72",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "7deed94b-08cb-486a-92e8-a34824994496",
    "name": "2025 Men's New High Quality Short Sleeve T-Shirt Cotton Sweat Absorption Printed Sports T-Shirt Men Casual Fashion Short Sleeve",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ec/bb/ecbb971437f42876dd07a0f8e37d585c.jpg",
    "cost_min": "6.79",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "51c38b59-33f8-432c-b36b-241dfc9453bc",
    "name": "5pcs/Lot BUK7608-55A BUK7608-55 BUK7608 in Stock",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4c/8e/4c8effb6303705546047cc342c1c9732.jpg",
    "cost_min": "2.22",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "5df86f4d-81ce-42d2-beca-78990fda91ce",
    "name": "VEYDA Women/Man's Eyebrows Hair Eyebrows Six Style 100% Human Hair Artificial Weaving Lace Workers' Hair Braided Eyebrow Wigs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/37/f9/37f9d4ef0e4a407c503486a1101a4bdb.jpg",
    "cost_min": "12.23",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "b4bd5850-7f95-4d20-b73e-1037f0879bbe",
    "name": "High Street Women's Wide Leg Pants Drawstring Y2K Gothic Hip Hop Lady's Cargo Pants Hotsweet Matching Female Trousers Summer New",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/72/56/7256bdf68e95da6170604c2b492c8ac6.jpg",
    "cost_min": "7.79",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "d5790809-537d-4080-9238-b9939aa99773",
    "name": "Jinsihou Durable Green Round Oval Geometry Template Ruler for Architectural Drawing and Furniture Design Resin Measuring Ruler",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/15/92/1592480b7a0c60fd98d811778d52b722.jpg",
    "cost_min": "1.37",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "d94ce3ce-3737-4bc2-a031-d6523b5dd426",
    "name": "Modern Fashion Women's Suit Set Two Piece With Bow Peaked Lapel Solid Color High Quality Business Casual Outfit Jacket Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/37/a3/37a3530fb9051047d40b55864dce80de.png",
    "cost_min": "81.90",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2ee2472c-48d8-470c-a812-fe44d4cd215c",
    "name": "Tuya Zigbee Wifi Smoke Detector Sensor 80DB Alarm Fire Smart Smoke Detector Wifi Fire Protection Home Security Alarm Smart Life",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/57/bb/57bbb949916f6687d5820356499df508.jpg",
    "cost_min": "22.29",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "6fc71098-6200-4499-ab2f-d2a5ae7fa654",
    "name": "Original Raytools Laser Ceramic D28 M11 D32 M14 D19.5 M8 Laser Nozzles Holder for BT240S BM109 BM111 BS06K Laser Cutting Head",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e7/b2/e7b22eddbec7cc3df53e99b1f7867d11.jpg",
    "cost_min": "2.97",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "416dc918-b903-450a-bb53-b84473860fb5",
    "name": "1 Piece of Compression Knee Pad, Shock Resistant Knee Pad, Running Knee Pad, Arthritis Joint Pain Relief Knee Pad, Suitable For",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0d/fc/0dfc40deb71a42b1c22a68199c9eb8c9.png",
    "cost_min": "3.68",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "49ba0718-4000-4fd1-b27c-c94c9346de2e",
    "name": "Motorcycle Bottle Holder Accessories for Bmw R1250gs R1200gs R1300gs R1250/R1200 GS 1250/1200 LC ADV F800gs F750gs Cup Holder",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6e/65/6e65e3ed4885f0ccab21149526bb04ce.jpg",
    "cost_min": "9.22",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "97fa9678-a4ae-4601-bc22-c9ea0bbd33ae",
    "name": "10pcs 1W 3W High Power Warm White/Cool White /Natural White/Red/Green/Blue/Royal Blue IR LED With 20mm Star Pcb",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/07/7b/077b3207f9448b90eef95a677cfa4228.jpg",
    "cost_min": "3.54",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "fe1bee1d-c12e-41ca-b7da-cc86854e9298",
    "name": "Bag Pendant for Birkin Kelly Bag Pegasus Lock Charm All-Steel Animal Metal Lock Bag Pendant High-End Charm Necklace",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1b/ea/1beab59a037e58d7b9fe20d75e371dcc.jpg",
    "cost_min": "18.48",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "b1846abe-592c-4a4b-b085-61fe12f85790",
    "name": "10Styles 6/9/11inch Pain Relief Ice Pack Cooler Bag Reusable Breathable Material Hot & Cold Therapy Injury Care Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4b/e0/4be04589edaa0d43db182d43621bbabc.jpg",
    "cost_min": "3.34",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "a44117de-4e47-42d0-b8f8-7100d9d1686d",
    "name": "WRELS 1/2/3 Pairs Merino Wool Socks Breathable Hiking Socks for Men Women  Sweat Wicking Cushion Socks Winter Warm Sports Socks",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/71/80/71808c08ec8f864f3ceabf7dce2ea6f4.jpg",
    "cost_min": "21.45",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "d56cc7b4-a2e1-42aa-96da-319844300c9b",
    "name": "2024 Casual Sports Suit Men Spring/Fall Cardigan Hoodie Hoodie Trousers Two-Piece Set",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b5/ff/b5ffe093f938ac20df89e6f149305598.jpg",
    "cost_min": "42.85",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "66b8a75c-0645-4adb-aa5e-1efba36f38a1",
    "name": "Mens Hip Hop Watch VintagInspired Retro Quartz Timepiece With Oversized Rhinestone Dial and Durable Stainless Steel Band for Men",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/58/1f/581f3ee2305e0aeac9939aaa39a97d09.jpg",
    "cost_min": "4.77",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "b99bc5f2-3772-4d83-ae30-822ad8d0dfb5",
    "name": "Mini Timing Display Portable Handheld Mini Nail Lamp Family Quick-Drying Flashlight Pen Rechargeable Nail Dryer UV LED Nail Pen",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3f/62/3f62d3900af9385ad1af728e0cae5a13.jpg",
    "cost_min": "4.42",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "28b201b4-ea68-4d65-b847-84013f9b52bf",
    "name": "Silicone Mold for Resin Large Rectangle Tea Plate Coaster DIY Epoxy UV Resin Molds for Home Decoration Craft Making Art Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0b/ff/0bff0f5df80d611ef903351a36f37ac0.jpg",
    "cost_min": "2.27",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "9606eb89-430f-4810-bb0a-e659ef100e86",
    "name": "Motocross Goggles Sunglasses  Glasses Cycling Glasses Man Glasses Motorcycle Goggles Motocross Racing Goggles Motorcycle Glasses",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/19/2d/192dba43c94ff9c315a2ac3c37943637.jpg",
    "cost_min": "6.18",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "63a3419c-fdfb-4055-9daa-eac541091e74",
    "name": "8Pcs/Box Pure Color Basic Style Decoration Washi Masking Tape Creative Scrapbooking Stationary School Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6c/ac/6cac03f77bd242f7d70d93d6583f5415.jpg",
    "cost_min": "2.49",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "30961179-1f58-4c7c-84bc-e760542799de",
    "name": "10M 3mm 3.5mm 4mm 5mm 6mm Double Sided Sticky Foam Tape Adhesive LCD Screen Frameless for TV Borderless Curved Display Sealing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7c/e3/7ce382e5d0a78c9f96d9ac5f08616f11.jpg",
    "cost_min": "3.81",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "e8b789b0-644f-4140-9e5b-543a0afc0d9b",
    "name": "Mini Wired Endoscope Inspection Camera, 1MP Borescope With LED Lighting, 8 / 5.5mm Waterproof USB & Type-C Endoscope for Android",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/10/56/105646cdc50dc02e5817a1e58018804f.png",
    "cost_min": "4.41",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "d319fa00-c612-44a8-aed1-ea4ff64c04fa",
    "name": "Adult Silicone Pacifier for Stress Relief Silicone Soother Pacifiers for Autisms",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ad/ee/adee5b52ea2a6d1223128ea32ecd04a4.jpg",
    "cost_min": "2.73",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "fb8b65f3-c8c2-46b9-99c7-e2e1e3d2a431",
    "name": "LED Warning Canceller Decoder 12V T10 Cable for 501 T 10 W5W 192 168 Car LED Lights Error Load Resistor",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/81/4f/814f9285f8d20d334c1eb79753eb9730.jpg",
    "cost_min": "3.23",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "6fde0e9e-f4f5-43bd-ac5b-63c76c6888aa",
    "name": "Cell Phone Speaker Cleaner Kit for iPhone Samsung Xiaomi Tablet Type C Port Universal Dust Removal Tool Portable Clean Brush Set",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2e/ee/2eeedcac08b27907646e112f5aeefb0f.jpg",
    "cost_min": "2.38",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "5d710ead-632f-4cba-99a0-2bce50424eeb",
    "name": "Persesus Pro IV Pickleball Paddle Ben Johns GEN 4 TFP Foam Core T700 Carbon Fiber Pickleball Rackets Increases Spin & Power",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3d/58/3d581e0ee2f45b07859748c5c77b468e.jpg",
    "cost_min": "36.44",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "09b0282e-5648-47d6-a5b1-cac1f26bb379",
    "name": "Vintage Black Kids Mexican Hat Magician Hat Stage Performance Holiday Costume Hat Top Hats Kids Cosplay Hat Men Women Unisex",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e0/78/e0782d201e46bf7ba5e3332361f14373.png",
    "cost_min": "13.84",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "55ce2362-41cf-4b8c-b2db-7fb8174dd1e1",
    "name": "Tuya Smart Home Security Camera Indoor Smart Wifi Baby Camera",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2f/87/2f874508b864db9edf928625a0858c64.jpg",
    "cost_min": "18.00",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "ed7952e3-dfe3-431c-84be-def9c1bfeb56",
    "name": "1400W 220V Handheld Electric Grade Mixer 6 Gear Adjustable Speed Cement Plaster Mortar Coating Mixer Putty Powder Mixing Machine",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a3/b9/a3b9ae5a5e7fd7e2307cb0ce2827a792.jpg",
    "cost_min": "20.94",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "cc8b29bb-e9ea-400f-a934-25acf1e15a41",
    "name": "Black Buttons Wrist Cuffs Detachable B36D Decorative Detachable Cuffs Short Fake Flared Sleeves",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c1/6f/c16f55e51ac7369c5e9590cc888c2df9.jpg",
    "cost_min": "2.18",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "a2522314-a3f0-4820-b9a7-674fada527fe",
    "name": "Car Modification Water Tank Truck Pickup Truck Off Road Vehicle Backup Water Tank Water Tank With Faucet for Vehicle Models",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ee/d8/eed821c4f0ec60fb04b02ea4be2edfa3.jpg",
    "cost_min": "60.28",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "a52c5431-9d17-4c0c-8280-a03adad16b74",
    "name": "JayCreer Digital Aircraft Audio Recording Cable for Sony / Action Cameras",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/94/1c/941c74c67bb41804250e4bb7e2760236.jpg",
    "cost_min": "48.20",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "f06894d9-f337-47cc-980a-6045802583dd",
    "name": "118 Inch Antenna 433MHZ SMA Male Plug Horn Antenna Works for 400 to 433MHz Receiving",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e0/8d/e08d54c3f945d91b40df156153386dbb.jpg",
    "cost_min": "74.64",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "f95a30a3-bd49-4e1f-9666-f728ff2599b6",
    "name": "Songmont Series Pendant Tiger Tooth Udo Woven Charms Courage Stone Carrying Cylinder Nothing Beads Bag Pack Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/05/a7/05a71d19b52b645c218a154aea55c675.jpg",
    "cost_min": "18.04",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "834f7e03-d239-4b93-b259-ea2bba870d91",
    "name": "JayCreer CYA E6B CRP-5 Plastic Flight Computer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fd/92/fd92c554c1d1bcd13da1450d177a24de.jpg",
    "cost_min": "94.68",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "08ecbe01-513f-45ac-9e69-59ca9572ecf4",
    "name": "PTCG Pokemon Collection Cards Pikachu Umbreon Gengar Latias GX EX v MAX RARE Self Made Single Cards Classic Game Anime Card Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4e/bb/4ebb805be7c43af6d2074cd311784738.jpg",
    "cost_min": "3.38",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "a6c1727d-667b-4346-8a4c-492680dd54e9",
    "name": "JayCreer Tiller Connector for Sailboat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/87/2a/872aad1aac513aec11249617ee67a4a1.jpg",
    "cost_min": "16.50",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "7ec105b6-aa20-4244-a11b-65158221913d",
    "name": "JayCreer Wind Indicator for Sailboat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0a/a7/0aa7ece6493fe3147b85f363a7ee0a32.jpg",
    "cost_min": "20.45",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "2bc379e7-6cc3-4a2e-be1c-344a5e172a03",
    "name": "Rip-Cut Circular Saw Guide Adjustable 65cm Ruler Cutting System Rip Guide for Circular Saws, Precision Edge Guide, 직소기 가이드",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c5/0e/c50eddb7b6799898410499c5a03f526b.jpg",
    "cost_min": "16.28",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "eabf0c36-e73b-4aeb-8fce-865b05ef9ddf",
    "name": "Keychain Buckle for Men Stainless Steel Key Ring Key Chain Hook Outdoor Carabiner Climbing Keyfob Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d2/83/d28363538aef1dc6b534ca8a9c1ef4da.jpg",
    "cost_min": "2.24",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "52c3cbf1-b127-431e-825a-a9c96f9a6884",
    "name": "Caravan Greywater Waste Water Disposal System for Caravans Motorhomes Camper Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b9/c5/b9c52632b66dee10082ef12c9142c926.jpg",
    "cost_min": "27.05",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "1bc5af0d-0cb3-4db9-9eef-073aa7cae10b",
    "name": "Magic Wand for Kids Girl Princesses Glowing Fairy Sticks Little Magic Fairy Music Glitter Sticks Girls Birthday Gifts Toys Chris",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/75/fb/75fb35240568071155bd66d90e317504.jpg",
    "cost_min": "18.45",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "3c2776d6-cdae-4ef1-8125-0aaeeb0d6175",
    "name": "Shave Brush",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1a/fe/1afe2a0841a7930b7175dc06fdba640e.png",
    "cost_min": "6.59",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "8e09d250-f7e6-4f25-909b-9e072e8408f9",
    "name": "Ultra Thin Power Bank for MagSafe,Magnetic Wireless Fast Charging LED Display Portable Battery for iPhone Samsung Phone Airpods",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b4/0c/b40c5681e08aca9a45c373b476e889f6.jpg",
    "cost_min": "25.13",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "13a055d9-d1a4-459e-9d61-81e35e231014",
    "name": "GREATZT 10pcs/Lot MOC3061 GREATZT  3061",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/22/0c/220c2a4d06a1b4fee28551b847635f42.jpg",
    "cost_min": "1.47",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "619260d6-c203-46f1-8ab7-713c025daa20",
    "name": "Moyu Meilong 3x3x3 4x4x4 Professional Magic Cube Carbon Fiber Sticker Speed Cube Square Puzzle Educational Toys for Children",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a5/3d/a53dadd9122194a76de0b39b08e5cf32.jpg",
    "cost_min": "3.60",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "d0d05aae-8e46-4d66-a32c-bb01900286c5",
    "name": "JayCreer Generator Air Filter for DJI T100/T70p/T70/T60/T50/T40 , RATO Edition",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d3/46/d3466acc1672c0dd3a826e15c9924942.jpg",
    "cost_min": "5.20",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "a0f21a7c-e8d1-4136-b6e4-ca875fa176e2",
    "name": "Women 100% Merino Wool Sleeveless Pullovers Turtleneck Sweater Waistcoat Wool Knitwear Spring Autumn Winter Fashion Vest Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/45/9c/459cd641333cb256fade3f75a0b63ce4.jpg",
    "cost_min": "24.09",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "66a2fad6-74c4-4906-bb5d-d2bd6f90d2cf",
    "name": "Tourniquet First Aid Kit Security Protection Camping Equipment Emergency Treatment Tactical Military First Aid Kit Outfit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/61/07/61073f8b076caf69198ae3fbbed558da.jpg",
    "cost_min": "2.93",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "1ac88e96-2a48-4138-a02c-29e3bc9ff9f0",
    "name": "JayCreer Flight Attendants Oxygen Mask Demonstration Props",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/da/07/da07b6efd8f8d6ec03660f5c40697128.jpg",
    "cost_min": "25.78",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "27d3a3ca-2848-4ea0-91d3-612e028391ae",
    "name": "Weightlifti Gym Gloves Fitness Training Fingerless Women Men Bodybuilding Exercise Sports Gloves Cycling Anti Slip Breathable",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1d/5b/1d5bca21f2abe0609bd0e81c3a1f608d.jpg",
    "cost_min": "2.30",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "c3aebfe6-5c23-42ad-b98d-7d568d1252fe",
    "name": "Stainless Steel Kitchen Knife Boning Knife Chef'S Knife Cooking Barbecue Meat Cleaver Paring Knife Kitchen Utensils Pocket Knife",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ed/fe/edfe67244e268053db9b4b7fbd2af848.jpg",
    "cost_min": "4.84",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "fff0f7cc-f6fa-48f2-85e5-2c0168005cc3",
    "name": "Spring Autumn Plus 4XL Knitted Men's Sleepwear Letter Lattice Pajamas Plaid Pajamas Sets Casual Loungewear Pyjamas Night Fashion",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/97/48/9748fed6c6a044f90ecb55614159f79a.jpg",
    "cost_min": "21.36",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "0a2e2429-7edd-4ef5-bef1-99bd6632d42b",
    "name": "New Retro Pink Warm Fur Collar Hooded Short Women Cotton Clothing Fashionable Harajuku High Street Winter Coat for Women",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7f/33/7f33571fa4ae21bddfc33385da7eba7e.jpg",
    "cost_min": "44.78",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "242316e4-d889-4142-8488-2e4a9ba48dfd",
    "name": "Universal Phone Stand on Desk 360° Rotating Multi-Angle Non-Slip Metal Base Foldable Desktop Holder for iPhone Xiaomi Samsung",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/61/8a/618a46fe7b96ef8853181185929978c3.jpg",
    "cost_min": "2.28",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "280aa2c0-8979-44e0-92ba-5a7cf70336de",
    "name": "Mens Clothing IP Trend Casual Shorts Summer Fitness Sports Mesh Breathable Quick Dry Short Pants Man Beach Basketball Sweatpants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d0/c5/d0c5e1453f53001f9d77df04bde55782.jpg",
    "cost_min": "10.84",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "0ce58c3e-c4c2-4c0c-b117-be3f99dd99bd",
    "name": "Stable Power Supply Module 3.3V Suitable for Underwater Camera Camera Module",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ed/43/ed43ebd00dfda7292dde54b6d077a008.jpg",
    "cost_min": "3.78",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "4560f035-ab0c-4c21-a92a-06c7ce73c54a",
    "name": "2Pcs 6.3x32mm Ceramics Fuse DMI 1000V FF315mA FF400mA FF500mA FF630mA FF800mA FF1A FF1.6A FF2A FF 10A~20A for Digital Multimeter",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/20/3e/203edca707330852ab30c2b9bf9eba7b.jpg",
    "cost_min": "8.22",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "eb78c474-9366-46a0-a7a2-205bfaf11fa9",
    "name": "VATLTY Official Genuine Belt Buckle Men Zinc Alloy 36mm Automatic Buckle for 3.4cm to 3.5cm Non-Porous Belt Male Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/09/0c/090c599b86ac22ed4bb8dfa23ec0d64d.jpg",
    "cost_min": "7.29",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "1063e98f-6db1-4b79-a3fd-c99c67b2a3fe",
    "name": "Trolley Luggage 20 24 26 28\" Aluminum Frame Rolling Luggage Case USB Travel Suitcase on Wheels Combination Lock Carry on Luggage",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/db/7a/db7a04d2ee002cb92297c5aef30f4364.jpg",
    "cost_min": "58.93",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "33c68313-9af2-4486-a43a-99b0ab8cb619",
    "name": "5pcs PVC Dust Filter Universal DIY Shield Back Plate for Computer Chassis I/O",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ac/21/ac21de63d24fc9bcaef5ceee92ff79ee.jpg",
    "cost_min": "3.33",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "bcbcbab3-3789-402d-8250-82863b87cc9f",
    "name": "JayCreer Cable Clip for Bose Proflight Series 2 ，A20",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c8/a6/c8a642a1d053d415ab8d84a70729bc58.jpg",
    "cost_min": "6.55",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "b607c22d-f838-45f3-8348-b2188d2d448a",
    "name": "Bambini Receiving Blanket",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f5/5a/f55a0c99af947b0c37a0a8dc63aa7fbf.jpg",
    "cost_min": "5.39",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "6e3b24e6-7d71-4762-bf37-c1491c7ba630",
    "name": "2025 Adult Explorer Vest New Men's Vest Outdoor Running Training Sports Fitness Quick-Drying Breathable Cotton Printed Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e6/df/e6dff5b61b69cb8ec5167aef5f537a08.jpg",
    "cost_min": "9.48",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "0933243f-7f57-4995-89dd-a7510f0854f9",
    "name": "Shield Board 5-12v With 4 Channels Motor 6 Channels Servos for Arduino Robot Kit With PS2 Joystick for ESP32 Robot Car/Arm Kit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c4/7e/c47e68d375731b1079489b99b212a976.jpg",
    "cost_min": "44.87",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "79b1388f-eba6-48ee-83d0-7d955969bace",
    "name": "New Winter Cashmere Knitted Unisex Warm Hat High Quality Solid Leisure Sleeve Hat Men's and Women's High Quality Hat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d2/06/d206994e6eb856fa4953bf9dc25b68d5.jpg",
    "cost_min": "17.60",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "c2186b1b-4aa0-405d-8f73-331a8f4211d1",
    "name": "Seamless Insert Shoulder Pads Cosplay Short Sleeve Fitness Sport Top Wide Shoulder Insert Slim Big Muscle Clothes Female Male",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/dc/40/dc405a8a23da5e38b49b2e9a9762d094.jpg",
    "cost_min": "8.79",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "acc2b698-96c5-47e4-9650-f71ea4c1c8fb",
    "name": "Mens CrewNeck Pullover Sweater Long Sleeve Knitted Sweaters Vintage Lightweight Sweatshirts Soild Color Casual Jacket Coats",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a5/7b/a57b4acf44fe35cc3bdae94da1e1dc3c.jpg",
    "cost_min": "10.11",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "9d0b3e90-1f8e-4bab-9204-7b1e606fca99",
    "name": "YUNXI 24Black 30x30x5cm Broadband Acoustic Foam Panels High Density Studio Sound Absorbing Sponge Sound Isolation Wall Panels",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/89/5e/895e3f1b75f905d6eb92aacedd2fa2cf.jpg",
    "cost_min": "48.07",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "3f6eaa3c-17c2-4523-a3b1-0af7402a91df",
    "name": "Narural Rattan Spline 1–10 Mm, 500 G Round, Caning Material, Reed Spline, Basket Weaving Supplies for Cane Webbing Groove Chair",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a3/23/a323edff675754b3ac3eafcb4583c80b.jpg",
    "cost_min": "25.89",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "69b00265-22e4-4843-909d-2316ac64baca",
    "name": "Clip in Hair Extensions 7 PCS Full Head 22 Inch Long Curly Wavy Synthetic Hair Pieces Natural Wavy for Women Girls Hair",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/21/13/2113f4157ea33d8a15afeaa8e3d4dde2.jpg",
    "cost_min": "4.81",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "88b4441e-04e4-4f4a-a3cd-e808e66dfcf3",
    "name": "Natural Loofah Pad 2-Pack",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8e/45/8e45b5ab3ecdea1f23b56a152e7dcb7d.png",
    "cost_min": "5.99",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "7417580f-2e02-46df-b1ae-52e20a6efe23",
    "name": "IEFB Summer Men's Casual Jeans Shorts Loose Mid High Waist Fashion Knee Lenght Denim Short Pants Vintage Male New Korean 9A8588",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/eb/48/eb4816b3bcb7f3ac58192ff5ccaebf38.jpg",
    "cost_min": "19.62",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7e4a7f1f-bab3-4fce-94ec-aff18df85e4a",
    "name": "38 40 Inch Bone Straight Weave Human Hair Bundles Raw Hair Extensions Brazilian Natural Black 3 4 Bundle Deals Unprocessed",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/84/64/8464e120085fdbf820325c2679600932.jpg",
    "cost_min": "16.38",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "8073de79-aba6-48f2-8445-7c7bbee5a16f",
    "name": "Men's Cotton Short Sleeve Quick Dry T-Shirt for Home Fitness Spring Summer Comfortable Casual Base Layer Top in White Black",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fd/86/fd86561fbdcb6cdcda44032f20179116.jpg",
    "cost_min": "6.79",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "f648715a-e4d4-43b3-9ac1-d264b08566d4",
    "name": "Eye Catching Sparkle Sequined Women Jumpsuits Bodysuits Costumes for Stage Show Female Top Blazer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5e/56/5e561f4d610c21247b3152bcb39fa656.jpg",
    "cost_min": "70.94",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "bd9387db-92a7-4d28-a7d2-6a4ea6e6af88",
    "name": "Duffel Waist Bag Molle Waterproof Fanny Packs Camera Bag EDC Utility Pouch Crossbody With Shoulder Strap Hand Carry",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0e/2c/0e2cf6bf0248f8cba717e808bd2d2a06.jpg",
    "cost_min": "12.42",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "7101e3ca-af51-4041-8db1-bbc7314bcd30",
    "name": "4 in 1 Lens 58mm Mobile Phone Filter Kit CPL ND UV Star With Magnetic Phone Case for iPhone 17 Pro/Pro Max Photography",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/87/5c/875cc9ea7bec4bd9c30c71da3c64acff.jpg",
    "cost_min": "23.11",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "3f679f30-6d08-4ee9-86f1-ab11d00033be",
    "name": "Hoodie Female Hoodie Personality Irregular Crop Ultra Short Style Long Sleeve Top Female Drop Shipping Sweatshirt Y2k Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/84/0e/840ebc41840d641b452382f45fd9a575.jpg",
    "cost_min": "8.22",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "06efc3d9-1976-426a-b698-2c409c9694f0",
    "name": "Canada Fashion Winter Jackets for Man Down Parka Coat Man White Goose Down Jacket Hooded Warm Thick Long Puffer Jacket HXY252",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a7/1c/a71ca2425918e045b913d96925b6be8f.jpg",
    "cost_min": "3.02",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7388e67d-4a50-4d1d-a650-1d0d1f9c941f",
    "name": "0-18m Retro Baby Boots Fashion PU Winter Boys Girls Shoes Non-Slip Soft Sole First Walker Winter Warm Snow Boots Crib Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4c/9c/4c9cf78606a4ed43edea4694dab6aadc.jpg",
    "cost_min": "2.65",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "51e15960-044b-47c4-bd00-8efa5394e08b",
    "name": "50PCS 1.5MM LED Diode Light White Yellow Red Green Orange Blue Warm White Original Color DIP 95-21qrc F1.5 Red Colloid Red",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0e/8e/0e8e31f9be45bfd2574c1462f4cc3c1a.jpg",
    "cost_min": "4.14",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "16acf5d0-2949-4f8a-b4ea-100901f19b97",
    "name": "SFC-200 SFC-300 SFC-400 Air Filter Regulator Air Compressor Oil Water Separator Trap Filter Regulator Valve Automatic Drain",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8c/7e/8c7eca7cf984ed892061c9d786c55562.jpg",
    "cost_min": "40.22",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "0dd55ee9-7fe3-49c4-a26d-47cea12e7eed",
    "name": "Winter Women Rainbow Reflective Horn Hooded Parkas Down Bubble Coat Puffer Jacket Bling Luminous Cute Hooded Down Jacket Outcoat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/46/c7/46c796e7bdde3cc076138ea4dcf11934.jpg",
    "cost_min": "48.49",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "933207fc-35ff-4553-9245-d571889c44bc",
    "name": "Korean Harajuku Messenger Bags Corduroy Women's Small Shoulder Bag Teenager Girl Crossbody Bag Cute Tote Student Bolsa",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/da/c8/dac814072fbe0e8d62f8311c0e304a5f.jpg",
    "cost_min": "6.24",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "f8003e35-520d-4039-bfd1-f424bc24f833",
    "name": "10Pcs Multimeter Ceramic Fuses 7017240 6.3 X 32mm FF 315mA FF500mA FF630mA FF800mA FF1A FF1.6A FF2A DMI 1000V Fast-Acting Fuse",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ad/e1/ade164bb2fda53c29cf63f9fc9d7dbb1.jpg",
    "cost_min": "12.62",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "4bffe720-bcae-4dcb-a7de-494ae08b07d2",
    "name": "Fashion Hat Wig Brimless Cap With Long Curly Wave Hair Extensions Knitted Synthetic Removable Hairs Piece for Women Winter Use",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9e/d1/9ed1443ed1ae522910d670d8c588eb5c.jpg",
    "cost_min": "8.56",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "8acf733e-8aaa-4a0b-abd0-498143714c5d",
    "name": "JayCreer Flush Hose Fitting for Yamaha PWC WaveRunner / Sport Jet Boat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/38/bf/38bf6df5624828d5131b2052eac01084.jpg",
    "cost_min": "6.35",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "96c292c3-3e68-479d-9aaa-1ccba6373cdc",
    "name": "Pet Paw Cleaner Soft Silicone Material Pet Foot Wash Cup Cat and Dog Foot Cleaner Portable Massage Pet Paw Cleaning Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d6/2c/d62ceeb30a078f89abe248a9cf796799.jpg",
    "cost_min": "5.77",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "3eb10303-42bb-4072-bec4-0d4433ac1173",
    "name": "Chic Faux Fur Patchwork Woolen Women's Coat Lapel Full Sleeve Solid Long Coats 2025 Autumn Winter Fashion Female New Outerwears",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/01/62/0162b230b98e080472a4d3d84d915b1c.jpg",
    "cost_min": "39.56",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "60034101-a468-480e-8862-ae70282bcd28",
    "name": "DN15~DN100 Brass Thickened Anti-Reverse Water Check Valve Pipe Thread Plain Inside Screw Spring Swing Vertical Check Valve",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/58/cf/58cfd831914e9678a516406213557ccd.jpg",
    "cost_min": "25.56",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "1a16065a-43dd-4b5b-8275-949066b4c63e",
    "name": "Women Sport Wear Slim Fit Polyester Quick-Drying Full Zip Outdoor Fitness Running Tights Short Sleeves Women's Yoga Wear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fb/79/fb79916a51a097b30cd9a64c1b82f357.jpg",
    "cost_min": "6.50",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "4c8e0b56-e7db-460e-ae5e-9bb1fc52e70f",
    "name": "Sterile Glass Vials Sealed With Rubber Stopper and Burr-Free Aluminum Plastics Cap,Sterile Packaged 20pcs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/50/f0/50f0bb55a36bc5c558580ed2aef2feed.jpg",
    "cost_min": "14.99",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "5ec5f51e-a093-434c-81ad-c473058f3cf0",
    "name": "5/10/20Pcs 14mm Bag Metal Buckles Handbag Strap Tassel Cap Clasp Hook Connector Hanger Rope Cord Lock DIY Hardware Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/42/6e/426ee2bf1fb6f6a1360c8132aad60765.jpg",
    "cost_min": "7.45",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "81d23061-9c8b-426e-8969-b39a75cfae1a",
    "name": "Children's Wide Version Barefoot Shoes Boys and Girls Anti Slip Baby Shoe Childrens Sport Shoe Zero-Drop Healthy Sole Breathable",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1d/e7/1de7d7d0b32ade4f77adc22b73a9458e.jpg",
    "cost_min": "28.42",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "f631c698-b5d0-460a-868e-00d4158a0c5d",
    "name": "Coconut Slippers Men Women EVA Soft Like Stepping on Shit Thick Soled Sandals Solf Non-Slip Wearing Slipper Outdoor Indoor Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ae/48/ae48db719303365cf1183b004a3f6764.jpg",
    "cost_min": "7.82",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "ff239c62-7bcc-4f63-a9b7-0dec7177120b",
    "name": "Retro Solid Stand Collar Long Tweed Coat Women 2025 Fashion Large Lapel Single Breasted Coats With Belt Lady Chic Street Outwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/66/4c/664c5cb57fe4a077935ce0b80b41f3c3.jpg",
    "cost_min": "40.07",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0d92d52a-bc39-45ed-9cc2-a155a1b3a3b2",
    "name": "SmartDevil Full Cover Tempered Glass for iPhone 17 17Pro Max 16ProMax 16Pro Screen Protector for iPhone 15Pro HD Anti-Blue Light",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/16/92/1692c1a3eedad386bb152e0ec8c25676.jpg",
    "cost_min": "7.48",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "960bc3c5-862a-472a-a601-a98baa44d240",
    "name": "2 Pieces Anti-Abrasion Protector Sticker for Inline Skates SEBA Powerslide Falcon Side Sliding Protective Pad Universal Patines",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/89/79/8979baf04682b1eb78c8ee8ff2c1ffb7.jpg",
    "cost_min": "13.05",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "a0ccd9e8-9fc8-411f-9721-937ec6a8555d",
    "name": "Helorpc Industrial Mini PC With Inter I3 I5 Celeron Processor Support WIN10 Linux RS232 WiFi With 4xUSB 1xHDMI 1xVGA Computer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/60/0a/600a737d9c4bd80131dce669919afd8f.jpg",
    "cost_min": "75.74",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "c5eff9f7-46ee-493c-9e7d-45151b694ec1",
    "name": "Stylish Pink Traditional Chinese Silk Satin Blouse Women Summer Vintage Shirt Tops New Flower Clothing S M L XL XXL WS012",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9b/80/9b80859b6ab24c83160e1e93d28e696c.jpg",
    "cost_min": "9.80",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "1b7fb714-3739-4de7-94b5-a2c3bd19debc",
    "name": "Fedora Hat Women Winter Hats for Women Ribbon Band Men's Hat Wide Brim Classic Beige Wedding Church Bowler New Cap Chapeau Femme",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/69/04/690422cf02f0b13f58f81bdcc604c32a.jpg",
    "cost_min": "7.95",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "58fc7f03-40ce-49f6-b938-cc7e4fe1219b",
    "name": "Men Summer Solid Casual Office Breathable Cotton Polo Shirt Fashion Brand Male Business High Quality Striped Short Sleeve Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b4/f3/b4f3ffacf54a572c3d929962fb4a15cd.jpg",
    "cost_min": "6.53",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "a8c01f74-7f69-4526-be09-77df0b6fb57e",
    "name": "10/50 Sheets Holographic Printable Vinyl Sticker Paper Matte/Glossy/Transparent/Silver/Gold Adhesive Sticker for Inkjet Printer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/07/47/074727028ccea295c236cd33c2d69058.jpg",
    "cost_min": "5.14",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "306fad9c-d862-4e06-915c-2fccc4f798ad",
    "name": "Dark Green Satin Bridesmaid Dress for Women A-Line Round Neck Balloon Sleeve Prom Evening Gown Long Custom Wedding Party Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/13/30/1330fb07d27d76ccd0050b60c065a99a.jpg",
    "cost_min": "59.79",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "5e86611b-134d-4a3b-ba85-a401105ec3ca",
    "name": "PWM Electronic Switch Robotic Arm Air Pump Valve Controller Vacuum Suction Cup for Arduino Robot DIY Kit Programmable Robot Kit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/dd/5f/dd5f9048b0208074a201fb4584750a51.jpg",
    "cost_min": "12.09",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "a89ab2b9-d0a7-4b8e-8bb6-d690cfc45e98",
    "name": "Autumn and Winter Models, Men's Waterproof Hiking Shoes, Outdoor PU Leather Sports Shoes, Wear-Resistant,  Walking, Tactical",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5f/f5/5ff5eca83ebfab87c65e7ffe28b534a4.jpg",
    "cost_min": "17.27",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "e7393a6a-68a6-465a-8da9-133c22b0db27",
    "name": "500Pcs 18 Size Mini Screw Nuts DIY Kit Laptop Computer Assemble Repair Screws Fastener Set for Repairing Glasses Mobile Phone",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/86/e2/86e22aba8a4619d5b200641851a5f5ab.jpg",
    "cost_min": "4.48",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "724e6e66-0b9d-42c3-a1c9-71f84ba4ba99",
    "name": "Men's Compression Gym Shorts EVERLAST Printed Sports Pants, Double Layered, Quick Drying Basketball Beach Muscle Fitness",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6d/b0/6db02d42ab17c0349f002b26bab01bf8.jpg",
    "cost_min": "8.74",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "309f3166-1c7f-4696-aa7d-c3c3c2fe9cbc",
    "name": "Watercolor Print Hijab Muslim Marble Scarf Soft Breathable Sun Protection Lightweight Summer Beach Wrap for Women",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d0/6c/d06c32478169e68274cbe61269c1afca.jpg",
    "cost_min": "4.80",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0efe2dfc-d7dd-442d-944d-a50c22c4525f",
    "name": "Women Cheer Dance Outfits Cheerleader Costume Dancewear Hollow Out Cheerleading Uniform Long Sleeve Cheering Team Clothes Sets",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ab/4a/ab4ae8a13a571c9760c10dc340b7d547.jpg",
    "cost_min": "16.66",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "279320ab-b0e3-4ef0-947d-6455e4f8036d",
    "name": "Oak Wood Phone Case",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/aa/b4/aab4f65a46b5f5ceaa04f38c6c601615.jpg",
    "cost_min": "22.37",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "9bb68ac2-adb8-41a3-be28-a60f2f7b5d77",
    "name": "New Fashion Sports Shorts Men Breathable Quick Dry Men's Short Pants Men Breathable Elastic Waist Shorts Male Bottom Black XXXL",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/26/f3/26f3827d8698c2a687623c2037ba8246.jpg",
    "cost_min": "5.66",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "1ca8f90b-0e37-4681-ba51-2c5b412b1063",
    "name": "Pet Hair Remover Reusable Ball Laundry Washing Machine Filter Wool Sticker Cat Hair Remover Pet Fur Lint Catcher Pet Grooming",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4d/01/4d016a97f35500da7d1fdd0889a03cd1.jpg",
    "cost_min": "1.55",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "58f8ac62-ec83-4bd2-a6fb-67c5db5629c6",
    "name": "Chronograph Wristwatch BOBO BIRD Male Quartz Wooden Timepiece Auto Date Stopwatch Multifunctional Relogio Masculino Customized",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c3/cd/c3cd67524ea437750ec76aaf7b18e023.jpg",
    "cost_min": "31.32",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "b363ef83-a30a-4adc-97ba-abf307eb2ae3",
    "name": "31pcs/Set Stainless Steel Wire Rope Kit PVC Guardrail Rope Camping Fixed Camping Clothesline 2mm Kit 10/15/20m",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2b/a4/2ba4cb4b8c38a9a42c44dcb7933647f6.jpg",
    "cost_min": "16.77",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "9ae5444d-4b7d-43ae-9474-d09875f86556",
    "name": "New Baby Ruffle Socks With Rubber Soles Infant Sock Newborn Autumn Children Floor Lace Flowers Shoes Anti Slip Soft Sole Sock",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1c/60/1c60e1274edbf3037de34393e4003b3f.jpg",
    "cost_min": "4.20",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "423f7e01-5c9a-4893-9391-f1fa1e47af4d",
    "name": "Couple Watch BOBO BIRD Wooden Simple Fashion Leather Wristwatch Men and Women Personality Timepiece Great Gift Reloj Luminous",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b2/f9/b2f92502fe5e734433d05558549f996c.jpg",
    "cost_min": "19.46",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "e615aaf4-fdc4-4487-ac17-ac2feacc42e7",
    "name": "Parent-Child Interactive Telescopic Sword Multiplayer Battle Game Decompression Telescopic Toy 3D Stress Relief Fidget Toys",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/9e/bc/9ebceeb117bcd31c6f733f2dc3005462.jpg",
    "cost_min": "2.23",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "ee2ae097-048a-47ca-99f6-96e80ebed7e7",
    "name": "ROSES Red Side High Split Mermaid Evening Dresses One Shoulder Prom Dresses Sweetheart Stain Formal Occasion Dress Customized",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ea/81/ea8101b489572c15c3a2905babfb1c49.jpg",
    "cost_min": "84.50",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "fc8ce5e4-15f0-4996-b77a-4f85ddaf6d4e",
    "name": "24PCS 30x30x5cm Studio Acoustic Soundproof Foam High Density Sound Foam Noise Insulation Sound Absorption Treatment Panels",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/32/43/324311ca1dd85198781ca4673fefc3ae.jpg",
    "cost_min": "24.51",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "04dfbaf9-4104-4ea9-9785-a5b19009c56f",
    "name": "24PCS 2\" X 12\" X 12\" Studio Acoustic Soundproof Foam High Density Sound Foam Noise Insulation Sound Absorption Treatment Panels",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/98/3f/983f33a55c4ff1fe12a90eaf62e71193.jpg",
    "cost_min": "23.23",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "b26c06ac-0927-4478-8c69-1c28c394461f",
    "name": "Personalized Graffiti Roller Skating Bag Men Women Outdoor Sports Roller Skating Backpack Gym Bag Running Fitness Bag Casual Bag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/73/8f/738fa0146dfa5373032be896292c8f12.jpg",
    "cost_min": "24.42",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "749acc43-da17-415f-9f55-e8b4757a4530",
    "name": "Original Aqara Smart Natural Gas Detector ZigBee Gas Leak Alarm Intelligent Linkage Smart Home Security for Xiaomi Home Homekit",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/10/15/1015e78d758c722ff849032b719027a2.jpg",
    "cost_min": "38.48",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "df910720-e220-45af-818a-35e95f0e86d0",
    "name": "H&STAR Synthetic Braided Headband  Hair Band Tooth Non-Slip Fishbone Braid Style Hairdband Pressure Accessories Ladies Headwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b9/af/b9af2f68ee05dcb3a7d4461d4e75cb00.jpg",
    "cost_min": "2.09",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "8ac1be07-be07-48b3-8852-983be1c37d1d",
    "name": "Aqara Smart Natural Gas Detector Zigbee Gas Leak Alarm Intelligent Linkage Smart Home Security for Xiaomi Mi Home Homekit APP",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8c/97/8c973aaf1bbe1ac48e7c234b82f14537.jpg",
    "cost_min": "38.85",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "9f1a6cb9-61f5-4f91-ba83-83685e01ed5a",
    "name": "Autumn Mens Thermal Streetwear Plush Thick Fleece Sweatpant Lambswool Waterproof Trousers Winter Waem Casual Windproof Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b7/65/b7658b128a82e998ffc35dbc96acd807.jpg",
    "cost_min": "11.28",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "1144c55f-392b-4203-a40d-a9f8fad42522",
    "name": "Baby Crib Hanging Rattles Toys Car Seat Toy Soft Mobiles Stroller Crib Cot Spiral Toy Pram Hanging Dolls for Babies Newborn Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6c/71/6c71d9eeef0b8f1453bde5d114e42ab6.jpg",
    "cost_min": "2.49",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "724cdf5f-a804-40ad-a6b0-303bb2490503",
    "name": "QKZ AK3 FiLe Wired Earphone With Microphone HiFi Music Monitor Bass Headphones Noise Cancelling Headset for Sport Gaming Earbuds",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fb/36/fb36bf9df5fd52b20112c00a4eead852.jpg",
    "cost_min": "3.52",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "98ee8ace-a50c-42af-bb52-795c42226564",
    "name": "Plus Size Women Simple Long Sleeve Blouse Chic Korean Style Loose Fit Breathable Shirt Casual Autumn Solid Color Midi Tunic Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2d/ba/2dbae1dddb195b634e6144070ec3945b.jpg",
    "cost_min": "12.63",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "49b75389-09c1-46d7-9132-14e9ff40621a",
    "name": "10Pcs 3x12x4mm Micro V-Groove Wheel Fine Wire Guide Wheel Carbon Steel Bearing Pulley Roller Non-Standard Bearing",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/13/c7/13c7bdcb15dd8bcf0ac1471c21e97346.jpg",
    "cost_min": "9.40",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "9f6996f5-6506-47cc-b069-e6577db74af2",
    "name": "Motorcycle Metal & Brass Alloys Front and Rear Brake Pads for KTM SX SXF EXC EXCF EXCR XC XCW XCF XCFW MXC XCRW SXC 85-625 Parts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e5/5b/e55b7f27d57d5745c5ad81e62219126f.jpg",
    "cost_min": "6.83",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "5454723d-f413-4861-b57d-3a0dd367ba49",
    "name": "New Robot Clamp Gripper Servo Bracket Mount Mechanical Claw Arm Kit for Diy Toy for Arduino Compatible With Mg996,Mg995, DS3218",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f3/ef/f3effe23112f410b988b90ec1b3cdc7b.jpg",
    "cost_min": "13.74",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "2e2d81bc-18c9-49a5-8d02-92db12cde489",
    "name": "DEAT Leisure Full Sleeve Wool Liner Wde Waisted Turn Down Collar Women Slim Patchwork Woolen Coat 2024 Autumn Autumn New TD659",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f4/4e/f44e10e275022446825e78a1a588c80a.jpg",
    "cost_min": "49.22",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "a23f4a91-dbe4-4bdc-9aa0-857fbdb39e77",
    "name": "Deepeel 40mm Pure Brass Belt Head Men's Copper Vintage Dragon Belts Pin Buckle for 36-38mm Waistband Leather Crafts Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f6/72/f6721545a3a4c124d217cbbe139a7200.jpg",
    "cost_min": "8.91",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7f565dba-bca8-44f4-91c6-e037d3208d0e",
    "name": "High Waist Silicone Briefs Women Bikin Elasticity Swimming Trunks Unisex Quick Dry Lining Waterproof Beachwear Pool Party Wear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c0/d6/c0d693c767ea8dde58b4d9315cbd01fa.jpg",
    "cost_min": "7.49",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "17bd15cd-a37a-4dcf-b0fc-c34e664dc299",
    "name": "1/2Pcs Deepeel 35/40mm Vintage Metal Bag Belt Buckle Antique Brass Silver Leather Adjust Pin Clasp DIY Webbing Strap Decor Hook",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/30/ba/30bac9c72c79b346013c50378de62937.jpg",
    "cost_min": "4.39",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7bc001ed-d0c9-43c6-8be0-f7f7dfb7ed3b",
    "name": "Girls Snow Queen Elsa Anna Kids Costumes for Girls 2024 Carnival Party Prom Gown Children Clothing Frozen Jasmine Princess Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5d/c5/5dc507f89a7a26dc50584d99b61bc01f.jpg",
    "cost_min": "6.22",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "64cac7fc-aae2-49c1-b2f0-58b2f4dded08",
    "name": "Detachable Seamless Insert Shoulder Pads Short Sleeve Fitness Top Wide Shoulder Enhancement Slim Muscle Definition Integrated",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e5/27/e527b8a2d9792c18ce6f0b0ce7cada13.jpg",
    "cost_min": "20.15",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "f8c9d074-d863-4331-b4fd-4fb812940229",
    "name": "For Insulin Injection Pen 10pcs 3ml Empty Cassette Bottle Magic Pen Insulin Cartridges Health Medical Beauty Care Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/54/5d/545dfada62a1184d516ca2401013344a.jpg",
    "cost_min": "18.23",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "e46279ac-9c02-4448-ac53-14f26e05a172",
    "name": "Waterproof Hiking Shoes Men‘s Outdoor Trekking Sneakers Mountain Climbing Camping Trainers Hunting Tactical Boots Bike Shoe Male",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7c/7e/7c7e582a4d183ef30753609af4e69936.jpg",
    "cost_min": "22.44",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "6d764223-2b40-4eaa-ab26-64229b7f043d",
    "name": "4PCS MAX Bearing 3800 3801 3802 3803 63800 63802 7901 7902 7903 19307 20307 RS Full Ball Bearings for Bicycle Frame 2RS RSV LLU",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4e/5f/4e5fd42e751923947ddf0cdc09823129.jpg",
    "cost_min": "18.87",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "ff54a163-6636-485f-9ccf-aa329d81e03a",
    "name": "1200pcs/Bag Crystal Refill Pack!Wholesale 5mm Epoch Beads Perlen Magic Water Beados Puzzles Toys Educational Kids Bead 3D Puzzle",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/32/5c/325c7b3c02cbea591135937dc86cc834.jpg",
    "cost_min": "3.55",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "b75317f7-1ff3-46d7-acb6-86e2d5aceaa6",
    "name": "Lightweight, Foldable Portable Travel Aqua Shoes Water Shoes Barefoot Sand Inspired Shoes Beach Snorkeling Swimming Water Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b6/b8/b6b806271c8a64ec2434a0c239fa64de.jpg",
    "cost_min": "7.15",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "0844fded-9515-4172-8f35-72e10d423b3f",
    "name": "Silicone Swimming Trunks Low Waist Briefs Silica Panties Safety Women Anti Embarrassment Underwear Breathable Comfortable Briefs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1c/57/1c576bc0886e7e2d455892e805cade05.jpg",
    "cost_min": "7.49",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "622041dc-d942-4410-8679-a9ccc19f0c7f",
    "name": "3Pin XLR Dmx512 Cable 1.5 Meters 2m 3m DMX Cable DMX Line LED Par Moving Head Light Stage Light XLR Connector Dmx Dj Equipment",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/32/7a/327abaa314239ed969d48356b9c003de.jpg",
    "cost_min": "5.81",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "92a8b766-e780-44f4-bdaa-bca3e80e2a32",
    "name": "Silicone Underwear Waterproof Swimming Trunks Diving Hot Spring Women's Menstrual Swim Rubber Pants Briefs Colorful Soft Party",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/46/1a/461a63a586a9af5cc47a9fa655ba04f0.jpg",
    "cost_min": "7.44",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "49c414c2-9600-471f-b175-49c7a30c9865",
    "name": "New Long Sleeve Henley Shirt Men Cotton Lightweight T-Shirts Men Breathable Streetwear Solid Color Business Button Polo Shirts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/55/a5/55a5a3684bb8ba67c9cf3ae6bc4b84c5.jpg",
    "cost_min": "8.93",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "da06a750-8086-4a47-8664-0db0f5dc97e0",
    "name": "Women's Criss Cross Slim Fit Sports Cami Top Seamless Halter Crop Tee Shirt Tops Workout Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c9/4b/c94b9a6a189a5b457f46e7925a8d979e.jpg",
    "cost_min": "7.45",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "bc1b9884-3469-43e6-906f-1c525d31ed51",
    "name": "144pcs Pokemon Pikachu Action Figure Toys Mini Figures Model Toy Pikachu Anime Kids Doll Birthday Christmas Gifts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/91/c0/91c0015df88f0e2c874ddbd8744a0c34.jpg",
    "cost_min": "3.43",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "e0882ac7-6332-4d4a-8a46-a158226d8c70",
    "name": "MT07 Frame Sliders Crash Protector for YAMAHA MT-07 Fz07 Tracer 2014-2025 Motorcycle Accessories Engine Pad Falling Protection",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0e/9c/0e9c658c019508d7624ce0ad16eb23f9.jpg",
    "cost_min": "31.38",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "c58b4614-d4b8-44d9-8c7d-336ee4bdbdc3",
    "name": "Essager USB4.0 40Gbps OTG Adapter 240W Fast Charging Converter 90 Degree USB Type C Data Adapter for Phone Macbook Laptop 8K60Hz",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ee/5c/ee5c447806a412a5a49d731458fcf9fd.jpg",
    "cost_min": "5.04",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "dab82598-1af5-4119-8523-e8c2a4b1c78c",
    "name": "Baby Shoes Cotton Knit Newborn Girls Boy Footwear 0-18m Fashion Solid Shallow Infant Children Clothing Accessories Bedding Boots",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ed/74/ed7495b46e0a6aae6e80efc4549e2921.jpg",
    "cost_min": "7.03",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "6a104d2a-2cc8-4051-a58a-09d489e25819",
    "name": "YJKVUR Men's Athletic Performance Gym Workout Shorts With Pockets 2026 New  Summer Training Running Jogger With Big Size M-8xl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/57/a2/57a2f92722fa15695ce7e513df12b6c6.jpg",
    "cost_min": "4.87",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "b15224c7-b3ba-465c-9337-4bdc4db66ed8",
    "name": "Thick Warm Women's Winter Down Jackets Coats Parkas Large Fur Collar Hood Woman Cotton Padded Puffer Jacket Outwear Overcoat H01",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7a/48/7a486cd47185384dc7adbe8c9b2c6f2a.jpg",
    "cost_min": "6.41",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "d1a2c1e6-e930-4543-8066-e1a451e377f6",
    "name": "RGB Gaming Light Strip Computer Screen Sync Backlight Monitor Ambient Lighting Smart APP Control DIY Color Modes for Game Room",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/70/c6/70c623431481f12a29bb8ab431ae5fea.jpg",
    "cost_min": "14.46",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "6490444e-d3d8-4e02-b0c3-9e6b71159965",
    "name": "Customized Glitter Bling Bling Wedding Dress Spaghetti Straps Sequins Bridal Gown Sexy Sparkling Party Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0b/88/0b88e709397f85fa5e17e33775795085.jpg",
    "cost_min": "84.94",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "8e1e1bea-c446-4c6a-9ffd-d3465adec5bf",
    "name": "Cotton Linen Shirt Men Henley Neck Pocket Casual Beach Short Sleeve Solid Color Male Tops T-Shirts Vintage Streetwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e6/48/e64856fdbc7376f8bfa7ac42c5d42143.jpg",
    "cost_min": "6.91",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "b8fd2e5d-4486-402c-85ad-41ea69562cbf",
    "name": "USB Rechargeable Luminous Collar Adjustable Led Glowing Dog Collar for Large Small Dogs Cat Night Light Collar Pet Safety Harnes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5a/af/5aaf6aa8167ee7f774f96cd0b50f63b9.jpg",
    "cost_min": "3.72",
    "categories": [
      "rts.pets"
    ]
  },
  {
    "id": "a78f9d27-4bd3-4e0a-91a5-4821704bfb5e",
    "name": "Women Trunks Swimming Anti-Infection Underwear Protect Menstruation Waterproof Silicone Rafting Waterproof Boxers Swimming Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4f/99/4f99a7dcae6f9c4312b5dbc039e47e34.jpg",
    "cost_min": "19.38",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "03b07577-7299-4f71-a460-e771eb96bfba",
    "name": "5.75 Inch Motorcycle LED Headlight Faro Moto Light Halo White DRL Angel Eyes for Dyna Sportster Softail 5 3/4\" Led Moto Headlamp",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8d/4a/8d4aba4ad89d5bd4fb1d6b80d75baee6.jpg",
    "cost_min": "14.55",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "178c5e21-5d64-4b8d-8cac-a89f6d6188a7",
    "name": "18th Century Historical Period Dress for Women Rococo Baroque Elizabeth Ball Gown",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fc/04/fc043416ebb9b29e5e89bb37637ca7e9.jpg",
    "cost_min": "23.45",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "dc05e59c-bf28-4abf-a64c-ab7beada4c12",
    "name": "Men's Slippers Summer Cartoon Bear Indoor Soft Thick Sole Anti Slip Women Exquisite Slides Bathroom  Beach Outdoor Shoes Couple",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5a/95/5a9501ed6e87854c5f48f7c93a2a1764.jpg",
    "cost_min": "3.74",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "2c6f7fcc-7556-4faf-8946-d5eff81ba0f1",
    "name": "Autumn New Arrival Unisex Straight - Leg Workwear Leisure Pants With Water - Repellent Hiking Design",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/66/c8/66c825d3ea0433ef2737a367179c17b1.jpg",
    "cost_min": "37.37",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "4d70e1ea-dc31-4e89-a236-35599244f6d7",
    "name": "Men Faux Leather Sexy Boxer Briefs Comfortable Sport Underwear Luxury Unique Personality Hot Item Breathable Fashion Daily Wear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/bd/41/bd41efc0b7b30d8e96550bcb366338b7.jpg",
    "cost_min": "6.89",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "9918e08d-316a-4d97-8077-c23d667a4edc",
    "name": "30pcs 3D Face Mask Children Disposable Cute Cartoon Prints 3 Layer Ply Dustproof Sanitary Masks Individual Package 4-12 Boy Girl",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0c/be/0cbe22303640264d5a855b0083fc29c2.jpg",
    "cost_min": "3.73",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "0a66ee14-9bc5-48f2-98c8-a8b0c0ec95e3",
    "name": "2026 New Smart Watch Android Phone 1.44''Inch Color Screen Bluetooth Call Blood Oxygen/Pressure Monitoring Smart Watch Women Men",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f3/11/f311887eae661b49246ea95b688067e5.jpg",
    "cost_min": "1.70",
    "categories": [
      "rts.consumerElectronics"
    ]
  },
  {
    "id": "9612d493-4909-4e3c-b873-2c9952c2e5a1",
    "name": "ADEIRS New Feather Hair Extensions 100% Human Hair Real Natural Hair Comfortable and Invisible Black Brown Blonde Straight",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/04/01/040170fedddba7f8bf895dcb0e5d9cc0.jpg",
    "cost_min": "19.70",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "0208980a-f618-4fdf-bfcf-3ecd09f67881",
    "name": "For VK63 Hands C3 Green Luminous Watch Accessories Hands Suitable for VK 63 Quartz Movement Men‘s Watches Parts for Wristwatche",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e6/12/e6120bc0b56a94bbeceefefbde01254f.png",
    "cost_min": "4.42",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "68449c42-8602-4085-982f-c04ad652c8da",
    "name": "New Fashion Hooded Casual Men Coat Winter Windproof Thicken Solid Parka Outdoors Loose Simplicity Comfort Keep Warm Jacket Men",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/32/05/3205deac503dacfba80183fcf6d0017e.jpg",
    "cost_min": "59.98",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "d2f9e453-08db-48f4-9776-0085d8c8fc28",
    "name": "Korean Women Cardigan 2026 Summer Thin Casual Solid Sun-Proof All-Match Knitted V-Neck Sweet Style Candy Color Tops",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c2/4d/c24d7be07bf3f9277275100145b7da29.jpg",
    "cost_min": "6.89",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f1d4620a-0019-40e0-8e05-512c06d69eb8",
    "name": "Custom Name Cloth Weaving Wooden Personalized Baby Pacifier Chain Dummy Nipple Holder Guard Teether Pendant  Newborn Gift Stuff",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c0/2e/c02e888245c71d0cbc9af340505f85c2.jpg",
    "cost_min": "4.25",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "4c107857-4f8c-4e65-9be6-d6441492eda2",
    "name": "PVC Transparent Plastic Mask Windproof Rainproof Non Breathable Smooth Soft Weather Resistant Face Cover for Outdoor Activities",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/6e/48/6e486e06f818cbf296324022bc7a923a.jpg",
    "cost_min": "8.39",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "d979daca-6345-4de9-adbe-face14a6778c",
    "name": "Multi-Functional RFID Blocking Passport Bag Travel Document Holder With Long Zipper Ticket Storage Wallet for Multiple Passports",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ca/05/ca0587390f643227233926b4622cbeda.jpg",
    "cost_min": "6.38",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "76aedb62-8bea-4572-bf9b-446dd738fe54",
    "name": "New Women Autumn Winter Long Style 100% Genuine Real Sliver Fox Fur Vest Natural Fox Fur Sleeveless Coat Lady Real Fox Fur Gilet",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/83/2c/832c4783efbb32e28f079b60427d01d4.jpg",
    "cost_min": "45000.00",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "409ab42d-6dc7-4875-a318-c96c1fa75902",
    "name": "Charming Mini Fish Tank - Perfect Micro Landscape Decoration - Create a Charming Aquatic Display for Your Micro Landscape",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c1/52/c1529e561da5cb075b1693bb3f85b8f7.jpg",
    "cost_min": "3.07",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "c2afd578-39be-4b02-9611-61b307fcd5c1",
    "name": "The Latest MKSD Ultra V5.5 Unlocking Card Stickers for IPhone 6/7/8/X/Xs/Xr/Xsmax/11/12/13pm All Series MKSD Black/Mksd Blue",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ac/82/ac82684193b30fafed0dd4838f2ae316.png",
    "cost_min": "2.95",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "5d4d874a-63b6-477a-9e6a-6e4a1af69da2",
    "name": "Ninjas Theme Birthday Decorations Paper Tableware Plate Cup Tablecloth Kids Banner Cake Toppers Halloween Party Supplies",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f5/c7/f5c7565038959d83b76fe33b0e9a7b30.jpg",
    "cost_min": "32.86",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "fe2fdc4c-d4d2-4b06-b65a-d98bf396e9e1",
    "name": "40mm Men Pure Copper Pin Buckle Stainless Steel Waistband Clasp Pants Single/Double Pins Belt Hook DIY Leather Craft Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2a/4e/2a4e07d0a90787ebfec66a3d6b0ecdf8.jpg",
    "cost_min": "8.86",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7eeb8144-0811-4a36-b0a7-e18d97f1c25e",
    "name": "25Honda Summer CBR1000RR Motorcycle Fitness Shorts Factory Men's and Women's Shorts Sports Casual Pants Locomotive Printed Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/de/55/de5549db36cbfba19b04e591c804bab2.jpg",
    "cost_min": "6.69",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "32f1e3fa-6431-4b2f-950f-7cc4355fc47d",
    "name": "2 in 1 Compression Shorts for Men Gym Workout Running Shorts With Phone Pockets Athletic Quick Dry Activewear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fc/c2/fcc2a0a02b7a9545abd27ba1e14a8943.jpg",
    "cost_min": "8.98",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "2c1a2b0a-eff2-4a93-8a62-57b27db5b923",
    "name": "Summer Flower Printed Women's Sexy Low-Cut Dress Sleeveless Backless Slim Sling Dresses 2025 Beach Vacation Lady Vestidos",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/11/b7/11b7f20977c67aee8b919f16eed3f3c5.jpg",
    "cost_min": "25.91",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "2d8c09e7-da04-4953-ac8b-dcb5244ad8b6",
    "name": "Body Wave 100% Brazilian Clip in Hair Extensions Human Hair 8Pcs Remy Hair Extensions Clip Ins for Women With 18Clips 120g",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/f7/c2/f7c28d46392dd220814bc8574942a37e.jpg",
    "cost_min": "41.29",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "39cb36c8-89e4-4736-a207-b41874b273bf",
    "name": "Brand Men Turtleneck Sweaters and Pullovers 2023 New Fashion Knitted Sweater Winter Men Pullover Homme Wool Casual Solid Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/26/2f/262f76bad897eeaf8628ae7524063150.jpg",
    "cost_min": "23.24",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "6f89ffc8-53d2-4f25-bdec-d896232c4369",
    "name": "Womens Metallic Faux Leather Cheerleading Uniform Costume CheerDancewear Strappy Crop Tops Vest Double Layered Ruffle Mini Skirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/e2/36e2ccab7f86dbdbcb693a0409a9441a.jpg",
    "cost_min": "14.87",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "b72a1e17-8816-4a2e-b7c3-ee4251edb236",
    "name": "Original Ultra-Simple High Quality Men's Leather Document Baotou Layer Cowhide Computer Bag Business Trip Office Handbag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0f/1f/0f1f898eb949323017ee93a93bc2897d.jpg",
    "cost_min": "107.59",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "c14f7b60-ca3a-4e52-be5a-f35c492cda92",
    "name": "ESPLB Canvas Roll Tool Bag Multi-Purpose Organizer Bucket Handbag Car First Aid Kit Wrap Roll Storage Case",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/78/9b/789bf454022d69c7bedaed586fa222f8.jpg",
    "cost_min": "9.33",
    "categories": [
      "rts.tools"
    ]
  },
  {
    "id": "1d7ddbd7-7633-4510-a3af-b2317e2f85c9",
    "name": "15A Burmese Curly Bundles 3C4A Spiral Curly Hair Bundles Virgin Hair Burmese Vietnamese Raw Human Hair Extensions 1/3/4 Pcs",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a1/59/a159b5abfc25fd68bc70f2a5f174be55.png",
    "cost_min": "26.91",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "18c4f36c-b5f1-4c80-8ab8-1eefaf8a4328",
    "name": "Men's Summer 100% Cotton Fashionable Casual Loose Large Size FAITH HOPE LOVE Printed Sports Round Neck Short Sleeve T-Shirt Top",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7d/a9/7da9912cac035df9ea98c80e602774cd.jpg",
    "cost_min": "5.91",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "2e84e902-8e4d-43f3-9306-1a55765b1cb7",
    "name": "Honda Zipper Hoodie Outdoor Sports Enthusiasts 2025 New Men and Women Fashion Half Zipper Pocket Spring and Autumn Hoodie",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7b/e1/7be12a721bc51167d0e8f9bbf3b5d220.jpg",
    "cost_min": "19.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "69e5fa84-83f7-47f1-b275-bc3f30457e3f",
    "name": "Newborn Baby Shoes Knit Infant Boys Girls Boots Fashion Patchwork Flanging Toddler Kid Crib Shoes 0-18m Chlid Footwear Cute Warm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ab/e5/abe5eee7a646c43897cf90674a1b529a.jpg",
    "cost_min": "5.83",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "13fe589c-d6a9-4652-961a-12c7419f2e07",
    "name": "100pcs/Lot 125Khz Proximity RFID EM4305 T5577  Smart Card Read and Rewriteable Token Tag Keyfobs Keychains Access Control",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/36/1b/361b0c1caa183d42517837ec736524cf.jpg",
    "cost_min": "31.10",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "21d49c27-b177-41fa-a7c9-62306b303ee8",
    "name": "4.5-29mm/19-40mm Round Cable Stripper Fiber Optic Tool Optical Fiber Cable Jacket Slitter Longitudinal Transverse Dual Use",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/39/97/3997c0a0798eb2a59a0ca889be1701e4.jpg",
    "cost_min": "0.97",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "ffffbd83-ebfc-4056-bc99-377211603321",
    "name": "2024 Long Sleeve Beading Wedding Dress  Square Collar Luxury Sweep Train Winter Bridal Gowns Vestido De Noiva Customized",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b3/06/b3066aab639611a5a74c4b4b8246b23d.jpg",
    "cost_min": "95.40",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "76b534cb-93e0-41e8-a25f-618bfa95cc11",
    "name": "Hot Sale GS Adventure Motorrad Commemorative T Shirt Outdoor Motorcycle Riding Comfortable Top for Adventure Bike Lovers",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2c/53/2c535e63fe381800a505c8c114c9b940.jpg",
    "cost_min": "7.25",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "b3210370-8c17-4b34-9179-cd415948e163",
    "name": "【US Plug】UGREEN 20W 30W GaN Charger Mini PD 3.0 USB C Phone Charger for iPhone 16 15 14 Pro Samsung S25 Xiaomi Tablet iPad Air",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/94/1d/941d2de54311cf800cab32f9c358cb7b.jpg",
    "cost_min": "5.93",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "78410c47-8f43-4f0e-a5b1-e124ec40d3f9",
    "name": "Cute Pear Night Light 7-Color Dimmable Touch-Controlled Night Light Silicone Stress Reducing Pat Duck Lamp USB Rechargeable",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3f/f3/3ff3abd7cb36f92bc1c4d21e4e40d685.jpg",
    "cost_min": "84.71",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "b8943373-1508-4911-a2bc-e0ff3b48f18b",
    "name": "2pcs LED Fog Light H8 H11 H3 H7 5050SMD 9005 Hb3 H27 880 881 RGB Colorful 5050 H1 Bulbs Car Front Fog Lights Remote 12V White",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/20/45/2045615a89a6a99278f4e07e41780eb8.jpg",
    "cost_min": "3.82",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "99e675ad-b64d-4163-8c9f-7d5cef06df2a",
    "name": "HUISHI Solid Handkerchief Vintage Fashion Party Pocket Hanky for Suit Men's Handkerchief Groomsmen Pocket Square Hanker",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/80/6a/806ad81a1523fda1ab2182bf5df1c8b7.jpg",
    "cost_min": "3.26",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "f0869ee8-74ee-4a8d-8bb9-e378281ee112",
    "name": "Women's Yoga Short Sports Jacket With Gold Zipper - Slim Fit Gym Workout Jacket",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7c/af/7caffa6adcd01590227c9287357a06f8.jpg",
    "cost_min": "23.63",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "55ca67ae-3fea-4566-9654-fe428880734d",
    "name": "2.8 Inch Large Screen Instant Print Camera, HD Digital Video Camera for Kids, Outdoor Zero Ink Portable Print Toy Camera",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/5f/e2/5fe2d2eabed1f78c96600278d8b2fe7e.png",
    "cost_min": "2.64",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "aab3fcff-4548-4dec-9fdb-59ff469f14a9",
    "name": "EDECPBM Customized Long Evening Dresses for Special Occasions Vestidos De Fiesta Luxury Prom Dresses 2025 Wedding Party Dress",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ae/99/ae994db1a6514a36b9da523d897dccf4.jpg",
    "cost_min": "86.24",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "1befe1ec-2e1d-49aa-b583-daa0d98f1d57",
    "name": "Custom Name Wooden Personalized Baby Pacifier Chain Silicone Bead Dummy Nipple Holder Guard Teether Pendant  Newborn Gift Stuff",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/62/60/62602515aef0acf0587107c6d5fb802e.jpg",
    "cost_min": "4.35",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "e9b62bb8-baad-4474-bc2d-0d6482a521e4",
    "name": "Sports Shorts Women Casual Fitness Shorts Cycling Running Wearing Causal Thin Anti-Walking Gym Yoga Hot Pants Bottoms Mujer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0e/b9/0eb9783699f45493205ea767472f4dc1.jpg",
    "cost_min": "2.68",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "08b1cee1-097c-4bd6-808e-1744e1597fee",
    "name": "KPop Demon Hunter Print Backpack Set With Lunch Bag and Pencil Bag, Large Capacity Lightweight and Breathable Outdoor Knapsack",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cf/a1/cfa1417c3ce7641e8639d0c82e4ff2fd.jpg",
    "cost_min": "26.06",
    "categories": [
      "rts.bagsLuggage"
    ]
  },
  {
    "id": "e977316e-cad0-4f53-abaf-6644f44ca5ec",
    "name": "LED Grow Light Full Spectrum USB Grow Light Strip 0.5m 1m 2m 2835 Chip LED Phyto Lamp for Plants Flowers Greenhouse Hydroponic",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/14/7b/147b70c1976efc0610a5100af9bb9abb.jpg",
    "cost_min": "2.02",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "9c7f90cf-e058-4f74-863e-45661888ca73",
    "name": "Men Women Beach Swimming Water Sports Socks Barefoot Sports Water Shoes Fitness Dance Swimming Surf Snorkeling Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/49/d2/49d2bc909169fe95b670947d904e78f8.jpg",
    "cost_min": "8.01",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "6d81163a-f5a4-412f-908c-52a94e3a1b45",
    "name": "8mm 2026 NL DV BE Bird Ring With Letters Cards for Pigeon Rings",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/12/1c/121caec9634f33fd9576f41e0552c742.jpg",
    "cost_min": "11.91",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "dfc6d561-0545-488e-a31c-e67da1ab0bd2",
    "name": "10-100Pcs Stainless Steel Material Durable Barber Shaving Blade Double Edge Safety Razor Extra Stainless Blades",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/60/56/60560e153c5746ecbaedc6140a069eb9.jpg",
    "cost_min": "2.05",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "589bc8f5-7e4c-4788-a923-3b8a7967e11e",
    "name": "Cotton Linen Shirt Men Henley Neck Pocket Casual Beach Short Sleeve Solid Color Male Tops T-Shirts Vintage Streetwear",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e1/9a/e19a259fe5426e883cd4fa45cdc2b61e.jpg",
    "cost_min": "7.16",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "45b7414d-b8fe-41e7-a7b0-7b87c159ae42",
    "name": "1/5/10pcs Pink Color Handle Anti-Slip Splicing and Fixing Jewelry Pliers Tools & Repair Kit, for DIY Jewelery Making",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/42/c7/42c7b89e94d0d24ad7f4fce6fcc14b04.jpg",
    "cost_min": "2.48",
    "categories": [
      "rts.jewelryAccessories"
    ]
  },
  {
    "id": "b88f236d-3959-4d7f-be7d-065c156a48ce",
    "name": "Woman Boots Knee High Platform Chunky Heels Trend Punk Gothic New Rock Leather Fashion Women's Shoes Motorcycle Footwear Q221",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7a/b6/7ab6cc2600e4e79cd679c50ebd5f5a8a.jpg",
    "cost_min": "21.64",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "52491041-bd11-4afa-960f-3d5e7e1b070b",
    "name": "New Arrival LED Luminous Cosplay Anime Mask Neon Light Up Fox Mask Halloween Party Mask Carnival Party Led Mask",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/05/c8/05c8d9d8205cb29f7728444157369d11.jpg",
    "cost_min": "19.58",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "b0671620-b0ed-49ed-b5f4-e7552f6da63c",
    "name": "2Pcs Patellar Tendon Support Strap for Knee Pain Relief Knee Bands for Basketball, Running and Hiking, Silicone Patella Band",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cf/29/cf2922d9f74d2abd3b6ef6138f2719ec.jpg",
    "cost_min": "0.74",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f2d47fab-33aa-406d-8cf6-f5c438749179",
    "name": "1/2Pcs Quick Attach Buckle, Durable ABS Waist Bag Clip for Outdoor Lovers & Regular Equipment Switchers DIY Tools",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/08/be/08be283b28ae1fa7a56ff843511edd8a.jpg",
    "cost_min": "1.83",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "04886f58-624a-4210-b72b-7cb8417ec16a",
    "name": "Women Two Tone Fluffy Push Up Underwire Bra Panty Set Winter Warm Soft Comfortable Cute Fresh Plush Lingerie Lightweight Design",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/bb/93/bb93e23f7023fbdd4e33f9798275e0df.jpg",
    "cost_min": "13.19",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "f2973c11-da56-486e-8cc0-3c92fc3f9c09",
    "name": "Baby Fitted Bassinet Sheet Newborn Changing Pad Cover Solid/Printed Breathable Crib Fitted Sheets Cradles Mattress Cover",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0b/37/0b372be5700d5f73f733ef6ace7e9fe8.jpg",
    "cost_min": "7.35",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "d0182cfb-eb7e-4e96-85f3-0ca307c6a740",
    "name": "Pregnant Women Support Belly Band Back Clothes Belt Adjustable Waist Care Maternity Abdomen Brace Protector Pregnancy Care Belts",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ef/68/ef6896f5cba50acb8f9d69cb35d62f09.jpg",
    "cost_min": "6.84",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "f6aebd2b-010a-49e3-a688-0fda82084309",
    "name": "Camping Car Accessory Foldable Trash Can Large-Capacity Material Easy-To-Clean for Motorhome Home Car Kitchen",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/98/89/9889792468f2a7c814a8e2330dd411f1.jpg",
    "cost_min": "7.83",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "db993dba-c287-407a-b6e0-8ac54998350a",
    "name": "Kids Cartoon Multi-Functions Digital Camera Portable Selfie Toddler Video Camera Thermal Printer Video Educational Toys Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/8c/76/8c761b2962bef0ff4bf4566b6a0637ac.jpg",
    "cost_min": "4.04",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "606e4091-eb72-41f6-a9ef-68bf3f8a96b4",
    "name": "200pcs, Custom Business Cards/Cards, Business Cards, Desktop Business Cards, Thank You Cards, Business Cards, Waterproof Surface",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a7/06/a706db3e2f619c4e1bb7d4fd0a02009f.jpg",
    "cost_min": "6.48",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "a034b489-23b2-4454-b7cf-6020d47ed0ff",
    "name": "2026 Pocket Monster Pikachu Full Over Print Adult Pajama Pants Matching Family Outfits Early Spring Flannel Comfy Casual Pants",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/39/9c/399c21eefd30dce629631ff51a4d49cd.png",
    "cost_min": "15.22",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "d1e36675-d956-4d7e-8ac5-8497a98e51be",
    "name": "Women Summer Sun Protection Coat Lace Bow Ruffle Cardigan Shirt Female Blouse Tops for Woman Covers Blusa White Y2K Korean Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0e/b5/0eb5f478d981401b8c427635c79f3188.jpg",
    "cost_min": "5.71",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "9dcf2728-2ade-4f18-9937-135c71167aee",
    "name": "Baby Blanket Hat Set Cartoon Printed Cotton Newborn Swaddle Adjustable Infant Sleeping Swaddle Wraps All Seasons 0-6 Months",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/cd/64/cd64bf79d04c24e7be7adc0cec86de48.jpg",
    "cost_min": "5.90",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "b801bb94-176c-4da6-8c83-684d684ae9f4",
    "name": "Xiaomi Mijia Honeywell Fire Alarm Smoke Detector Gas Detector Bluetooth Work With Multi-Function Gateway 3 Smart Home Security",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/14/78/14788ec20a3b4682c0fd24a31f9a87f2.jpg",
    "cost_min": "39.54",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "63b172c2-0538-4e9f-9bbe-9b61eef12ca1",
    "name": "Women's Baggy Cargo Jeans Abi Y2k Japanese Streetwear Hip-Pop Goblin Core Cyber Punk Denim Pants Grunge Designer Harajuku Cowboy",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/15/24/15240116ccbd5cee839a9e37a51a1e3f.jpg",
    "cost_min": "46.28",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "98911722-6d0e-468c-b602-20931ebf6b0c",
    "name": "BOBO BIRD Luxury Watch Men Metal Wooden Chronograph Man's Quartz Wristwatch Male Auto Date Clock Armbanduhr Custom Logo Dropship",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2f/77/2f77542bcaf407cb13176d99f45fc233.jpg",
    "cost_min": "27.71",
    "categories": [
      "rts.watches"
    ]
  },
  {
    "id": "bd8f7ff3-65ba-4f87-94c7-f8e73b7c45a4",
    "name": "Japan School Sweater Spring Autumn V-Neck Cotton Knitted Sweater College Style JK Uniform Cardigan 5 Color Student Girls Cosplay",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/26/fc/26fc1f45e3cce399b8573950326072bc.jpg",
    "cost_min": "27.01",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "686e714a-0aa7-46e4-b690-ab92190b6c9f",
    "name": "For Growth Chair Dining Plate Babies Feeding Chair Dining Table Plate ABS High Seat Tray Children Dining Chair Accessories",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/01/65/0165b582fb358137cf80dc2c553cc441.jpg",
    "cost_min": "2.82",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "86ab32cc-7013-4e5f-ab3f-d6ef7055c693",
    "name": "Men 100% Silk Pocket Square Print Real Satin Small Square Scarf Gentleman Business Suit Shirt Chest Scarf Handkerchief 30*30 Cm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/65/77/6577d22071e395d6489fe141bcbbad3a.jpg",
    "cost_min": "8.83",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "7ea9995f-8e35-4d87-b928-c6dbf0829410",
    "name": "Korean Shirt Y2k Tops False Two-Piece Polo Collar Women's Blouse Spring Casual Streetwear Loose Female Pullovers Elegant Blouses",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b0/90/b09088e75242c5646562fd1290c15807.jpg",
    "cost_min": "7.39",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "66ec26c8-af6f-48bb-ab63-3f3d604324d0",
    "name": "Hexagonal Titanium Alloy Tactical Pen Multi-Functional Signature Writing Pen Emergency Window Breaker Student Office Stationery",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/11/6b/116b962006ad29da5954e26e61d91e7b.jpg",
    "cost_min": "2.81",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "33cd00a8-267f-4a3c-accc-d3942e77707e",
    "name": "Human Hair Dreadlocks Loc Extensions Kinky Straight Wholesale Crochet Braids  Remy Hair Extensions 10 20 40 60 Strands",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/7a/a2/7aa258640024079f0648942f08324f81.jpg",
    "cost_min": "23.59",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "922af608-3f0b-42df-868f-80a643aac604",
    "name": "New Mens Crew Neck Sweaters Long Sleeve Lightweight Knit Dress Pullover Sweaters Casual Outwear Twist Patterned Cable Sweaters",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1f/32/1f3209e8d60cab3e23aba912ed7dd6d8.jpg",
    "cost_min": "10.26",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "4a5f7940-c01c-420a-9e91-4c0cd25fa232",
    "name": "2Pcs Carbon Fiber Car Water Slot Non-Slip Cup Mat for Chevrolet Cruze Sonic Silverado Trax Camaro Captiva Equinox Trailblazer SS",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/d6/0e/d60e170f11fb6dd6038f07675819667e.jpg",
    "cost_min": "3.13",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "b111dbf9-e4f0-459b-b2f5-f4bfd8108f87",
    "name": "YNPO Solid Color EVA Platform Slippers Women Thick Sole Non Slip Beach Slides Sandals Lady Summer Soft Sole Wedge Heel Slipper",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/af/31/af312bc093078a9f25d049aa5634e53b.jpg",
    "cost_min": "7.07",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "e74d3025-e7ec-47b2-883c-a6a582b56bc6",
    "name": "Yellow Red Green Polyester African Dresses for Women Summer African Women O-Neck Short Sleeve Knee-Length Dress African Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/49/79/4979a3350cca6939532fb828ded980b1.jpg",
    "cost_min": "9.43",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "6b5b9b10-eac4-47aa-8f37-84333728fcc0",
    "name": "Faux Fur Coat Men Hooded Outerwear Comfortable Thick Winter Warm Long Jacket LED Stage Dance Party Cosplay Costume Overcoat",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e2/65/e265d87c5b9956c582e249b5bae666d6.jpg",
    "cost_min": "130.17",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "41247293-2514-4bc5-a1f0-e842c79638e2",
    "name": "Man Vest Sleeveless Top Men Tank Top Gym Shirt Bodybuilding Singlet Basketball T Shirt Streetwear Summer Outdoor Sports Y2k",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4e/b7/4eb762f3eda2ed89b7c9973ef29b486c.jpg",
    "cost_min": "20.80",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "cbf30f97-2eef-414a-a45a-bd825e70614b",
    "name": "Mens Duck Down Padded Pants High Waist Men's Winter Business Pants Warm White Duck Down Padded Trousers Male Black PT-406",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/37/e9/37e90a65d4b679d220533ce3e5e29649.jpg",
    "cost_min": "24.86",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "f8a96f2f-1d7f-4607-bde9-5629855920fd",
    "name": "Large M-5xl Cross Border Autumn/Winter Outdoor Single Layer Windproof Stormtrooper Hoodie Casual Stormtrooper Sport Jacket Mount",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/37/eb/37eb8d38962e7979ae367fa680c3644b.png",
    "cost_min": "20.69",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "15c9e976-e069-46c8-af77-cb258a5e3ca7",
    "name": "Handguard Universal for Duke 390 22MM Motorcycle Accessories Hand Guard Handle Bar Covers for KTM HONDA KAWASAKI YAMAHA SUZUKI",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ba/f9/baf90818c01f242cbd5500849bb1ba68.jpg",
    "cost_min": "27.62",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "dd16ba22-dba2-4911-b3ab-e08afe97fee5",
    "name": "New Cotton Women Winter Warm Short Puff Jacket Korean Design Irregular Cotton Coat Trend Loose Thicken Parkas Tide Black White",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0a/f9/0af9a2993684270d621cdf85012419bc.jpg",
    "cost_min": "32.82",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "6daed205-cca0-4939-9c3a-172f1c4a17b6",
    "name": "Chic Fluffy Women Fake Fur Jacket Lapel Collar Short Sleeve Lace Up Buckles Cardigan Tops Casual Warm Street Daily Winter Vests",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/61/47/6147e275122da18b5e04cfe15f365af7.jpg",
    "cost_min": "29.52",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "cdfacb4a-741b-4f68-8f6c-a3083864fdd1",
    "name": "Islamic Cothing Lady Arm Sleeves Women Cotton Cover UV Sun Protection Muslim Fashion Modal Base Soft Stretch Ice Sleeve",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/3a/f0/3af0418f03dffc2441955ccbb53039b5.jpg",
    "cost_min": "4.11",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "425f3745-9cbf-46b7-a904-a60a6985d321",
    "name": "For BMW X5 X6 E70 E71 E72 Dashboard Fan Volume Radar Button AC Vent Grille Rear Trunk Switch Start Stop Key Cover Replacement",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2e/d8/2ed8108bafac2b17b9c9b5ba8fcb83a1.jpg",
    "cost_min": "5.34",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "0f2aa685-8152-4279-a097-61022217e815",
    "name": "Christmas Lights LED Fairy String Curtain Lights 8 Mode Remote USB Festoon Christmas Decor for Home Holiday New Year Lamp",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/62/43/62438f27157f006c858e8d1ac0c72d56.jpg",
    "cost_min": "2.97",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "c2e788e8-450e-4568-9d81-ad240d0f7166",
    "name": "Spongebob Anime Disposable Tablewares Set Paper Cups and Cake Topper for Birthday Christmas Party Supplies Favors Gift Bag",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fc/38/fc3871f3387dac983840390ed664a645.jpg",
    "cost_min": "164.87",
    "categories": [
      "rts.toysHobbies"
    ]
  },
  {
    "id": "411c7476-b894-4a01-827f-8d76a4ab6131",
    "name": "Sterile Pasteur Pipette Plastic Straw Sterile LDPE Dropper Easy Tearing Individually Wrapped 1ml/2ml/3ml/5ml/10ml 100 / PK",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/db/c8/dbc87c81571270f0b54189f9bf62d551.jpg",
    "cost_min": "16.76",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "f3f19cbd-d451-410c-aa5d-e73a50d04911",
    "name": "2025 New Spring and Summer Basketball Shoes for Male Students, Versatile Couple Models, Shock-Absorbing Sports Shoes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c0/c0/c0c0a7e9b3a8acd8af0c0efd657a460f.jpg",
    "cost_min": "33.03",
    "categories": [
      "rts.sportsEntertainment"
    ]
  },
  {
    "id": "432bddbc-75b1-44b0-ab60-430a2b36096c",
    "name": "2025 Japanese Kimono Women Formal Dress Traditional Japanese Yukata Photo Photography Dress Party Dress Cosplay Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a5/9b/a59b624e38ac7d187679da3131aa6dbb.jpg",
    "cost_min": "9.02",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "e3ac8872-df1e-4051-8095-aaadb89b604d",
    "name": "Running T-Shirt Men Summer Ice Silk Thin Top Reflective Printing Quick Dry Short Sleeve Breathable Fitness Sports T-Shirt 5XL",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/fa/1c/fa1cf101c354644263da0610ada8fb1c.png",
    "cost_min": "5.83",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "1d13dee4-f146-465c-9b98-f05af8a4c39c",
    "name": "5M Christmas LED Curtain Icicle String Light Droop 0.4-0.6m LED Party Garden Stage Outdoor Waterproof Decorative Fairy Light",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/0d/66/0d6687fe6a396afffcfdcde54f62191e.jpg",
    "cost_min": "5.40",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "4257fd0a-844c-4172-b817-7a0518c7b04a",
    "name": "For Eufy X10 Pro Omni Replacement Parts Accessories Roller Side Brush Filter Mop Cloth Rags Pads Dust Bag Vacuum Cleaner Part",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/a5/93/a593ed693277f2fdf53813681f1278d6.png",
    "cost_min": "5.52",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "7ad3dd2f-6794-403c-90e1-2833385be722",
    "name": "LED Night Light Mini Folding Desk Lamp Cute Pet Lights Dog Deer Portable Night Light Student Living Room Decor Gift",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c4/f7/c4f7716cdf66020f74fea5f0873e825e.jpg",
    "cost_min": "2.19",
    "categories": []
  },
  {
    "id": "ae6aee45-c277-4657-8ddb-388ed2072a1f",
    "name": "Ultimate Silicone Gloves Waterproof Sunscreen Oil Resistant Anti Dryness Thick Soft Moisturizing Hand Kitchen Cleaning Household",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/86/20/8620e765a0edaab8a58ae4b56087e491.jpg",
    "cost_min": "6.44",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "9984d9ea-ade1-4915-b4e5-2d98722ee48c",
    "name": "Joyroom 3/2/1pcs HD Glass for iPhone 17 16 15 Pro Max Screen Protector Full Screen Tempered Glass Protection for iPhone 17 16 15",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/91/86/9186b8123707b3a210266c2e3a86e258.jpg",
    "cost_min": "4.34",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "bd6b85e1-e22c-49db-9adf-a55b0bc1014e",
    "name": "Muslim Caps for Men Clothing Skull Prayer Hat Flat Top Knitted Mesh Kufi Kippah Islamic Saudi Arabia Jewish Summer",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/1c/5d/1c5d665101e501a2c6d44320dd2fafa0.jpg",
    "cost_min": "19.22",
    "categories": [
      "rts.noveltySpecialUse"
    ]
  },
  {
    "id": "479835d8-aa27-437f-b433-aba64d8332ca",
    "name": "Korean Casual Sweet Fungus Lace Collar Women's Shirt Top Autumn New Women Fashion Fake Two-Piece Lace Up Long Sleeved Shirt",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/44/78/4478421aa39b23e153fa166208e16caa.jpg",
    "cost_min": "16.20",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "73e3eba1-afda-4484-a55c-e5c04e93691e",
    "name": "Lenovo New Wireless Lavalier Microphone Portable Audio Video Recording Mini Mic for iPhone Android Live Broadcast Gaming Phone",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2e/e7/2ee7506c25ed905d332d356ca9392341.jpg",
    "cost_min": "4.24",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "b4063780-745b-488b-bff4-2ed22a6b0691",
    "name": "3 Colors Plus Size Cotton Pregnant Shorts High Waist Pregnancy Briefs Adjustable Maternity Underwear Panties for Women Clothes",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ee/01/ee01fa8c6ecd6c1bce3086d71bf94c01.jpg",
    "cost_min": "4.15",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "59b0b113-6e9c-4eb8-a49c-c6a831300b48",
    "name": "12 Colors Cute Stamp Ink Oil-Based Crafts Stamps Inks for Rubber Stamps Fabric Scrapbook Wedding Decor Fingerprint Stamp",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/c7/6a/c76a611288e0ef32e82b0d9299fd2855.jpg",
    "cost_min": "2.54",
    "categories": [
      "rts.computerOffice"
    ]
  },
  {
    "id": "520206a9-7b49-41ce-b25d-c4ce674cd07f",
    "name": "Maden Vintage Mohair Scarf Winter Knitted Scarves Men & Women Warm Windproof Solid Color Simple Fashion Small Size Collar Scarf",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/53/5c/535c5e648c2bb6d3ab3fd4f5243db9ad.jpg",
    "cost_min": "12.94",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "d80b2f1a-86de-4fd4-baed-bd8cb501a03c",
    "name": "BeardGuru Rebel Beard Oil",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4b/05/4b058ef34fb46f97f01e500613644674.jpg",
    "cost_min": "13.79",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "9d955236-a19c-4cfd-ac08-a074c43b5896",
    "name": "BeardGuru AppleBlossom Beard Balm",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/94/1f/941f92de0dc4cfb0699c978b4931e3a3.jpg",
    "cost_min": "14.39",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "4af26b3c-5b2d-4c36-a782-1541715633ff",
    "name": "BeardGuru AppleBlossom Beard Oil",
    "staff_picks": [
      "bestseller",
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/22/71/22714f6fbde831c38be4df8fc108bc53.jpg",
    "cost_min": "13.79",
    "categories": [
      "rts.beautyHealth"
    ]
  },
  {
    "id": "0df2d2a3-628b-44db-82e3-18da4bb4e5da",
    "name": "Summer Luxury Polo Shirt Mens Polo Large T Shirts Stritching Shorts Sleeve Turn-Down Collar Business Tee Shirt Sweatwear 6XL",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/27/0b/270b1108f120be34870d6b40059af304.jpg",
    "cost_min": "10.07",
    "categories": [
      "rts.mensFashion"
    ]
  },
  {
    "id": "e8dc463c-acf2-4427-bcb0-7e93a27362e5",
    "name": "1-10m Ultra-Strong Double-Sided Adhesive Nano Tape Clear Removable Waterproof Extra Strong Sticky Strip Heavy-Duty Two Side Tape",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/ca/10/ca10b47b05b3c1814de776dea276bab4.jpg",
    "cost_min": "2.52",
    "categories": [
      "rts.homeGarden"
    ]
  },
  {
    "id": "9b41615c-c66e-4e34-9e5a-920586645443",
    "name": "HUB Sports Jdm Style Boss Kit 6-Bolt Hole Steering Wheel Hub Adapter for Mitsubishi Honda Toyota ISUZU Subaru Proton Acura Etc.",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/e1/b0/e1b0aa6fb183c14f4ce00f322e3a3711.jpg",
    "cost_min": "216.72",
    "categories": [
      "rts.automobilesMotorcycles"
    ]
  },
  {
    "id": "e48f0139-f6dc-48b6-bace-5d67bc710c97",
    "name": "Baby Shoes Knitted Infant Child Bed Footwear 0-12m Cute Turn-Down Breathable Newborn Boys Girls Walk Boots Fashion Solid Bandage",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/4a/bd/4abda2e5d5f9860ef115112ced0bb878.jpg",
    "cost_min": "6.39",
    "categories": [
      "rts.kidsBabies"
    ]
  },
  {
    "id": "4e786397-d53f-4389-bb3e-5ce39930a4c0",
    "name": "Casual Sexy Basic Solid Flare Pants Y2K Slim Low-Waisted Boot Cut Pants Women 2024 Autumn Spring Fashion Streetwear Lady",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/12/12/1212cd5b45f38f49544ec2b61880b1cb.jpg",
    "cost_min": "10.41",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "82c786a5-c2fc-4475-801e-3245bbe0f27d",
    "name": "Casual Sexy Basic Solid Flare Pants Y2K Slim Low-Waisted Boot Cut Pants Women 2024 Autumn Spring Fashion Streetwear Lady",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/2f/74/2f7428fbdb62d37478e1b4d1afeb6e13.jpg",
    "cost_min": "10.85",
    "categories": [
      "rts.womensFashion"
    ]
  },
  {
    "id": "8c664f8b-e1bb-4aba-8811-75ef856014b0",
    "name": "3Pcs Tempered Glass for iPhone 14 13 12 11 15 Pro Max Mini Screen Protector for iPhone 17 XR XS MAX 7 8 Plus 16 Protective Glass",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/b0/84/b0840d3ae29c5d17a8fe19d9cf5d84c3.jpg",
    "cost_min": "2.34",
    "categories": [
      "rts.cellphonesTelecommunications"
    ]
  },
  {
    "id": "547fad21-f0f0-46b4-bbc0-862f629ead5c",
    "name": "Ballantine's Bottle Glass Platter",
    "staff_picks": [
      "category_pick"
    ],
    "image": "https://media.modalyst.co/cache/99/ef/99ef39ebf7cfc0779eccd9ad441e5656.webp",
    "cost_min": "10.85",
    "categories": [
      "rts.homeGarden"
    ]
  }
];

export const PRODUCTS_BY_CATEGORY = {
  'rts.beautyHealth': [
    {
      id: '4af26b3c-5b2d-4c36-a782-1541715633ff',
      name: 'BeardGuru AppleBlossom Beard Oil',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/22/71/22714f6fbde831c38be4df8fc108bc53.jpg',
      cost_min: '13.79',
    },
    {
      id: '5ab6aad8-e7dc-40f7-a99f-b2cd2db9e691',
      name: 'Aftershave Serum Bundle (5-Pack)',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/75/5a/755ac8daf3f7c261fdd549fe9b282039.jpg',
      cost_min: '41.39',
    },
    {
      id: '58e0a5b7-71f2-4908-9e4e-cc5bcd964396',
      name: 'Oatmeal & Goat Milk Handmade Soap',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c3/14/c314843234dae3c8c11baa044c2eea86.png',
      cost_min: '2.70',
    },
    {
      id: '882e36f7-fba7-40ee-8d84-ee77dea101b4',
      name: 'Mineral (Baking Soda-Free) Deodorant',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/44/e3/44e397a90383cbde9e4a2b921d085e18.jpg',
      cost_min: '5.99',
    },
    {
      id: '1894e343-d747-4bbb-9137-0097029a9db7',
      name: 'Grapefruit Splash- Grapefruit Scented Handmade Soap',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/3e/7c/3e7c70dccb4c2176fb393aedb3d126cc.png',
      cost_min: '2.70',
    },
    {
      id: 'e7f59821-341d-416e-9cb9-0ef9c5882020',
      name: 'Cheek Flush (Talc-Free)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/7e/a7/7ea737f372a54f8fa91509e1f14b9c54.jpg',
      cost_min: '7.20',
    },
    {
      id: 'a87ef190-04c8-441f-81a5-72db992782ee',
      name: 'Lustrao Hair Regrowth Oil',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d9/75/d97589d65dbaa2c26fe8eed09a68b8ef.png',
      cost_min: '16.19',
    },
    {
      id: '3afce4e2-58a8-4257-9213-93eeca4837eb',
      name: 'Vitamin C Repairing Oil',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8b/a3/8ba372e4e69df9d0ec2c2b625ce2b459.png',
      cost_min: '11.99',
    },
    {
      id: '5b0f5b73-356b-4c20-bd40-aa6c6309286c',
      name: 'Face Mask',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c7/19/c719fa980a650bbc3427f2523626cff2.png',
      cost_min: '11.99',
    },
    {
      id: '373157b3-b693-4c6c-a4de-65507f408992',
      name: 'Advanced Skin Regimen Kit (5-Piece Set)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/91/6a/916a07ecff5156b149363b1dc0782ca1.jpg',
      cost_min: '35.39',
    },
    {
      id: '4709560d-c7c7-4817-9b3a-df444e5b57c9',
      name: 'Salt Scrub (Multiple Sizes)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c9/b9/c9b970858a7899ceab5946303fd8fb55.jpg',
      cost_min: '10.19',
    },
    {
      id: '07ebb848-f56b-4a21-b1f0-0cacd16ef325',
      name: 'Essentials Skin Regimen Kit (4-Piece Set)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/45/8d/458d2342f5794d1dca90021667a6369c.png',
      cost_min: '23.99',
    },
    {
      id: '5dfd173b-a36e-41dc-8adc-21156f043dfe',
      name: 'Hair Serum',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ad/97/ad97d6bc0a7078ccbe3527dd7c86a24a.png',
      cost_min: '16.79',
    },
    {
      id: '3c2776d6-cdae-4ef1-8125-0aaeeb0d6175',
      name: 'Shave Brush',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/1c/01/1c0120f047bebeb5fcc08ddecac05a8d.jpg',
      cost_min: '6.59',
    },
    {
      id: '88b4441e-04e4-4f4a-a3cd-e808e66dfcf3',
      name: 'Natural Loofah Pad 2-Pack',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8e/45/8e45b5ab3ecdea1f23b56a152e7dcb7d.png',
      cost_min: '5.99',
    },
    {
      id: 'dcc37698-e1bb-49e2-bcbc-4c8e55d06a05',
      name: 'Eucalyptus Radiata  Pure Essential OIl-15ml',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a1/f7/a1f74232576c950f04165ef8ef7cff14.jpg',
      cost_min: '8.40',
    },
    {
      id: 'd80b2f1a-86de-4fd4-baed-bd8cb501a03c',
      name: 'Rebel Beard Oil',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4b/05/4b058ef34fb46f97f01e500613644674.jpg',
      cost_min: '13.79',
    },
    {
      id: '9d955236-a19c-4cfd-ac08-a074c43b5896',
      name: 'BeardGuru AppleBlossom Beard Balm',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/94/1f/941f92de0dc4cfb0699c978b4931e3a3.jpg',
      cost_min: '14.39',
    },
    {
      id: '47c563f1-1649-43e4-8209-388a4e878f4b',
      name: 'Turmeric & Honey Handmade Soap',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/06/f2/06f2eb92ed5a233e687387681c7c3598.png',
      cost_min: '2.70',
    },
    {
      id: 'd44c6cc7-ae76-478b-8f37-27a57903563d',
      name: 'Bamboo Charcoal Detox Handmade Soap Bar',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/94/b3/94b3329c1f9e960e9d98a9a7a80c5cb6.png',
      cost_min: '2.70',
    },
  ],
  'rts.mensFashion': [
    {
      id: 'd5542416-c060-48ec-a7f2-2c6e412840a0',
      name: 'Linen Mens Shorts Newest Summer Casual Shorts Men Cotton Fashion Men Short Bermuda Beach Short Plus Size 4XL Joggers Male Hot',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/d5/83/d583a692876e12efa964fb951d446f30.jpg',
      cost_min: '15.69',
    },
    {
      id: '09f49cca-244f-4d4d-b880-26292aedab4c',
      name: 'The Endless Summer 1966 Surf Documentary T-Shirt',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/53/45/534592c59fe11ec07698865f27f5abf4.png',
      cost_min: '13.17',
    },
    {
      id: '90b66014-5f49-4d7d-bd4c-e4617ac072fd',
      name: "Men's High Arch Firm Support All-In-One Black Walking Shoes, Comfort & Performance Style",
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/6e/b0/6eb0a344dfdcad4cffae45226ec4d7c0.jpg',
      cost_min: '30.00',
    },
    {
      id: 'ccd94d9f-726e-4f8e-9db2-c65e4f928281',
      name: "ZIMEGO Men's 3/4 Sleeve Black & White Baseball Henley – Casual Athletic Button Crewneck Shirts",
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/cc/f2/ccf2337d74b11006ec8aee3ed5101287.jpg',
      cost_min: '15.00',
    },
    {
      id: 'ff80574e-72b9-4f93-a8eb-50f70874525b',
      name: 'Inverness - Walnut & Black Leather',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/fe/e8/fee8681753894fcad31b5e255e690c51.jpg',
      cost_min: '26.97',
    },
    {
      id: '03e35462-f6f3-4424-9774-ec87b38efe1f',
      name: 'Pablo Picasso Dove of Peace 1949 Artwork T-Shirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/44/62/4462e475e8e6507bd7d6a283d317cef5.png',
      cost_min: '13.17',
    },
    {
      id: 'ed380a08-3c99-4c8a-9889-bab6ca04bee9',
      name: "Andy Warhol's Banana, 1967 Pop Art T-Shirt",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4f/bf/4fbf4ff745af583a481ec3bb6b134555.png',
      cost_min: '13.17',
    },
    {
      id: '9d9c434d-5517-4a7e-b1ac-0cd080c654b8',
      name: 'MTR-8748 Navy',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/64/6f/646fc0a0cf007dbbc6c21049f703fbb3.jpg',
      cost_min: '18.62',
    },
    {
      id: '4b0e72ab-22e3-4aed-9db5-32f6842b5686',
      name: 'Banksy Anarchist Punk and His Mother Artwork T-Shirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/2d/78/2d78f602d3bf42cf432bbf6f0365fdb5.png',
      cost_min: '13.17',
    },
    {
      id: '787a7508-de25-49ea-b5c7-079ccbb1c973',
      name: "Save Ferris From Ferris Bueller's Day Off T-Shirt",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d9/c6/d9c6875248c9535c3c4fe240d5df6fec.png',
      cost_min: '13.17',
    },
    {
      id: '61122b8b-a0af-4a5b-aeb1-854effc54f7d',
      name: 'Amity Island Surf Shop, Jaws T-Shirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/76/cb/76cb0f1f7fdaaaa8a68d9b7c8d982bd0.png',
      cost_min: '13.17',
    },
    {
      id: 'f9f08587-5ce6-4bd8-b864-06c146fa5316',
      name: 'Find Your Coast® Heritage Sunset Explorer Hoodie',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/1c/7f/1c7ffad5c2d10a28880a1b1fad0e618d.png',
      cost_min: '47.40',
    },
    {
      id: '89d862ee-8fda-4857-a0cb-affb8d5cd383',
      name: '100% Cotton Short Sleeve Fucus Printed Tshirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/2e/cc/2eccc8d6dce42a1da1aeaa2b3d07a2aa.jpg',
      cost_min: '20.39',
    },
    {
      id: '8531a862-53ba-4909-a31b-21c82815e9f8',
      name: 'HATLANDER Camouflage Snapback Polyester Cap Blank Flat Camo Baseball Cap With No Embroidery Mens Cap and Hat for Men And',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ec/1e/ec1ec3a2403fdd3ffe27ad9149fbb02a.jpg',
      cost_min: '31.56',
    },
    {
      id: 'c186d667-fefb-4b78-9939-f36f375544b2',
      name: 'Luxury Boots BYMANYC® HUDSON STROLL',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a2/61/a2613d8f6e3279c242af8af4febea7c8.png',
      cost_min: '150.00',
    },
    {
      id: '8b9cbf8c-e025-4d7b-a543-12b9e45d2acc',
      name: 'Eco-Friendly Sneakers Sport BYMANYC® New York BROOKLYN BLISS',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/93/ab/93abd877eab80131129e24aaccea96de.png',
      cost_min: '165.00',
    },
    {
      id: 'a764574d-cce4-4bd9-bb2b-9ab359f0bd3d',
      name: "65 McMlxv Men's Khaki Chino Pant",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/e3/0b/e30b0b04eee7d7c78cffcaa650777895.jpg',
      cost_min: '19.20',
    },
    {
      id: 'd7b8a0e4-3574-4ff8-b3a8-d9913b1ea6b6',
      name: 'Durable Polyester Cotton Cargo Pants for Work With Knee-Reinforcing Protection,Multi-Pockets, Comfort Fit for Constructi',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/5d/8e/5d8e240490e015cf1a16b1d9a8564d3a.jpg',
      cost_min: '35.77',
    },
    {
      id: 'e51eb92c-ea8c-46a4-ac70-24348f6948ca',
      name: 'Multifunctional Cargo Shirt [B229]',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/bb/f1/bbf1ab3d91f7971e6e179d088408b205.png',
      cost_min: '25.05',
    },
    {
      id: '1c7e0c32-8226-4f5c-b458-a4b263e5be51',
      name: 'Unityth - Geometric Retro Round Vintage Fashion Aviator Sunglasses',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/2f/9b/2f9b36ce283a32a98f00e8533e462d41.jpg',
      cost_min: '14.00',
    },
  ],
  'rts.jewelryAccessories': [
    {
      id: '7905e13b-804b-4b92-baf6-df87fd285af6',
      name: 'Silver Mountain Necklace',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/de/71/de71c5bc14b8c97d348d0d5871fc315b.jpg',
      cost_min: '23.40',
    },
    {
      id: '8b50eee8-5d7f-417c-b1d3-9e5e8b79a7cb',
      name: 'The Feather Ring',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/e3/7c/e37ca83b175bb403410346b14a375741.jpg',
      cost_min: '17.99',
    },
    {
      id: 'cd2d7cd9-a633-4006-9509-25ecb3037e55',
      name: 'Mye1038 - Fan Shape Drop Hoop Earrings',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d6/41/d641f81c91e1221ec79afcf8ac685047.jpg',
      cost_min: '4.95',
    },
    {
      id: '721b545d-ba3a-49c3-801f-20fed1fc49c1',
      name: 'Geometric Open Circle Ring',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/49/49/49499b0d0696860a0e2fa0c4302df474.jpg',
      cost_min: '36.00',
    },
    {
      id: 'b1907ac1-d1b7-4d5d-8f52-f54b1014f71b',
      name: 'Twist Cross Floral Elastic Knotted Headband',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d4/46/d4469c82c00462ff092078a1b0450ed7.jpg',
      cost_min: '13.02',
    },
    {
      id: 'db56d4d3-5f9b-4804-8470-2cb0c284a25b',
      name: 'Mama Bear and Cub Necklace',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/17/3d/173dd3d88a369cbb9d653c54218cd42c.jpg',
      cost_min: '23.40',
    },
    {
      id: 'f776f1d3-0a36-4626-8864-ccbeab7a6f4b',
      name: 'Crystal Bubble Initial Necklace',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f5/f9/f5f92cd8ff4805951ca9aa0ae8f57598.jpg',
      cost_min: '14.25',
    },
    {
      id: 'a9c507bc-5d83-4acd-a90f-db2c534b571d',
      name: 'Personalized Gold Bangle - Kids Name & Date Bracelet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a0/c3/a0c38b6bdf1922d8eda171b0c61072cd.jpg',
      cost_min: '15.00',
    },
    {
      id: '746d88d7-055b-40bb-844e-2a5d8a4fefd9',
      name: 'Union - Black Silk Stone Gemstone Beaded Bracelet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/72/eb/72eb7febb3fc83ad8e2b11ebf70e9e12.jpg',
      cost_min: '16.77',
    },
    {
      id: '847a79f0-43d6-4b14-9c48-714d065f73c2',
      name: 'Real Carbon Fiber Ring | Black | Slate Series',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4d/95/4d959b626586a22ebee582b4c8fd8aec.jpg',
      cost_min: '12.99',
    },
    {
      id: '7f8f7c10-8ca4-4503-8c03-ac1a5ffa9754',
      name: 'Irregular Design Opal Pearl Necklace',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/9c/dc/9cdc22ca5c9be3d0fa0c5b9704df75e8.jpg',
      cost_min: '48.00',
    },
    {
      id: 'dbb11068-851f-4295-a2b0-98c131b9d7d8',
      name: 'Freshwater Pearl Half Gold Bangle Bracelet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fa/4e/fa4e76f9acc113ddd90af974973354d3.jpg',
      cost_min: '52.00',
    },
    {
      id: '5af780d8-f505-4d91-9ee0-d3500da1a442',
      name: 'Freshwater Pearl and Pink Zircon Necklace',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8f/cd/8fcddae11a0e3e935e42061bd1c65120.jpg',
      cost_min: '54.40',
    },
    {
      id: '46f4ba92-d025-47b8-8641-3ab795d7751e',
      name: 'Initial Edge Square Seamless Clip Charm',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/0d/24/0d246cabc81f804ea545158889d9a9c8.jpg',
      cost_min: '8.25',
    },
    {
      id: '0e1de5f9-6b49-48ee-8861-f59995974a64',
      name: 'Grove - White Howlite & Blackwood',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/0f/1d/0f1d85ee0596e935f295540500842525.jpg',
      cost_min: '11.37',
    },
    {
      id: 'f7ce3d68-81bb-476f-870c-00747d54636f',
      name: 'Dani Glitter Bands',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/91/db/91db9e9e36258e5fa2fa3ee610293fb3.jpg',
      cost_min: '16.20',
    },
    {
      id: '3d319984-d915-4f3b-a1da-7fed4af3ce62',
      name: 'Silk Wreath Hoop Earrings',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/3e/4b/3e4b61e0ca191386e36a32c5c49cd61f.jpg',
      cost_min: '36.00',
    },
    {
      id: '28eb007d-1e1b-489d-80af-c300a94fc608',
      name: 'Marquise Ear Climbers',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c2/62/c2628c09ae1a164557ee57e74f632aa1.jpg',
      cost_min: '22.80',
    },
    {
      id: '228b6c3b-9991-4e33-ad06-48d04b8d9c8f',
      name: 'Personalized Initial Necklace - Sterling Silver',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f3/cf/f3cfd13e132f65d43b3cbb0c3c76de9c.jpg',
      cost_min: '21.00',
    },
    {
      id: '02c342fa-5dda-4235-909c-040227413962',
      name: 'Raw Natural Crystals | 24 Karats Pendant Necklaces',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/64/e8/64e826995a15c86a4c0c14dbe0d140d5.webp',
      cost_min: '22.19',
    },
  ],
  'rts.consumerElectronics': [
    {
      id: 'a4a09dc7-3185-40a3-8355-e74310716f40',
      name: 'BSport – Bluetooth Sport Headphones With Dual-Microphone and NFC',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d4/f5/d4f57b382de4b1cef32c5b030a498753.jpg',
      cost_min: '11.99',
    },
    {
      id: '231ca3d0-580b-4e17-91b6-b3852155a769',
      name: 'Beeing - The Cutting-Edge True Wireless Earbuds With Qi-Enabled Wireless Charging Case',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/10/5a/105ad37d58c1c34f5ea76f968557233e.jpg',
      cost_min: '35.99',
    },
    {
      id: '91a41875-a653-4ce8-9dda-d5df605b5a10',
      name: 'Tesla Fridge 193Wh Portable Power Station',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4b/ab/4babc0a9d32adadc5ab3db4a064350d4.jpg',
      cost_min: '159.60',
    },
    {
      id: '735510f2-09da-4f77-aae8-95480dad199f',
      name: 'VR Shinecon 10.0 Helmet 3D Glasses Virtual Reality Casque for Smartphone Smart Phone Goggles Headset Viar Video Game Binoculars',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/15/f6/15f690e37d4601a4efaea29c5634831e.jpg',
      cost_min: '31.36',
    },
    {
      id: '26c02774-4a8d-43b0-b2bb-afe8332af0c5',
      name: 'NA9 1080P HD Wifi Mini Wireless Surveillance Camera IR Infrared Night Vision Motion Detection IP Camera Home Security Sm',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f9/14/f914c56788edf324c0c844035455ce1d.jpg',
      cost_min: '46.05',
    },
    {
      id: 'db25145c-f76a-4474-a382-56804f9e7014',
      name: 'SabertoothPro VC550 AutoPod Phone-Tablet Mount',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/69/86/69866129829db1b5cd0f6a1325d74ef8.png',
      cost_min: '23.99',
    },
    {
      id: 'dc8ad7ea-403d-42e0-a63a-d2e3c9646258',
      name: 'Sabertooth VLT350 Smart Voice Language Translator',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ec/38/ec3859edeb509c88270ac3b693aeab2f.png',
      cost_min: '38.99',
    },
    {
      id: 'ec4e1fab-f3ad-45a0-ad37-c5538e5998c7',
      name: 'TriVox - Triangle Bluetooth Wireless Portable Speaker',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f3/69/f369a22517c451447de915c10587ffc0.png',
      cost_min: '17.99',
    },
    {
      id: '99f79c33-d371-46e4-b36c-3269ff6c0774',
      name: 'ACOPower 240W Foldable Solar Panel With ProteusX 20A Charge Controller',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/2d/d8/2dd8bb8a375ed02c5dd42199d661fcee.jpg',
      cost_min: '461.16',
    },
    {
      id: 'c81a13b3-af41-4092-889a-61e705feeb94',
      name: 'SERENITY Wireless Sleep Mask Headphones Bluetooth 5.0 [Free Shipping]',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f8/f2/f8f2d7e724bbff3845f554a141e22718.png',
      cost_min: '23.99',
    },
    {
      id: '737ac684-b712-4141-b888-701743f53072',
      name: 'Macaron Earbuds - Light Green',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/07/2d/072dd7a2d4a455af60fe70524dab92f7.jpg',
      cost_min: '14.95',
    },
    {
      id: '8e091267-d9a7-4691-b9c1-ee35ab1c4158',
      name: 'WHALE With Nylon Strap – Bluetooth IPX7 Waterproof Portable Outdoor Speaker With 30W Stereo Sound and USB Charge Out',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8e/58/8e58ce2b318069e76b51a7b62b794270.png',
      cost_min: '41.99',
    },
    {
      id: '3cd78cb0-f77d-4d7e-8035-8377d4408a72',
      name: 'Macaron Earbuds - Light Blue',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/33/d6/33d6fca382cb800fb504eb381a904fe7.jpg',
      cost_min: '14.95',
    },
  ],
  'rts.homeGarden': [
    {
      id: 'a4894d21-3467-4483-9a50-26825f1c9653',
      name: 'Kanye West Albums Minimal',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/e3/60/e360313194ba7fda5c17dbdee6e8c9a6.jpg',
      cost_min: '10.20',
    },
    {
      id: '080004d2-e3c2-4f9a-b725-0b34c4ee0e68',
      name: 'Grade a Amethyst Druzy Crystals',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/ef/5e/ef5e07515e3c9ebecf569a503c19728b.jpg',
      cost_min: '4.80',
    },
    {
      id: '53e942d7-de81-4e46-843a-bd1ba42a8e4f',
      name: 'Vintage Flower Tropical Leaves Cushion Cover',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/9d/c2/9dc22ebe47f71dfd4adfa778701f4d1a.jpg',
      cost_min: '13.92',
    },
    {
      id: 'f20c9c64-d8d2-4b66-a644-2f21061b9947',
      name: 'Blushing Rosé Gemstone Diffuser',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/82/a7/82a7b6c1d47141739e547778c30d10c8.jpg',
      cost_min: '39.60',
    },
    {
      id: '5ccd90de-8bf8-49de-ba98-dc5cf6cd6f83',
      name: 'Relax Sequin Cushion Cover',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d2/cf/d2cf55931176df5b674b8c2476a71623.png',
      cost_min: '13.19',
    },
    {
      id: '87c464d0-8deb-47fe-bd52-1810f74a6614',
      name: 'Sultan Peshkir Turkish Towels',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d3/73/d3730df81c7f8290c70860222b45c155.png',
      cost_min: '7.79',
    },
    {
      id: '8c856ae0-ccd2-429b-adaf-538af3f9fe6a',
      name: 'Laundry Detergent Strips',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/cb/e4/cbe4a9764d8e20f98ff02e4627099404.jpg',
      cost_min: '12.27',
    },
    {
      id: '5b6e8fdc-519c-4f62-9f0e-3d352dc45c74',
      name: 'Convoy S2+ Black  XML2 U2-1a AMC7135*3  2-Group 3/5-Mode EDC LED Flashlight',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/10/4a/104ab27773e022ff79d62bf22975a911.jpg',
      cost_min: '13.71',
    },
    {
      id: '4a1199b5-ea43-4d60-8ef4-095233cf6fed',
      name: 'Rose Gold Crystal Elixir Water Bottle With Tea Infuser 500ML',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f5/03/f5039e3234e3374157185d52fedae2eb.png',
      cost_min: '21.59',
    },
    {
      id: '9950588e-2c3a-4c92-89f4-76b7c7cc964d',
      name: 'Dish Soap Block',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ce/48/ce48263bcff9a2c3cad47c45eb79bfbb.jpg',
      cost_min: '8.39',
    },
    {
      id: '9df6e5c5-686a-4a12-9b0e-718773a0d6f1',
      name: 'Natural Handcrafted Grey Himalayan Salt Lamp 1.5-5kg',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/5f/c9/5fc9ff92bdef9d14b7cd9d781663bd20.png',
      cost_min: '16.79',
    },
    {
      id: 'a0951ae3-ca8e-4bfc-aad2-8444c15bdbdf',
      name: 'Geometric Cactus & Succulent Planter',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/05/5b/055b67233481c90c90446a0ece8b550d.jpg',
      cost_min: '36.00',
    },
    {
      id: 'c594c310-b664-4491-bc29-7ed7a6423a7a',
      name: 'Wooden Coasters - American Walnut / Set of 4 Coasters',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/80/f0/80f0e2497a9bffd0035dc376acdf202b.jpg',
      cost_min: '17.47',
    },
    {
      id: '0c0f5083-d281-46bf-a3e1-c0d9118446e9',
      name: 'ACOPower 30W Mono Solar Panel for 12 Volt Battery Charging',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f7/23/f723d14c01a9bc1c35b2b280d589394e.jpg',
      cost_min: '31.43',
    },
    {
      id: '55d0dc6a-7b1f-439e-9fb8-1427d8881b17',
      name: 'Blanket Wall Rack',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4e/5f/4e5f7b3d933b23722f6b7679df0902de.jpg',
      cost_min: '129.00',
    },
    {
      id: '08d13fdd-bfdd-4ffe-ae9d-e37e9575a24a',
      name: 'ORIA Digital Thermometer LCD Indoor Outdoor Thermometer Temperature Wireless Temperature Sensor Thermometer for Home Office Room',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/46/d4/46d42cf978dba4b8d20f0314f233652a.jpg',
      cost_min: '23.25',
    },
    {
      id: '75a7456b-e171-4a2d-9357-67e96ab6d4d8',
      name: 'Modern Feather Wooden Miniature Figurines',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/b3/93/b393c8467996d0dec2c24570ea69dfe0.jpg',
      cost_min: '16.27',
    },
    {
      id: '65e5d4f4-6b95-403f-981f-89c47df75998',
      name: 'Premium 100% Organic New Zealand Wool Dryer Balls',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c8/9c/c89cd885ea2fff25cfa76031b55e677d.png',
      cost_min: '14.40',
    },
    {
      id: 'bbed9e5a-4cde-4d55-aef7-8416748bf9ff',
      name: 'DaDa Bedding Soothing SeaFoam Sky Blue Cotton Fitted Bed Sheet W/Pillow Cases (JHW604)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/05/88/05885ada682460cd10e6f892bea64f00.jpg',
      cost_min: '19.50',
    },
    {
      id: 'cc0f08bd-5aba-4ad5-a5e7-f1c832452d58',
      name: "The Connoisseur's Set - Signature Glass Edition",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/7d/fd/7dfd88f4b8c919dfca6c68faaabd886d.png',
      cost_min: '38.49',
    },
  ],
  'rts.kidsBabies': [
    {
      id: '946a676d-c414-4c1b-bdbb-286b00ec8dae',
      name: 'Baby Onesie - Looks Like Mr. Tee',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/2e/4d/2e4d0863aae3001edd52d1fdc9c43eb1.png',
      cost_min: '21.60',
    },
    {
      id: 'b7358e4d-a609-4398-ae44-ba16f33ae812',
      name: 'Peter Pan Collar Dress',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/11/94/119465f3def0feb349bfdd7678c425af.jpg',
      cost_min: '14.40',
    },
    {
      id: '65ecd400-564f-4ae7-9bb0-8451f7972a19',
      name: 'Wall Stickers - Wooden Toys',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/9e/26/9e26115d2e8e4b0bd65dd3286fe033e5.jpg',
      cost_min: '23.40',
    },
    {
      id: '2f6422c7-14bd-415f-9f5e-bd6c4715b402',
      name: 'Monkey the Curtain Holder',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/0d/b5/0db57b11f02b705dbdb7de844147eaee.jpg',
      cost_min: '12.00',
    },
    {
      id: '74fed2e1-d156-4ca4-8406-86fb3a328794',
      name: 'Bambini Infant White Gown',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/83/35/8335734c543d354f8abc0f6505ef20df.jpg',
      cost_min: '4.19',
    },
    {
      id: 'dcdcfc28-7dcf-47cc-9ff9-bd4d12bcb6e8',
      name: 'Lammy Plush Rattle by Happy Horse',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/eb/13/eb134a9b3b19022fb7d7181f3400a7a9.jpg',
      cost_min: '9.60',
    },
    {
      id: 'b607c22d-f838-45f3-8348-b2188d2d448a',
      name: 'Bambini Receiving Blanket',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f5/5a/f55a0c99af947b0c37a0a8dc63aa7fbf.jpg',
      cost_min: '5.39',
    },
    {
      id: 'a2127943-2e82-44d1-91af-39401dd0abfd',
      name: "Bambini Girl's Printed Tank Top",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/59/57/595773526716c9e004f07e521faf6d30.jpg',
      cost_min: '6.59',
    },
    {
      id: '03a0a3c6-a153-440a-b979-8bab6bec3f1e',
      name: 'Baby Onesie - Mexican Dancing Dinosaur With Sombrero',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/cc/62/cc627e2df3055ab344cf64f3faa4f1b7.jpg',
      cost_min: '22.80',
    },
    {
      id: '786f88c2-90bb-4adf-884e-3619cb8f6650',
      name: 'Bambini Fleece Robe With Hoodie',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4a/d2/4ad22daecc2fe15954b8860a4395b7ad.jpg',
      cost_min: '5.99',
    },
    {
      id: '83a719db-fa62-44c0-9d6a-d21c55cc9913',
      name: 'A Wild Boy & a Wild Monster Infant Bodysuits Combo',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fd/53/fd53867e738e116f93834e8d7ee8e8bd.jpg',
      cost_min: '31.80',
    },
    {
      id: '35d35375-fd60-46c8-aea9-45b1a3eceab2',
      name: 'RBG - Infant Bodysuit - Gray',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c4/73/c473ee0deb7808397cb0d9429097e191.png',
      cost_min: '22.80',
    },
    {
      id: '09c46beb-4116-49a1-af55-81325a71ba17',
      name: 'Bamboo Rayon Alien Hooded Turkish Towel:Little Kid',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/66/af/66af6964a5daa910d25f4cc7c2dd6936.jpg',
      cost_min: '20.99',
    },
    {
      id: '050d1ed8-7650-4b28-929e-b0fa84eac788',
      name: 'Baby Mobile - Hot Air Balloon',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/06/f3/06f3bb0b2a4f2a0ff249e77d5ac3e226.jpg',
      cost_min: '16.80',
    },
    {
      id: '14df3ef7-4510-46c7-a3c7-4b9da7cabbf2',
      name: 'Are You My Mother? Bamboo Muslin Newcastle Blanket',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/05/df/05dffa1d414202b7c8934187d44e6ca2.jpg',
      cost_min: '16.50',
    },
    {
      id: '77dea216-151c-4a1c-b9b2-c680f5248b24',
      name: 'Ruffled Collar Bodysuit',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/57/32/5732921265c8ed1466ee59c09658990d.jpg',
      cost_min: '11.70',
    },
    {
      id: 'f9337801-a70a-4be5-9a7c-95213fecd623',
      name: 'Rainbow Cushion',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/6b/de/6bde72562053703544765c75996e7fef.jpg',
      cost_min: '16.20',
    },
    {
      id: '5bef2be7-88e8-4779-b7c0-026a79af1d9d',
      name: 'Indigo Forest Bamboo Newcastle Mini Kimono Jumpsuit',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/bd/5f/bd5f71d2e8cf613fd685b46643827ad9.jpg',
      cost_min: '12.00',
    },
    {
      id: '6ebd0a14-3212-4c04-8d69-c4b9a857c9d1',
      name: 'Double Croissant Sweatshirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/29/3d/293de841cc8a771f300062015923574f.jpg',
      cost_min: '26.23',
    },
    {
      id: 'b4e40b61-a4e5-4a29-9f50-eab51ec1544e',
      name: 'Indigo Forest Bamboo Newcastle Mini Pants',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/19/d0/19d0fa9bd2049f40dc842671bef75ab4.jpg',
      cost_min: '15.00',
    },
  ],
  'rts.sportsEntertainment': [
    {
      id: '9646987e-0cd8-4026-b01f-17dd3b25186b',
      name: 'Nation Auspicious Clouds Pickleball Paddle',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/19/dd/19dd8ce199d4b0b9d84728c6fc1f9d89.jpg',
      cost_min: '23.20',
    },
    {
      id: '8c05ce80-522a-4c70-a243-979ce94e7115',
      name: 'Ashton Sports Bra - Navy Blue',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/a4/0d/a40d722d9c090250e9071fbac216e939.jpg',
      cost_min: '9.70',
    },
    {
      id: '4897e990-b5e7-48d1-9f6d-b861122a8cfe',
      name: 'Pendleton X Yune Yoga Spider Rock Mat',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/99/a7/99a7d47549fe11d6196a37acb90ebd8d.jpg',
      cost_min: '39.00',
    },
    {
      id: 'f465eb28-2165-46c9-81ea-ade1b4c67e74',
      name: "Women's CoastFlex Turtle Bay Capri Leggings",
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/de/07/de075e54135e9f9da3679f25a392ffe3.png',
      cost_min: '36.00',
    },
    {
      id: 'ca0f74e7-e760-42c9-ac69-a13813f1d6b5',
      name: 'CoastFlex Sport Olivia II Leggings',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/9c/e5/9ce5034c3ff6ae9c2b14fc1c209e7661.png',
      cost_min: '48.00',
    },
    {
      id: '734a218e-a952-4444-8bc5-30629dec46b3',
      name: 'Vintage Lattice Pickleball Paddle',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d8/7b/d87bde021ff8b4c75fb079c400b5e533.jpg',
      cost_min: '23.20',
    },
    {
      id: 'f85302b6-2c51-418b-83dd-82939237362f',
      name: 'Push Up Board; Multi-Functional Detachable Push Up Bar; Home Workout Accessories',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/72/ea/72ea0d828aa40b6051549a850e7aafd1.jpg',
      cost_min: '25.19',
    },
    {
      id: 'f40058c3-161c-43c6-b6d4-fb05dc31e8e1',
      name: 'Professional Gym Adjustable Jump Rope - Black',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/9f/0a/9f0a52f1f3854146542463df8953256b.jpg',
      cost_min: '5.07',
    },
    {
      id: '99a92c83-f44c-412d-9dd8-a5434ad553ef',
      name: 'Santa Monica Leggings - Black',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f3/6e/f36ed08c8b977120746ed0aa0554fcd1.jpg',
      cost_min: '9.70',
    },
    {
      id: '7b23005d-7f4b-4ce8-98c6-ecbaeb4f45ad',
      name: 'Resistance Training & Ab Bundle',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d3/2a/d32aae40a1d8b8f0c8093e1c7562a69f.jpg',
      cost_min: '117.87',
    },
    {
      id: '438445ef-ec70-4ca6-99aa-a95386b64bb6',
      name: 'Yoga Strap Pendleton Canyonlands',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ed/a2/eda21302480e3508acbd28a9ae38c319.jpg',
      cost_min: '11.70',
    },
    {
      id: '652275e2-086f-4123-b361-77344da466f0',
      name: 'Pure Plant Protein Chocolate',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/1b/84/1b841d142a9c138ebd0a7560a72d6f2a.png',
      cost_min: '33.00',
    },
    {
      id: 'e9521abb-d739-4429-bb96-8954a5c1ea98',
      name: 'Pure Creatine',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/65/47/654765303e583c352ff24d30d5e4974c.png',
      cost_min: '33.00',
    },
    {
      id: 'ba303b99-aa66-42a0-8dba-3ee26f0ae58b',
      name: 'Yoga Towel Pendleton Fire Legend',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a8/7b/a87bfed0f59e88445662537ec8e4e8f2.jpg',
      cost_min: '29.70',
    },
    {
      id: '92068471-2bae-441c-8b75-b36988a3a840',
      name: 'OMSutra Studio Yoga Mat 6mm Deluxe',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/78/65/7865f5577559493658f0aa1079ed2418.jpg',
      cost_min: '31.84',
    },
    {
      id: 'cfc18d19-0f07-41b8-ba39-814a96dc2371',
      name: 'High Waisted Yoga Leggings - Navy Blue',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fd/3d/fd3da34eba9ca292446988fc8717f106.jpg',
      cost_min: '22.10',
    },
    {
      id: '6b718ef1-a8a1-46ee-8a74-486253e668e9',
      name: 'Trois Seamless Sports Jacket - Black With Navy',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ed/10/ed10f89a558b613f0827a4da7803fcf3.jpg',
      cost_min: '18.50',
    },
    {
      id: '509433d8-c2d6-4865-852a-1bcad268d68d',
      name: 'Topiom Water Rowing Machine (Dark)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/61/1f/611f29601a165e05e977c5a5e30d08dc.jpg',
      cost_min: '419.40',
    },
  ],
  'rts.womensFashion': [
    {
      id: 'a14e0d98-8e8c-47a0-99b5-28e4d99ba508',
      name: 'BARRINGTON | Slim Diamond Shape Fashion Sunglasses',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/8f/fb/8ffb58fa03c1b8a52b3d0f0ce3b82ba4.jpg',
      cost_min: '11.50',
    },
    {
      id: '0dfe0ce7-28b8-4bf4-9918-7e8d55424898',
      name: 'Annalise Womens Leather Jacket',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/08/5a/085a97b27b23522d76dec27145f9a72d.jpg',
      cost_min: '143.40',
    },
    {
      id: '5df93cfa-c7cc-40aa-86f3-66d5de976bda',
      name: 'Short Sleeve Knot Tunic',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/76/04/7604496e5eb81aea3955d46275eff106.jpg',
      cost_min: '20.99',
    },
    {
      id: '3de3631e-029b-4171-82d5-487fa50b8033',
      name: 'Turtleneck Model 199611 Badu',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/2e/6c/2e6c69dbc4fd2e3572ce1dcbf316abb5.jpg',
      cost_min: '19.90',
    },
    {
      id: '63f11225-8b92-4d14-bac8-576b50defffc',
      name: 'Flip-Flops Model 198287 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c6/ac/c6ac7b5b2481039ced1b6a60ba26cdf7.jpg',
      cost_min: '11.90',
    },
    {
      id: '0ee010c3-642f-45d4-8aec-52b3b72f7042',
      name: 'Cami With Lace Trim White and Fuchsia',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/22/6b/226b6fa41f62308b02612233a788991a.jpg',
      cost_min: '32.94',
    },
    {
      id: '93cd8c7a-c12c-4bc2-a8c3-de72cd6b365e',
      name: 'Denim Jacket With Star Embellishment in Midwash',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/5f/1b/5f1b1cfbfb6e6f4a158e16d6cd64ebcc.jpg',
      cost_min: '50.94',
    },
    {
      id: '7803470a-9267-41c2-8e1c-e38531023c67',
      name: 'Faux Fur Long Casual Coat',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/e1/e0/e1e01b0ed9ab2227ebd0b69ff0b1a389.jpg',
      cost_min: '69.48',
    },
    {
      id: '9fe7e77e-697a-437e-ac36-e72626b2428b',
      name: 'Find Your Coast® Palm Soul Open Shoulder A-Line Dress',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/47/47/47477bc0524fb88f4e8d0929c9e8818c.jpg',
      cost_min: '53.40',
    },
    {
      id: 'c8f6cb1a-062a-4088-8fc5-73887459b307',
      name: 'Underestimate Me Black Cat T-Shirt',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/7d/74/7d74aca6c08b7c95469009825a61d967.png',
      cost_min: '17.39',
    },
    {
      id: '294f43c3-cc7c-4493-8cbe-fa6d11d9e836',
      name: 'Touka Knitted Shrug Scarf - Black',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/e8/0f/e80f437861125afce3620da46f8ddae3.jpg',
      cost_min: '36.40',
    },
    {
      id: 'de11ef88-6fbc-436b-a841-019d4523c300',
      name: 'Daoko Pleated Puff Long Sleeve Shirt - White',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/dd/49/dd49bec2325063ef17479a82163733fb.jpg',
      cost_min: '46.20',
    },
    {
      id: '68d99667-3ae3-44be-9ff8-3b274fc3838e',
      name: 'Warmest Plush Insulated Cuff Knit Pom Women Winter Beanie Hat Warm Wool Insulated Cap Winter Beanie Hat',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/30/82/308289c2f7a0e41a18400ae3a64d8325.jpg',
      cost_min: '7.20',
    },
    {
      id: 'e88826af-f6af-4739-af2b-35852d1fc1c0',
      name: 'Gloriana - Women Circle Half Frame Oversize Rhinestone Fashion Round Sunglasses',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/8b/e1/8be118f5cb1dbd90d8e6e8c400ddd111.jpg',
      cost_min: '14.00',
    },
    {
      id: '8db44a75-9ebc-4613-ac47-03294869994c',
      name: 'Boho Deep V-Neck Sleeveless Maxi Dress',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/86/3c/863c64b0c6d6cc9b0fdbc30593f2cb05.jpg',
      cost_min: '46.14',
    },
    {
      id: '1ff6b821-827c-4889-aa2e-d4bdde3b6596',
      name: 'Rhinestone Stone Cap',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fd/fe/fdfe2f7fb9deb23ce986141eefec5e90.jpg',
      cost_min: '16.74',
    },
    {
      id: '9e70f6d9-1cf8-4c21-a979-5a99f933c7e1',
      name: 'Flip-Flops Model 194121 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/cc/00/cc008b785b2707e51e691d816441b942.jpg',
      cost_min: '23.90',
    },
    {
      id: '8fbdbf41-3a30-4acf-af35-e013893a0e8e',
      name: 'Snow Boots Model 202196 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/38/3c/383c712e9bdb874d5e740bd678fdbb1e.jpg',
      cost_min: '20.90',
    },
    {
      id: '3cc222d5-372a-44d7-8b16-968068abe966',
      name: 'Sport Shoes Model 198455 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/de/f3/def3526a154b4f4b2efc60227c660b5e.jpg',
      cost_min: '34.90',
    },
    {
      id: '23fd1e40-51e0-4534-87cf-9a8eda897d67',
      name: 'Slippers Model 191632 Step in Style',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/10/cc/10cc2ca84753ea2978b91311c31f35f3.jpg',
      cost_min: '21.90',
    },
  ],
  'rts.toysHobbies': [
    {
      id: '61b240a4-f57e-4481-b9ab-2b45b33db95f',
      name: 'Iimo 3-In-1 Foldable Tricycle With Canopy',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/30/a2/30a25aa3ba5e5be7626b796e69ab6b8a.jpg',
      cost_min: '196.00',
    },
    {
      id: 'dcba01b6-b316-4e4a-8e96-89e64b051894',
      name: 'Skillmatics Space Explorers - Teach Kids About Space - Write &amp; Wipe Educational Games for Children',
      staff_picks: ['bestseller', 'category_pick'],
      image: 'https://media.modalyst.co/cache/df/cc/dfcc808087e03f84cdfa46af002a5046.jpg',
      cost_min: '23.99',
    },
  ],
  'rts.bagsLuggage': [
    {
      id: '8f6f3f06-ec4f-4c42-8764-fd8bc02ffb48',
      name: 'Oversize Hobo Bag for Women Boho Purses and Handbags Fringe Big',
      staff_picks: ['category_pick', 'bestseller'],
      image: 'https://media.modalyst.co/cache/9a/2f/9a2f42db29a70c7b736e677fde690b7f.jpg',
      cost_min: '41.99',
    },
    {
      id: '3fbfcd8f-9447-43c5-9621-abaac14b6ddc',
      name: 'Causal Hobo Bag for Women Vegan Leather With Crossbody Long Strap in Tan, Blue, Grey, Black',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/50/15/5015c8c0e6f2f28de3091cc28f8a25ea.jpg',
      cost_min: '41.94',
    },
    {
      id: '648ae142-3aa6-4fed-b36e-2b41b57610c6',
      name: 'Backpack Purse for Women Utility Big Backpack Purse Vegan Leather Antique Tone',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c5/61/c5611df91f51624ed53abead15edf681.jpg',
      cost_min: '41.21',
    },
    {
      id: '59458e49-a3af-4314-80f2-8416812475f2',
      name: 'Luxury Alligator Leather Handbags',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/97/11/971154bcad85803be2016882a03d099f.jpg',
      cost_min: '56.89',
    },
    {
      id: '15b0d2f3-8d17-44bb-b202-bc7fa0e4395f',
      name: 'Luxury Leather Bucket Acrylic Handle Shoulder Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/69/b3/69b3a316fd84f46611dad33a13dec6d1.jpg',
      cost_min: '50.18',
    },
    {
      id: 'eeabf9f3-43bb-42b8-accd-dc85d4e7c293',
      name: 'Shoulder Cross Chain Strap Handbag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/15/86/1586fd0a63ed0740779716b693bb2a5d.jpg',
      cost_min: '43.46',
    },
    {
      id: '08e81f99-fb6f-4187-9027-079de6ef6b22',
      name: '005 - Leather Wallet With Detachable Wristlet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/72/7e/727e06fc3034a44473cf80ca1f5dfcd9.jpg',
      cost_min: '19.35',
    },
    {
      id: '796fbb3a-ba54-468e-a3e7-d2cc45709888',
      name: 'Hdg2000 - Double Zip Around Wallet',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/36/34/3634b96dc02565fe4b45976c975a9060.jpg',
      cost_min: '9.00',
    },
    {
      id: '5f442e24-8bd6-4c79-8591-479e05f4f872',
      name: 'Genuine Leather Bag for Female Bag Shoulder Bag Large Capacity With Contrast Color Pattern Tote',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/53/82/538241a8842a2be7e17d08991edbb649.jpg',
      cost_min: '64.90',
    },
    {
      id: '6a996cba-aed2-460d-be90-c6067599a444',
      name: 'Pyramid Shape Tassel Wristlet Leather Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c7/45/c7452abee4fafdcc00e240eaff6dfb75.jpg',
      cost_min: '26.10',
    },
    {
      id: 'cc5d0d07-315c-442d-88ba-486a2ef74fe9',
      name: 'Diamond Evening Clutch Bag for Women Wedding Golden Clutch Purse Chain Shoulder Bag Small Party Handbag With Metal Handl',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/63/a5/63a599de2f944d38704e71258eb397c7.jpg',
      cost_min: '66.60',
    },
    {
      id: 'dfed20fd-e60b-4fe5-8258-e14eb19ef5b1',
      name: 'Kate - Blue Vegan Basket Weave Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/76/e1/76e174cf3c259b381096b57fd47e7b96.jpg',
      cost_min: '100.80',
    },
    {
      id: 'acbee3af-72a0-439b-95d6-6e737c38d2c3',
      name: 'Kiwi Small Leather Backpack',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/a0/d1/a0d13cc2559871d8aa9450151afc5bfa.jpg',
      cost_min: '57.20',
    },
    {
      id: 'a897ce02-79ce-41c1-bacc-c06b716120e4',
      name: 'Leopard Printed Tote Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fa/9f/fa9f0c69c4a5527c253a5f1886de0de0.jpg',
      cost_min: '9.90',
    },
    {
      id: 'c513f898-8109-4961-8c0d-302b363442ca',
      name: 'Naomi - Yellow Vegan Leather Tote Bag',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/ea/d3/ead3a3ba8c936a18f54c77f3662fd55b.jpg',
      cost_min: '105.00',
    },
  ],
  'rts.cellphonesTelecommunications': [
    {
      id: '279320ab-b0e3-4ef0-947d-6455e4f8036d',
      name: 'Oak Wood Phone Case',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/aa/b4/aab4f65a46b5f5ceaa04f38c6c601615.jpg',
      cost_min: '22.38',
    },
    {
      id: 'c63bae53-9010-47bb-9ed7-2dc3669b8dbc',
      name: 'Wireless Charger With Organic and Wood Material',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/30/ae/30ae4ff6b7a1e5b61dfb2ea5148d6ed4.jpg',
      cost_min: '11.16',
    },
    {
      id: 'cc814da8-7eb5-4065-94c0-4902812aa3c7',
      name: 'iPhone | Real Aramid Fiber Case | GHOST Series',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/82/8c/828c4f8277dcdf3b5ef9d875feaac008.jpg',
      cost_min: '29.24',
    },
    {
      id: '11af8ec3-d669-4d6b-b2ca-c371f28272cb',
      name: 'Apple AirPods | Real Forged Carbon Fiber Case',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/86/62/866278369871b432f1a2b754b3f282d0.jpg',
      cost_min: '38.99',
    },
    {
      id: '8ff9dd7f-8fb2-444d-bf1d-4237945afd33',
      name: 'PowerGlow - Jabees PowerGlow 4-In-1 Foldable Wireless Charging Station With LED Night Light',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/c8/5b/c85bd804b7d2637b0eb42fb46d0994a0.png',
      cost_min: '17.99',
    },
    {
      id: 'e8cd2757-d9cc-4226-bd3d-889b615ba8c2',
      name: 'Portable Zoom Binoculars With FMC Lens Low Light Night Vision for Bird Watching Hunting Sports',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/43/74/437408d9259b7ce88fed5c75cb0336e5.jpg',
      cost_min: '48.70',
    },
    {
      id: '058c0341-6a02-415a-b17f-9be8d94a7d0f',
      name: 'HyperFuel 100W Back-Up Power Bank for Laptops and Other Devices (20,000mAh)',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/f2/7d/f27d364883e67082ef984a158536fec0.png',
      cost_min: '59.99',
    },
    {
      id: '21cf11c2-0bd5-466e-90fc-46f8dfb4a977',
      name: 'Real Carbon Fiber Key Holder & Organizer',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d4/75/d47582148dd9519f9931989c354d1e5f.jpg',
      cost_min: '27.29',
    },
  ],
  'rts.pets': [
    {
      id: 'd1e7b309-c796-49e8-83a7-9c813ea9e53f',
      name: 'Nylon LED Pet Dog Collar,Night Safety Flashing Glow in the Dark Dog Leash,Dogs Luminous Fluorescent Collars Pet Supplies',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/4a/0a/4a0a84ca4f29ac0cdb9109360f70abdf.jpg',
      cost_min: '0.34',
    },
    {
      id: '77dc18b3-eac8-406d-8964-39225e9ed08c',
      name: '4pcs Waterproof Winter Pet Dog Shoes Anti-Slip Snow Pet Boots Paw Protector Warm Reflective for Medium Large Dogs',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/91/31/913189cd8a51f174a4de8e9611fedfde.jpg',
      cost_min: '5.34',
    },
    {
      id: '377c054a-dac9-4b21-a534-0bd7b89566e8',
      name: 'Automatic Rolling Cat Ball Toy Smart Kitten Electric Toy Self Moving Dog Training Pet Kitten Interactive Toy for Indoor Playing',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/b4/70/b470f35f9a2561040618852f5a78a228.jpg',
      cost_min: '1.68',
    },
    {
      id: '33be9449-d92e-403d-a88a-a639927b69b6',
      name: 'Dog Clothes Hoodies the Dog Face Wind Coat Warm for Small Large Dogs Jacket Sweatshirt French Bulldog Jacket Clothing',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/b4/70/b470f35f9a2561040618852f5a78a228.jpg',
      cost_min: '3.38',
    },
    {
      id: '7a56800e-192c-43c3-82aa-e21e580e3a3f',
      name: 'Funny Simulated Animal No Stuffing Dog Toy With Squeakers Durable Stuffingless Plush Squeaky Dog Chew Toy Crinkle Pet Squeak Toy',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/d8/ed/d8ed26d30b518869f33127d0d7bfb874.jpg',
      cost_min: '3.38',
    },
    {
      id: 'b73f750f-95bd-48cf-a105-85efc27c2632',
      name: '50cm Soft Colorful Duck Plush Toy for Cats Dogs Relax Pet Companion Anxiety-Relieving Dog Buddy Energy Release Gift for Pets',
      staff_picks: ['category_pick'],
      image: 'https://media.modalyst.co/cache/fb/a2/fba23eb479ea2f471399d7828c0a5b75.jpg',
      cost_min: '3.38',
    },
  ],
};
